(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["articulo-blog"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var secciones = document.querySelectorAll('[data-articulo-blog]');
    if (!secciones.length) return;

    secciones.forEach(function (seccion) {
      var botonCopiar = seccion.querySelector('[data-articulo-blog-copiar]');
      var feedback = seccion.querySelector('[data-articulo-blog-feedback]');

      if (botonCopiar && feedback) {
        botonCopiar.addEventListener('click', function () {
          var url = botonCopiar.getAttribute('data-url');
          var textoCopiado = botonCopiar.getAttribute('data-texto-copiado') || '';

          if (!url || !navigator.clipboard) return;

          navigator.clipboard.writeText(url).then(function () {
            feedback.textContent = textoCopiado;
            feedback.hidden = false;
          });
        });
      }

      var formulario = seccion.querySelector('[data-articulo-blog-formulario]');
      if (!formulario) return;

      var boton = formulario.querySelector('[data-articulo-blog-boton]');
      var exito = formulario.querySelector('[data-articulo-blog-exito]');
      var error = formulario.querySelector('[data-articulo-blog-error]');

      if (exito) exito.focus();
      else if (error) error.focus();

      formulario.addEventListener('submit', function () {
        if (!boton) return;
        boton.disabled = true;
        boton.setAttribute('aria-busy', 'true');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aviso-cookies"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const aviso = document.querySelector('[data-aviso-cookies]');
    if (!aviso) return;

    const claveAlmacen = aviso.dataset.claveAlmacen || 'aviso-cookies-consentimiento';
    const retrasoMs = Number(aviso.dataset.retraso || 0);
    const diasValidez = Number(aviso.dataset.diasValidez || 0);
    const esEditor = aviso.dataset.editor === 'true';

    const botonAceptar = aviso.querySelector('[data-aviso-cookies-aceptar]');
    const botonRechazar = aviso.querySelector('[data-aviso-cookies-rechazar]');

    if (aviso.hidden) {
      aviso.setAttribute('inert', '');
    }

    function leerConsentimiento() {
      try {
        const datos = window.localStorage.getItem(claveAlmacen);
        if (!datos) return null;
        return JSON.parse(datos);
      } catch (error) {
        return null;
      }
    }

    function guardarConsentimiento(valor) {
      try {
        window.localStorage.setItem(
          claveAlmacen,
          JSON.stringify({
            valor,
            fecha: Date.now(),
          })
        );
      } catch (error) {
        /* almacenamiento no disponible */
      }
    }

    function consentimientoValido() {
      const datos = leerConsentimiento();
      if (!datos || !datos.valor) return false;
      if (!diasValidez || diasValidez <= 0) return true;
      const limiteMs = diasValidez * 86400000;
      return Date.now() - Number(datos.fecha || 0) < limiteMs;
    }

    function actualizarOffsetBanner() {
      if (!aviso.hasAttribute('data-visible')) {
        document.documentElement.style.removeProperty('--naia-cookie-banner-offset');
        document.documentElement.removeAttribute('data-naia-cookies-visibles');
        return;
      }
      const alto = aviso.getBoundingClientRect().height;
      if (alto > 0) {
        document.documentElement.style.setProperty('--naia-cookie-banner-offset', `${Math.ceil(alto)}px`);
        document.documentElement.setAttribute('data-naia-cookies-visibles', '');
      }
    }

    function mostrarAviso() {
      aviso.hidden = false;
      aviso.removeAttribute('inert');
      aviso.setAttribute('data-cookie-pendiente', '');
      document.dispatchEvent(new CustomEvent('aviso-cookies:visible'));
      requestAnimationFrame(() => {
        aviso.setAttribute('data-visible', '');
        actualizarOffsetBanner();
        if (botonAceptar && !document.querySelector('[data-popup-newsletter]:not([hidden])')) {
          try {
            botonAceptar.focus({ preventScroll: true });
          } catch (e) {
            botonAceptar.focus();
          }
        }
      });
    }

    function ocultarAviso() {
      aviso.removeAttribute('data-visible');
      aviso.removeAttribute('data-cookie-pendiente');
      aviso.setAttribute('inert', '');
      document.documentElement.style.removeProperty('--naia-cookie-banner-offset');
      window.setTimeout(() => {
        aviso.hidden = true;
      }, 320);
    }

    function aplicarConsentimientoShopify(aceptado) {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (!privacy || typeof privacy.setTrackingConsent !== 'function') return;

      privacy.setTrackingConsent(
        {
          analytics: !!aceptado,
          marketing: !!aceptado,
          preferences: true,
          saleOfData: false,
        },
        function () {}
      );
    }

    function resolver(valor) {
      const aceptado = valor === 'aceptado';
      guardarConsentimiento(valor);
      aplicarConsentimientoShopify(aceptado);
      ocultarAviso();
      document.dispatchEvent(
        new CustomEvent('aviso-cookies:actualizado', {
          detail: { valor, marketing: aceptado },
        })
      );
    }

    (function restaurarConsentimientoShopify() {
      const datos = leerConsentimiento();
      if (!datos || !datos.valor) return;
      aplicarConsentimientoShopify(datos.valor === 'aceptado');
    })();

    if (esEditor) {
      aviso.hidden = false;
      aviso.setAttribute('data-visible', '');
      return;
    }

    if (!consentimientoValido()) {
      aviso.setAttribute('data-cookie-pendiente', '');
    }

    window.addEventListener('resize', () => {
      if (aviso.hasAttribute('data-visible')) actualizarOffsetBanner();
    });

    function iniciarBanner() {
      if (consentimientoValido()) {
        aviso.hidden = true;
        aviso.setAttribute('inert', '');
        return;
      }
      aviso.hidden = false;
      window.setTimeout(mostrarAviso, Math.max(0, retrasoMs));
    }

    let bannerIniciado = false;
    function iniciarBannerUnaVez() {
      if (bannerIniciado) return;
      bannerIniciado = true;
      iniciarBanner();
    }

    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking', version: '0.1' }],
        function (error) {
          if (error) {
            console.warn('[Naia cookies] consent-tracking no disponible', error);
          }
          iniciarBannerUnaVez();
        }
      );
    } else if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciarBannerUnaVez, { once: true });
    } else {
      iniciarBannerUnaVez();
    }

    if (typeof ResizeObserver !== 'undefined') {
      const observador = new ResizeObserver(() => {
        if (aviso.hasAttribute('data-visible')) actualizarOffsetBanner();
      });
      observador.observe(aviso);
    }

    function reabrirPreferencias() {
      try {
        window.localStorage.removeItem(claveAlmacen);
      } catch (error) {
        /* almacenamiento no disponible */
      }
      aplicarConsentimientoShopify(false);
      mostrarAviso();
    }

    document.addEventListener('click', (evento) => {
      const disparador = evento.target.closest('[data-reabrir-cookies]');
      if (!disparador) return;
      evento.preventDefault();
      reabrirPreferencias();
    });

    document.addEventListener('aviso-cookies:reabrir', reabrirPreferencias);
    window.naiaReabrirAvisoCookies = reabrirPreferencias;

    botonAceptar?.addEventListener('click', () => resolver('aceptado'));
    botonRechazar?.addEventListener('click', () => resolver('rechazado'));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aviso-stock"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const contenedor = document.querySelector('[data-aviso-stock]');
    if (!contenedor) return;

    const reubicar = contenedor.dataset.reubicar === 'true';
    const claveAlmacen = contenedor.dataset.claveAlmacen || 'aviso-stock-horizon';
    const esEditor = contenedor.dataset.editor === 'true';
    const formulario = contenedor.querySelector('[data-aviso-stock-formulario]');
    const confirmacion = contenedor.querySelector('[data-aviso-stock-confirmacion]');
    const confirmacionTexto = contenedor.querySelector('[data-aviso-stock-confirmacion-texto]');
    const feedback = contenedor.querySelector('[data-aviso-stock-feedback]');
    const emailInput = contenedor.querySelector('[data-aviso-stock-email]');
    const privacidadInput = contenedor.querySelector('[data-aviso-stock-privacidad]');
    const botonEnviar = contenedor.querySelector('[data-aviso-stock-enviar]');
    const botonCambiar = contenedor.querySelector('[data-aviso-stock-cambiar]');
    const varianteEl = contenedor.querySelector('[data-aviso-stock-variante]');
    const variantes = JSON.parse(contenedor.querySelector('[data-aviso-stock-variantes]')?.textContent || '[]');

    const textos = {
      exito: contenedor.dataset.textoExito || '',
      yaRegistrado: contenedor.dataset.textoYaRegistrado || '',
      errorEmail: contenedor.dataset.textoErrorEmail || '',
      errorGeneral: contenedor.dataset.textoErrorGeneral || '',
      etiquetaVariante: contenedor.dataset.etiquetaVariante || '',
    };

    let varianteActiva = null;

    const leerAlmacen = () => {
      try {
        const crudo = window.localStorage.getItem(claveAlmacen);
        const datos = crudo ? JSON.parse(crudo) : {};
        return datos && typeof datos === 'object' ? datos : {};
      } catch (error) {
        return {};
      }
    };

    const guardarAlmacen = (datos) => {
      window.localStorage.setItem(claveAlmacen, JSON.stringify(datos));
    };

    const claveVariante = (variante) => String(variante?.id || contenedor.dataset.varianteId || '');

    const obtenerEmailsVariante = (variante) => {
      const datos = leerAlmacen();
      const lista = datos[claveVariante(variante)];
      return Array.isArray(lista) ? lista : [];
    };

    const emailRegistrado = (variante, email) => {
      const normalizado = email.trim().toLowerCase();
      return obtenerEmailsVariante(variante).some((item) => String(item.email || item).toLowerCase() === normalizado);
    };

    const mostrarFeedback = (mensaje, esExito = false) => {
      if (!feedback) return;
      feedback.hidden = false;
      feedback.textContent = mensaje;
      feedback.classList.toggle('aviso-stock__feedback--exito', esExito);
    };

    const ocultarFeedback = () => {
      if (!feedback) return;
      feedback.hidden = true;
      feedback.textContent = '';
      feedback.classList.remove('aviso-stock__feedback--exito');
    };

    const mostrarConfirmacion = (mensaje) => {
      if (formulario) formulario.hidden = true;
      if (confirmacion) confirmacion.hidden = false;
      if (confirmacionTexto) confirmacionTexto.textContent = mensaje;
    };

    const mostrarFormulario = () => {
      if (formulario) formulario.hidden = false;
      if (confirmacion) confirmacion.hidden = true;
      ocultarFeedback();
    };

    const emitirRegistrado = (detalle) => {
      document.dispatchEvent(
        new CustomEvent('aviso-stock:registrado', {
          detail: detalle,
        })
      );
    };

    const actualizarVisibilidad = (variante) => {
      varianteActiva = variante;
      const disponible = Boolean(variante?.available);

      if (varianteEl) {
        varianteEl.textContent = `${textos.etiquetaVariante}: ${variante?.title || ''}`;
      }

      contenedor.dataset.varianteId = claveVariante(variante);

      if (disponible && !esEditor) {
        contenedor.hidden = true;
        contenedor.setAttribute('aria-hidden', 'true');
        contenedor.setAttribute('inert', '');
        mostrarFormulario();
        return;
      }

      contenedor.hidden = false;
      contenedor.setAttribute('aria-hidden', 'false');
      contenedor.removeAttribute('inert');

      if (emailInput && emailInput.value) {
        /* mantener email si el usuario cambia variante */
      }

      const suscripcionActiva = emailInput?.value
        ? emailRegistrado(variante, emailInput.value)
        : false;

      if (suscripcionActiva) {
        mostrarConfirmacion(textos.yaRegistrado.replace('[[email]]', emailInput.value.trim()));
      } else {
        mostrarFormulario();
      }
    };

    const reubicarEnPdp = () => {
      if (!reubicar) return;
      const ancla = document.querySelector('[data-aviso-stock-ancla]');
      if (!ancla || ancla.contains(contenedor)) return;
      ancla.appendChild(contenedor);
    };

    const validarEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    formulario?.addEventListener('submit', (evento) => {
      evento.preventDefault();
      ocultarFeedback();

      const email = emailInput?.value?.trim() || '';
      if (!validarEmail(email)) {
        mostrarFeedback(textos.errorEmail);
        emailInput?.focus();
        return;
      }

      if (privacidadInput && !privacidadInput.checked) {
        mostrarFeedback(textos.errorGeneral);
        privacidadInput.focus();
        return;
      }

      if (emailRegistrado(varianteActiva, email)) {
        mostrarConfirmacion(textos.yaRegistrado.replace('[[email]]', email));
        return;
      }

      if (botonEnviar) botonEnviar.disabled = true;

      try {
        const datos = leerAlmacen();
        const clave = claveVariante(varianteActiva);
        const lista = Array.isArray(datos[clave]) ? datos[clave] : [];
        const registro = {
          email,
          productoId: contenedor.dataset.productoId,
          productoTitulo: contenedor.dataset.productoTitulo,
          productoHandle: contenedor.dataset.productoHandle,
          varianteId: clave,
          varianteTitulo: varianteActiva?.title || '',
          fecha: new Date().toISOString(),
        };
        lista.push(registro);
        datos[clave] = lista;
        guardarAlmacen(datos);

        emitirRegistrado(registro);
        mostrarConfirmacion(textos.exito.replace('[[email]]', email));
      } catch (error) {
        mostrarFeedback(textos.errorGeneral);
      } finally {
        if (botonEnviar) botonEnviar.disabled = false;
      }
    });

    botonCambiar?.addEventListener('click', () => {
      mostrarFormulario();
      emailInput?.focus();
    });

    emailInput?.addEventListener('input', () => {
      if (!feedback?.hidden) ocultarFeedback();
    });

    document.addEventListener('producto:variante-cambiada', (evento) => {
      if (evento.detail?.variante) {
        actualizarVisibilidad(evento.detail.variante);
      }
    });

    const obtenerVarianteInicial = () => {
      const params = new URLSearchParams(window.location.search);
      const varianteId = Number(params.get('variant'));
      if (varianteId) {
        const encontrada = variantes.find((item) => Number(item.id) === varianteId);
        if (encontrada) return encontrada;
      }
      return variantes.find((item) => item.available) || variantes[0];
    };

    reubicarEnPdp();
    actualizarVisibilidad(obtenerVarianteInicial());
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["barra-beneficios-404"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const seccion = document.querySelector('[data-barra-beneficios-404]');
    if (!seccion) return;

    const pista = seccion.querySelector('[data-barra-beneficios-404-pista]');
    if (!pista) return;

    const btnAnterior = seccion.querySelector('[data-barra-beneficios-404-anterior]');
    const btnSiguiente = seccion.querySelector('[data-barra-beneficios-404-siguiente]');
    const controles = seccion.querySelector('[data-barra-beneficios-404-controles]');

    const desplazar = function (direccion) {
      const ancho = pista.clientWidth;
      if (!ancho) return;
      pista.scrollBy({ left: direccion * ancho * 0.85, behavior: 'smooth' });
    };

    const actualizarControles = function () {
      if (!controles) return;

      const desbordamiento = pista.scrollWidth > pista.clientWidth + 4;
      controles.hidden = !desbordamiento;

      if (!btnAnterior || !btnSiguiente) return;

      btnAnterior.disabled = pista.scrollLeft <= 2;
      btnSiguiente.disabled = pista.scrollLeft + pista.clientWidth >= pista.scrollWidth - 2;
    };

    if (btnAnterior) {
      btnAnterior.addEventListener('click', function () {
        desplazar(-1);
      });
    }

    if (btnSiguiente) {
      btnSiguiente.addEventListener('click', function () {
        desplazar(1);
      });
    }

    pista.addEventListener('scroll', actualizarControles, { passive: true });
    pista.addEventListener('keydown', function (evento) {
      if (evento.key === 'ArrowLeft') {
        evento.preventDefault();
        desplazar(-1);
      }

      if (evento.key === 'ArrowRight') {
        evento.preventDefault();
        desplazar(1);
      }
    });

    if (typeof ResizeObserver !== 'undefined') {
      const observador = new ResizeObserver(actualizarControles);
      observador.observe(pista);
    }

    actualizarControles();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["barra-beneficios-articulo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const seccion = document.querySelector('[data-barra-beneficios-articulo]');
    if (!seccion) return;

    const pista = seccion.querySelector('[data-barra-beneficios-articulo-pista]');
    if (!pista) return;

    const btnAnterior = seccion.querySelector('[data-barra-beneficios-articulo-anterior]');
    const btnSiguiente = seccion.querySelector('[data-barra-beneficios-articulo-siguiente]');
    const controles = seccion.querySelector('[data-barra-beneficios-articulo-controles]');

    const desplazar = function (direccion) {
      const ancho = pista.clientWidth;
      if (!ancho) return;
      pista.scrollBy({ left: direccion * ancho * 0.85, behavior: 'smooth' });
    };

    const actualizarControles = function () {
      if (!controles) return;

      const desbordamiento = pista.scrollWidth > pista.clientWidth + 4;
      controles.hidden = !desbordamiento;

      if (!btnAnterior || !btnSiguiente) return;

      btnAnterior.disabled = pista.scrollLeft <= 2;
      btnSiguiente.disabled = pista.scrollLeft + pista.clientWidth >= pista.scrollWidth - 2;
    };

    if (btnAnterior) {
      btnAnterior.addEventListener('click', function () {
        desplazar(-1);
      });
    }

    if (btnSiguiente) {
      btnSiguiente.addEventListener('click', function () {
        desplazar(1);
      });
    }

    pista.addEventListener('scroll', actualizarControles, { passive: true });
    pista.addEventListener('keydown', function (evento) {
      if (evento.key === 'ArrowLeft') {
        evento.preventDefault();
        desplazar(-1);
      }

      if (evento.key === 'ArrowRight') {
        evento.preventDefault();
        desplazar(1);
      }
    });

    if (typeof ResizeObserver !== 'undefined') {
      const observador = new ResizeObserver(actualizarControles);
      observador.observe(pista);
    }

    actualizarControles();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["barra-beneficios-blog"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const seccion = document.querySelector('[data-barra-beneficios-blog]');
    if (!seccion) return;

    const pista = seccion.querySelector('[data-barra-beneficios-blog-pista]');
    if (!pista) return;

    const btnAnterior = seccion.querySelector('[data-barra-beneficios-blog-anterior]');
    const btnSiguiente = seccion.querySelector('[data-barra-beneficios-blog-siguiente]');
    const controles = seccion.querySelector('[data-barra-beneficios-blog-controles]');

    const desplazar = function (direccion) {
      const ancho = pista.clientWidth;
      if (!ancho) return;
      pista.scrollBy({ left: direccion * ancho * 0.85, behavior: 'smooth' });
    };

    const actualizarControles = function () {
      if (!controles) return;

      const desbordamiento = pista.scrollWidth > pista.clientWidth + 4;
      controles.hidden = !desbordamiento;

      if (!btnAnterior || !btnSiguiente) return;

      btnAnterior.disabled = pista.scrollLeft <= 2;
      btnSiguiente.disabled = pista.scrollLeft + pista.clientWidth >= pista.scrollWidth - 2;
    };

    if (btnAnterior) {
      btnAnterior.addEventListener('click', function () {
        desplazar(-1);
      });
    }

    if (btnSiguiente) {
      btnSiguiente.addEventListener('click', function () {
        desplazar(1);
      });
    }

    pista.addEventListener('scroll', actualizarControles, { passive: true });
    pista.addEventListener('keydown', function (evento) {
      if (evento.key === 'ArrowLeft') {
        evento.preventDefault();
        desplazar(-1);
      }

      if (evento.key === 'ArrowRight') {
        evento.preventDefault();
        desplazar(1);
      }
    });

    if (typeof ResizeObserver !== 'undefined') {
      const observador = new ResizeObserver(actualizarControles);
      observador.observe(pista);
    }

    actualizarControles();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["barra-beneficios-busqueda"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const seccion = document.querySelector('[data-barra-beneficios-busqueda]');
    if (!seccion) return;

    const pista = seccion.querySelector('[data-barra-beneficios-busqueda-pista]');
    if (!pista) return;

    const btnAnterior = seccion.querySelector('[data-barra-beneficios-busqueda-anterior]');
    const btnSiguiente = seccion.querySelector('[data-barra-beneficios-busqueda-siguiente]');
    const controles = seccion.querySelector('[data-barra-beneficios-busqueda-controles]');

    const desplazar = function (direccion) {
      const ancho = pista.clientWidth;
      if (!ancho) return;
      pista.scrollBy({ left: direccion * ancho * 0.85, behavior: 'smooth' });
    };

    const actualizarControles = function () {
      if (!controles) return;

      const desbordamiento = pista.scrollWidth > pista.clientWidth + 4;
      controles.hidden = !desbordamiento;

      if (!btnAnterior || !btnSiguiente) return;

      btnAnterior.disabled = pista.scrollLeft <= 2;
      btnSiguiente.disabled = pista.scrollLeft + pista.clientWidth >= pista.scrollWidth - 2;
    };

    if (btnAnterior) {
      btnAnterior.addEventListener('click', function () {
        desplazar(-1);
      });
    }

    if (btnSiguiente) {
      btnSiguiente.addEventListener('click', function () {
        desplazar(1);
      });
    }

    pista.addEventListener('scroll', actualizarControles, { passive: true });
    pista.addEventListener('keydown', function (evento) {
      if (evento.key === 'ArrowLeft') {
        evento.preventDefault();
        desplazar(-1);
      }

      if (evento.key === 'ArrowRight') {
        evento.preventDefault();
        desplazar(1);
      }
    });

    if (typeof ResizeObserver !== 'undefined') {
      const observador = new ResizeObserver(actualizarControles);
      observador.observe(pista);
    }

    actualizarControles();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["barra-beneficios-cuenta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const seccion = document.querySelector('[data-barra-beneficios-cuenta]');
    if (!seccion) return;

    const pista = seccion.querySelector('[data-barra-beneficios-cuenta-pista]');
    if (!pista) return;

    const btnAnterior = seccion.querySelector('[data-barra-beneficios-cuenta-anterior]');
    const btnSiguiente = seccion.querySelector('[data-barra-beneficios-cuenta-siguiente]');
    const controles = seccion.querySelector('[data-barra-beneficios-cuenta-controles]');

    const desplazar = function (direccion) {
      const ancho = pista.clientWidth;
      if (!ancho) return;
      pista.scrollBy({ left: direccion * ancho * 0.85, behavior: 'smooth' });
    };

    const actualizarControles = function () {
      if (!controles) return;

      const desbordamiento = pista.scrollWidth > pista.clientWidth + 4;
      controles.hidden = !desbordamiento;

      if (!btnAnterior || !btnSiguiente) return;

      btnAnterior.disabled = pista.scrollLeft <= 2;
      btnSiguiente.disabled = pista.scrollLeft + pista.clientWidth >= pista.scrollWidth - 2;
    };

    if (btnAnterior) {
      btnAnterior.addEventListener('click', function () {
        desplazar(-1);
      });
    }

    if (btnSiguiente) {
      btnSiguiente.addEventListener('click', function () {
        desplazar(1);
      });
    }

    pista.addEventListener('scroll', actualizarControles, { passive: true });
    pista.addEventListener('keydown', function (evento) {
      if (evento.key === 'ArrowLeft') {
        evento.preventDefault();
        desplazar(-1);
      }

      if (evento.key === 'ArrowRight') {
        evento.preventDefault();
        desplazar(1);
      }
    });

    if (typeof ResizeObserver !== 'undefined') {
      const observador = new ResizeObserver(actualizarControles);
      observador.observe(pista);
    }

    actualizarControles();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["barra-beneficios-listado-colecciones"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const seccion = document.querySelector('[data-barra-beneficios-listado-colecciones]');
    if (!seccion) return;

    const pista = seccion.querySelector('[data-barra-beneficios-listado-colecciones-pista]');
    if (!pista) return;

    const btnAnterior = seccion.querySelector('[data-barra-beneficios-listado-colecciones-anterior]');
    const btnSiguiente = seccion.querySelector('[data-barra-beneficios-listado-colecciones-siguiente]');
    const controles = seccion.querySelector('[data-barra-beneficios-listado-colecciones-controles]');

    const desplazar = function (direccion) {
      const ancho = pista.clientWidth;
      if (!ancho) return;
      pista.scrollBy({ left: direccion * ancho * 0.85, behavior: 'smooth' });
    };

    const actualizarControles = function () {
      if (!controles) return;

      const desbordamiento = pista.scrollWidth > pista.clientWidth + 4;
      controles.hidden = !desbordamiento;

      if (!btnAnterior || !btnSiguiente) return;

      btnAnterior.disabled = pista.scrollLeft <= 2;
      btnSiguiente.disabled = pista.scrollLeft + pista.clientWidth >= pista.scrollWidth - 2;
    };

    if (btnAnterior) {
      btnAnterior.addEventListener('click', function () {
        desplazar(-1);
      });
    }

    if (btnSiguiente) {
      btnSiguiente.addEventListener('click', function () {
        desplazar(1);
      });
    }

    pista.addEventListener('scroll', actualizarControles, { passive: true });
    pista.addEventListener('keydown', function (evento) {
      if (evento.key === 'ArrowLeft') {
        evento.preventDefault();
        desplazar(-1);
      }

      if (evento.key === 'ArrowRight') {
        evento.preventDefault();
        desplazar(1);
      }
    });

    if (typeof ResizeObserver !== 'undefined') {
      const observador = new ResizeObserver(actualizarControles);
      observador.observe(pista);
    }

    actualizarControles();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["barra-beneficios-pagina"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const seccion = document.querySelector('[data-barra-beneficios-pagina]');
    if (!seccion) return;

    const pista = seccion.querySelector('[data-barra-beneficios-pagina-pista]');
    if (!pista) return;

    const btnAnterior = seccion.querySelector('[data-barra-beneficios-pagina-anterior]');
    const btnSiguiente = seccion.querySelector('[data-barra-beneficios-pagina-siguiente]');
    const controles = seccion.querySelector('[data-barra-beneficios-pagina-controles]');

    const desplazar = function (direccion) {
      const ancho = pista.clientWidth;
      if (!ancho) return;
      pista.scrollBy({ left: direccion * ancho * 0.85, behavior: 'smooth' });
    };

    const actualizarControles = function () {
      if (!controles) return;

      const desbordamiento = pista.scrollWidth > pista.clientWidth + 4;
      controles.hidden = !desbordamiento;

      if (!btnAnterior || !btnSiguiente) return;

      btnAnterior.disabled = pista.scrollLeft <= 2;
      btnSiguiente.disabled = pista.scrollLeft + pista.clientWidth >= pista.scrollWidth - 2;
    };

    if (btnAnterior) {
      btnAnterior.addEventListener('click', function () {
        desplazar(-1);
      });
    }

    if (btnSiguiente) {
      btnSiguiente.addEventListener('click', function () {
        desplazar(1);
      });
    }

    pista.addEventListener('scroll', actualizarControles, { passive: true });
    pista.addEventListener('keydown', function (evento) {
      if (evento.key === 'ArrowLeft') {
        evento.preventDefault();
        desplazar(-1);
      }

      if (evento.key === 'ArrowRight') {
        evento.preventDefault();
        desplazar(1);
      }
    });

    if (typeof ResizeObserver !== 'undefined') {
      const observador = new ResizeObserver(actualizarControles);
      observador.observe(pista);
    }

    actualizarControles();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["barra-beneficios-password"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const seccion = document.querySelector('[data-barra-beneficios-password]');
    if (!seccion) return;

    const pista = seccion.querySelector('[data-barra-beneficios-password-pista]');
    if (!pista) return;

    const btnAnterior = seccion.querySelector('[data-barra-beneficios-password-anterior]');
    const btnSiguiente = seccion.querySelector('[data-barra-beneficios-password-siguiente]');
    const controles = seccion.querySelector('[data-barra-beneficios-password-controles]');

    const desplazar = function (direccion) {
      const ancho = pista.clientWidth;
      if (!ancho) return;
      pista.scrollBy({ left: direccion * ancho * 0.85, behavior: 'smooth' });
    };

    const actualizarControles = function () {
      if (!controles) return;

      const desbordamiento = pista.scrollWidth > pista.clientWidth + 4;
      controles.hidden = !desbordamiento;

      if (!btnAnterior || !btnSiguiente) return;

      btnAnterior.disabled = pista.scrollLeft <= 2;
      btnSiguiente.disabled = pista.scrollLeft + pista.clientWidth >= pista.scrollWidth - 2;
    };

    if (btnAnterior) {
      btnAnterior.addEventListener('click', function () {
        desplazar(-1);
      });
    }

    if (btnSiguiente) {
      btnSiguiente.addEventListener('click', function () {
        desplazar(1);
      });
    }

    pista.addEventListener('scroll', actualizarControles, { passive: true });
    pista.addEventListener('keydown', function (evento) {
      if (evento.key === 'ArrowLeft') {
        evento.preventDefault();
        desplazar(-1);
      }

      if (evento.key === 'ArrowRight') {
        evento.preventDefault();
        desplazar(1);
      }
    });

    if (typeof ResizeObserver !== 'undefined') {
      const observador = new ResizeObserver(actualizarControles);
      observador.observe(pista);
    }

    actualizarControles();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["barra-beneficios-plp"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const seccion = document.querySelector('[data-barra-beneficios-plp]');
    if (!seccion) return;

    const pista = seccion.querySelector('[data-barra-beneficios-plp-pista]');
    if (!pista) return;

    const btnAnterior = seccion.querySelector('[data-barra-beneficios-plp-anterior]');
    const btnSiguiente = seccion.querySelector('[data-barra-beneficios-plp-siguiente]');
    const controles = seccion.querySelector('[data-barra-beneficios-plp-controles]');

    const desplazar = function (direccion) {
      const ancho = pista.clientWidth;
      if (!ancho) return;
      pista.scrollBy({ left: direccion * ancho * 0.85, behavior: 'smooth' });
    };

    const actualizarControles = function () {
      if (!controles) return;

      const desbordamiento = pista.scrollWidth > pista.clientWidth + 4;
      controles.hidden = !desbordamiento;

      if (!btnAnterior || !btnSiguiente) return;

      btnAnterior.disabled = pista.scrollLeft <= 2;
      btnSiguiente.disabled = pista.scrollLeft + pista.clientWidth >= pista.scrollWidth - 2;
    };

    if (btnAnterior) {
      btnAnterior.addEventListener('click', function () {
        desplazar(-1);
      });
    }

    if (btnSiguiente) {
      btnSiguiente.addEventListener('click', function () {
        desplazar(1);
      });
    }

    pista.addEventListener('scroll', actualizarControles, { passive: true });
    pista.addEventListener('keydown', function (evento) {
      if (evento.key === 'ArrowLeft') {
        evento.preventDefault();
        desplazar(-1);
      }

      if (evento.key === 'ArrowRight') {
        evento.preventDefault();
        desplazar(1);
      }
    });

    if (typeof ResizeObserver !== 'undefined') {
      const observador = new ResizeObserver(actualizarControles);
      observador.observe(pista);
    }

    actualizarControles();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["barra-beneficios-tarjeta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const seccion = document.querySelector('[data-barra-beneficios-tarjeta]');
    if (!seccion) return;

    const pista = seccion.querySelector('[data-barra-beneficios-tarjeta-pista]');
    if (!pista) return;

    const btnAnterior = seccion.querySelector('[data-barra-beneficios-tarjeta-anterior]');
    const btnSiguiente = seccion.querySelector('[data-barra-beneficios-tarjeta-siguiente]');
    const controles = seccion.querySelector('[data-barra-beneficios-tarjeta-controles]');

    const desplazar = function (direccion) {
      const ancho = pista.clientWidth;
      if (!ancho) return;
      pista.scrollBy({ left: direccion * ancho * 0.85, behavior: 'smooth' });
    };

    const actualizarControles = function () {
      if (!controles) return;

      const desbordamiento = pista.scrollWidth > pista.clientWidth + 4;
      controles.hidden = !desbordamiento;

      if (!btnAnterior || !btnSiguiente) return;

      btnAnterior.disabled = pista.scrollLeft <= 2;
      btnSiguiente.disabled = pista.scrollLeft + pista.clientWidth >= pista.scrollWidth - 2;
    };

    if (btnAnterior) {
      btnAnterior.addEventListener('click', function () {
        desplazar(-1);
      });
    }

    if (btnSiguiente) {
      btnSiguiente.addEventListener('click', function () {
        desplazar(1);
      });
    }

    pista.addEventListener('scroll', actualizarControles, { passive: true });
    pista.addEventListener('keydown', function (evento) {
      if (evento.key === 'ArrowLeft') {
        evento.preventDefault();
        desplazar(-1);
      }

      if (evento.key === 'ArrowRight') {
        evento.preventDefault();
        desplazar(1);
      }
    });

    if (typeof ResizeObserver !== 'undefined') {
      const observador = new ResizeObserver(actualizarControles);
      observador.observe(pista);
    }

    actualizarControles();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["barra-beneficios"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const seccion = document.querySelector('[data-barra-beneficios]');
    if (!seccion) return;

    const pista = seccion.querySelector('[data-barra-beneficios-pista]');
    if (!pista) return;

    const btnAnterior = seccion.querySelector('[data-barra-beneficios-anterior]');
    const btnSiguiente = seccion.querySelector('[data-barra-beneficios-siguiente]');
    const controles = seccion.querySelector('[data-barra-beneficios-controles]');

    const desplazar = function (direccion) {
      const ancho = pista.clientWidth;
      if (!ancho) return;
      pista.scrollBy({ left: direccion * ancho * 0.85, behavior: 'smooth' });
    };

    const actualizarControles = function () {
      if (!controles) return;

      const desbordamiento = pista.scrollWidth > pista.clientWidth + 4;
      controles.hidden = !desbordamiento;

      if (!btnAnterior || !btnSiguiente) return;

      btnAnterior.disabled = pista.scrollLeft <= 2;
      btnSiguiente.disabled = pista.scrollLeft + pista.clientWidth >= pista.scrollWidth - 2;
    };

    if (btnAnterior) {
      btnAnterior.addEventListener('click', function () {
        desplazar(-1);
      });
    }

    if (btnSiguiente) {
      btnSiguiente.addEventListener('click', function () {
        desplazar(1);
      });
    }

    pista.addEventListener('scroll', actualizarControles, { passive: true });
    pista.addEventListener('keydown', function (evento) {
      if (evento.key === 'ArrowLeft') {
        evento.preventDefault();
        desplazar(-1);
      }

      if (evento.key === 'ArrowRight') {
        evento.preventDefault();
        desplazar(1);
      }
    });

    if (typeof ResizeObserver !== 'undefined') {
      const observador = new ResizeObserver(actualizarControles);
      observador.observe(pista);
    }

    actualizarControles();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["barra-confianza-pdp"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const contenedor = document.querySelector('[data-barra-confianza-pdp]');
    if (!contenedor) return;

    const reubicar = contenedor.dataset.reubicar === 'true';

    const reubicarEnPdp = () => {
      if (!reubicar) return;
      const ancla = document.querySelector('[data-barra-confianza-ancla]');
      if (!ancla || ancla.contains(contenedor)) return;
      ancla.appendChild(contenedor);
    };

    reubicarEnPdp();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["barra-promo-404"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const seccion = document.querySelector('[data-barra-promo-404]');
    if (!seccion) return;

    const respetarMovimiento = seccion.dataset.respetarMovimiento === 'true';
    if (respetarMovimiento) {
      seccion.setAttribute('data-respetar-movimiento', 'true');
    }

    if (seccion.dataset.sticky === 'true') {
      const sentinel = seccion.querySelector('[data-barra-promo-404-sentinel]');
      const envoltorio = seccion.querySelector('[data-barra-promo-404-envoltorio]');

      if (sentinel && envoltorio && 'IntersectionObserver' in window) {
        const reservarEspacio = () => {
          if (seccion.hasAttribute('data-fijada')) {
            seccion.style.minHeight = `${envoltorio.offsetHeight}px`;
          } else {
            seccion.style.minHeight = '';
          }
        };

        const observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              seccion.removeAttribute('data-fijada');
            } else {
              seccion.setAttribute('data-fijada', '');
            }
            reservarEspacio();
          },
          { root: null, threshold: 0 }
        );

        observer.observe(sentinel);
        window.addEventListener('resize', reservarEspacio, { passive: true });
      }
    }

    if (!seccion.hasAttribute('data-barra-promo-404-countdown')) return;

    const fechaFinTexto = seccion.dataset.fechaFin;
    const contenedor = seccion.querySelector('[data-barra-promo-404-countdown-contenedor]');
    const expirado = seccion.querySelector('[data-barra-promo-404-expirado]');
    const diasEl = seccion.querySelector('[data-barra-promo-404-dias]');
    const horasEl = seccion.querySelector('[data-barra-promo-404-horas]');
    const minutosEl = seccion.querySelector('[data-barra-promo-404-minutos]');
    const segundosEl = seccion.querySelector('[data-barra-promo-404-segundos]');

    if (!fechaFinTexto || !contenedor) return;

    const fechaFin = new Date(fechaFinTexto.replace(' ', 'T'));
    if (Number.isNaN(fechaFin.getTime())) return;

    const rellenar = (valor) => String(valor).padStart(2, '0');

    const actualizar = () => {
      const restante = fechaFin.getTime() - Date.now();

      if (restante <= 0) {
        contenedor.hidden = true;
        if (expirado) expirado.hidden = false;
        return;
      }

      const totalSegundos = Math.floor(restante / 1000);
      const dias = Math.floor(totalSegundos / 86400);
      const horas = Math.floor((totalSegundos % 86400) / 3600);
      const minutos = Math.floor((totalSegundos % 3600) / 60);
      const segundos = totalSegundos % 60;

      if (diasEl) diasEl.textContent = rellenar(dias);
      if (horasEl) horasEl.textContent = rellenar(horas);
      if (minutosEl) minutosEl.textContent = rellenar(minutos);
      if (segundosEl) segundosEl.textContent = rellenar(segundos);
    };

    actualizar();
    window.setInterval(actualizar, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["barra-promo-articulo"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const seccion = document.querySelector('[data-barra-promo-articulo]');
    if (!seccion) return;

    const respetarMovimiento = seccion.dataset.respetarMovimiento === 'true';
    if (respetarMovimiento) {
      seccion.setAttribute('data-respetar-movimiento', 'true');
    }

    if (seccion.dataset.sticky === 'true') {
      const sentinel = seccion.querySelector('[data-barra-promo-articulo-sentinel]');
      const envoltorio = seccion.querySelector('[data-barra-promo-articulo-envoltorio]');

      if (sentinel && envoltorio && 'IntersectionObserver' in window) {
        const reservarEspacio = () => {
          if (seccion.hasAttribute('data-fijada')) {
            seccion.style.minHeight = `${envoltorio.offsetHeight}px`;
          } else {
            seccion.style.minHeight = '';
          }
        };

        const observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              seccion.removeAttribute('data-fijada');
            } else {
              seccion.setAttribute('data-fijada', '');
            }
            reservarEspacio();
          },
          { root: null, threshold: 0 }
        );

        observer.observe(sentinel);
        window.addEventListener('resize', reservarEspacio, { passive: true });
      }
    }

    if (!seccion.hasAttribute('data-barra-promo-articulo-countdown')) return;

    const fechaFinTexto = seccion.dataset.fechaFin;
    const contenedor = seccion.querySelector('[data-barra-promo-articulo-countdown-contenedor]');
    const expirado = seccion.querySelector('[data-barra-promo-articulo-expirado]');
    const diasEl = seccion.querySelector('[data-barra-promo-articulo-dias]');
    const horasEl = seccion.querySelector('[data-barra-promo-articulo-horas]');
    const minutosEl = seccion.querySelector('[data-barra-promo-articulo-minutos]');
    const segundosEl = seccion.querySelector('[data-barra-promo-articulo-segundos]');

    if (!fechaFinTexto || !contenedor) return;

    const fechaFin = new Date(fechaFinTexto.replace(' ', 'T'));
    if (Number.isNaN(fechaFin.getTime())) return;

    const rellenar = (valor) => String(valor).padStart(2, '0');

    const actualizar = () => {
      const restante = fechaFin.getTime() - Date.now();

      if (restante <= 0) {
        contenedor.hidden = true;
        if (expirado) expirado.hidden = false;
        return;
      }

      const totalSegundos = Math.floor(restante / 1000);
      const dias = Math.floor(totalSegundos / 86400);
      const horas = Math.floor((totalSegundos % 86400) / 3600);
      const minutos = Math.floor((totalSegundos % 3600) / 60);
      const segundos = totalSegundos % 60;

      if (diasEl) diasEl.textContent = rellenar(dias);
      if (horasEl) horasEl.textContent = rellenar(horas);
      if (minutosEl) minutosEl.textContent = rellenar(minutos);
      if (segundosEl) segundosEl.textContent = rellenar(segundos);
    };

    actualizar();
    window.setInterval(actualizar, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["barra-promo-blog"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const seccion = document.querySelector('[data-barra-promo-blog]');
    if (!seccion) return;

    const respetarMovimiento = seccion.dataset.respetarMovimiento === 'true';
    if (respetarMovimiento) {
      seccion.setAttribute('data-respetar-movimiento', 'true');
    }

    if (seccion.dataset.sticky === 'true') {
      const sentinel = seccion.querySelector('[data-barra-promo-blog-sentinel]');
      const envoltorio = seccion.querySelector('[data-barra-promo-blog-envoltorio]');

      if (sentinel && envoltorio && 'IntersectionObserver' in window) {
        const reservarEspacio = () => {
          if (seccion.hasAttribute('data-fijada')) {
            seccion.style.minHeight = `${envoltorio.offsetHeight}px`;
          } else {
            seccion.style.minHeight = '';
          }
        };

        const observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              seccion.removeAttribute('data-fijada');
            } else {
              seccion.setAttribute('data-fijada', '');
            }
            reservarEspacio();
          },
          { root: null, threshold: 0 }
        );

        observer.observe(sentinel);
        window.addEventListener('resize', reservarEspacio, { passive: true });
      }
    }

    if (!seccion.hasAttribute('data-barra-promo-blog-countdown')) return;

    const fechaFinTexto = seccion.dataset.fechaFin;
    const contenedor = seccion.querySelector('[data-barra-promo-blog-countdown-contenedor]');
    const expirado = seccion.querySelector('[data-barra-promo-blog-expirado]');
    const diasEl = seccion.querySelector('[data-barra-promo-blog-dias]');
    const horasEl = seccion.querySelector('[data-barra-promo-blog-horas]');
    const minutosEl = seccion.querySelector('[data-barra-promo-blog-minutos]');
    const segundosEl = seccion.querySelector('[data-barra-promo-blog-segundos]');

    if (!fechaFinTexto || !contenedor) return;

    const fechaFin = new Date(fechaFinTexto.replace(' ', 'T'));
    if (Number.isNaN(fechaFin.getTime())) return;

    const rellenar = (valor) => String(valor).padStart(2, '0');

    const actualizar = () => {
      const restante = fechaFin.getTime() - Date.now();

      if (restante <= 0) {
        contenedor.hidden = true;
        if (expirado) expirado.hidden = false;
        return;
      }

      const totalSegundos = Math.floor(restante / 1000);
      const dias = Math.floor(totalSegundos / 86400);
      const horas = Math.floor((totalSegundos % 86400) / 3600);
      const minutos = Math.floor((totalSegundos % 3600) / 60);
      const segundos = totalSegundos % 60;

      if (diasEl) diasEl.textContent = rellenar(dias);
      if (horasEl) horasEl.textContent = rellenar(horas);
      if (minutosEl) minutosEl.textContent = rellenar(minutos);
      if (segundosEl) segundosEl.textContent = rellenar(segundos);
    };

    actualizar();
    window.setInterval(actualizar, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["barra-promo-busqueda"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const seccion = document.querySelector('[data-barra-promo-busqueda]');
    if (!seccion) return;

    const respetarMovimiento = seccion.dataset.respetarMovimiento === 'true';
    if (respetarMovimiento) {
      seccion.setAttribute('data-respetar-movimiento', 'true');
    }

    if (seccion.dataset.sticky === 'true') {
      const sentinel = seccion.querySelector('[data-barra-promo-busqueda-sentinel]');
      const envoltorio = seccion.querySelector('[data-barra-promo-busqueda-envoltorio]');

      if (sentinel && envoltorio && 'IntersectionObserver' in window) {
        const reservarEspacio = () => {
          if (seccion.hasAttribute('data-fijada')) {
            seccion.style.minHeight = `${envoltorio.offsetHeight}px`;
          } else {
            seccion.style.minHeight = '';
          }
        };

        const observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              seccion.removeAttribute('data-fijada');
            } else {
              seccion.setAttribute('data-fijada', '');
            }
            reservarEspacio();
          },
          { root: null, threshold: 0 }
        );

        observer.observe(sentinel);
        window.addEventListener('resize', reservarEspacio, { passive: true });
      }
    }

    if (!seccion.hasAttribute('data-barra-promo-busqueda-countdown')) return;

    const fechaFinTexto = seccion.dataset.fechaFin;
    const contenedor = seccion.querySelector('[data-barra-promo-busqueda-countdown-contenedor]');
    const expirado = seccion.querySelector('[data-barra-promo-busqueda-expirado]');
    const diasEl = seccion.querySelector('[data-barra-promo-busqueda-dias]');
    const horasEl = seccion.querySelector('[data-barra-promo-busqueda-horas]');
    const minutosEl = seccion.querySelector('[data-barra-promo-busqueda-minutos]');
    const segundosEl = seccion.querySelector('[data-barra-promo-busqueda-segundos]');

    if (!fechaFinTexto || !contenedor) return;

    const fechaFin = new Date(fechaFinTexto.replace(' ', 'T'));
    if (Number.isNaN(fechaFin.getTime())) return;

    const rellenar = (valor) => String(valor).padStart(2, '0');

    const actualizar = () => {
      const restante = fechaFin.getTime() - Date.now();

      if (restante <= 0) {
        contenedor.hidden = true;
        if (expirado) expirado.hidden = false;
        return;
      }

      const totalSegundos = Math.floor(restante / 1000);
      const dias = Math.floor(totalSegundos / 86400);
      const horas = Math.floor((totalSegundos % 86400) / 3600);
      const minutos = Math.floor((totalSegundos % 3600) / 60);
      const segundos = totalSegundos % 60;

      if (diasEl) diasEl.textContent = rellenar(dias);
      if (horasEl) horasEl.textContent = rellenar(horas);
      if (minutosEl) minutosEl.textContent = rellenar(minutos);
      if (segundosEl) segundosEl.textContent = rellenar(segundos);
    };

    actualizar();
    window.setInterval(actualizar, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["barra-promo-carrito"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const seccion = document.querySelector('[data-barra-promo-carrito]');
    if (!seccion) return;

    const respetarMovimiento = seccion.dataset.respetarMovimiento === 'true';
    if (respetarMovimiento) {
      seccion.setAttribute('data-respetar-movimiento', 'true');
    }

    if (seccion.dataset.sticky === 'true') {
      const sentinel = seccion.querySelector('[data-barra-promo-carrito-sentinel]');
      const envoltorio = seccion.querySelector('[data-barra-promo-carrito-envoltorio]');

      if (sentinel && envoltorio && 'IntersectionObserver' in window) {
        const reservarEspacio = () => {
          if (seccion.hasAttribute('data-fijada')) {
            seccion.style.minHeight = `${envoltorio.offsetHeight}px`;
          } else {
            seccion.style.minHeight = '';
          }
        };

        const observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              seccion.removeAttribute('data-fijada');
            } else {
              seccion.setAttribute('data-fijada', '');
            }
            reservarEspacio();
          },
          { root: null, threshold: 0 }
        );

        observer.observe(sentinel);
        window.addEventListener('resize', reservarEspacio, { passive: true });
      }
    }

    if (!seccion.hasAttribute('data-barra-promo-carrito-countdown')) return;

    const fechaFinTexto = seccion.dataset.fechaFin;
    const contenedor = seccion.querySelector('[data-barra-promo-carrito-countdown-contenedor]');
    const expirado = seccion.querySelector('[data-barra-promo-carrito-expirado]');
    const diasEl = seccion.querySelector('[data-barra-promo-carrito-dias]');
    const horasEl = seccion.querySelector('[data-barra-promo-carrito-horas]');
    const minutosEl = seccion.querySelector('[data-barra-promo-carrito-minutos]');
    const segundosEl = seccion.querySelector('[data-barra-promo-carrito-segundos]');

    if (!fechaFinTexto || !contenedor) return;

    const fechaFin = new Date(fechaFinTexto.replace(' ', 'T'));
    if (Number.isNaN(fechaFin.getTime())) return;

    const rellenar = (valor) => String(valor).padStart(2, '0');

    const actualizar = () => {
      const restante = fechaFin.getTime() - Date.now();

      if (restante <= 0) {
        contenedor.hidden = true;
        if (expirado) expirado.hidden = false;
        return;
      }

      const totalSegundos = Math.floor(restante / 1000);
      const dias = Math.floor(totalSegundos / 86400);
      const horas = Math.floor((totalSegundos % 86400) / 3600);
      const minutos = Math.floor((totalSegundos % 3600) / 60);
      const segundos = totalSegundos % 60;

      if (diasEl) diasEl.textContent = rellenar(dias);
      if (horasEl) horasEl.textContent = rellenar(horas);
      if (minutosEl) minutosEl.textContent = rellenar(minutos);
      if (segundosEl) segundosEl.textContent = rellenar(segundos);
    };

    actualizar();
    window.setInterval(actualizar, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["barra-promo-contacto"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const seccion = document.querySelector('[data-barra-promo-contacto]');
    if (!seccion) return;

    const respetarMovimiento = seccion.dataset.respetarMovimiento === 'true';
    if (respetarMovimiento) {
      seccion.setAttribute('data-respetar-movimiento', 'true');
    }

    if (seccion.dataset.sticky === 'true') {
      const sentinel = seccion.querySelector('[data-barra-promo-contacto-sentinel]');
      const envoltorio = seccion.querySelector('[data-barra-promo-contacto-envoltorio]');

      if (sentinel && envoltorio && 'IntersectionObserver' in window) {
        const reservarEspacio = () => {
          if (seccion.hasAttribute('data-fijada')) {
            seccion.style.minHeight = `${envoltorio.offsetHeight}px`;
          } else {
            seccion.style.minHeight = '';
          }
        };

        const observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              seccion.removeAttribute('data-fijada');
            } else {
              seccion.setAttribute('data-fijada', '');
            }
            reservarEspacio();
          },
          { root: null, threshold: 0 }
        );

        observer.observe(sentinel);
        window.addEventListener('resize', reservarEspacio, { passive: true });
      }
    }

    if (!seccion.hasAttribute('data-barra-promo-contacto-countdown')) return;

    const fechaFinTexto = seccion.dataset.fechaFin;
    const contenedor = seccion.querySelector('[data-barra-promo-contacto-countdown-contenedor]');
    const expirado = seccion.querySelector('[data-barra-promo-contacto-expirado]');
    const diasEl = seccion.querySelector('[data-barra-promo-contacto-dias]');
    const horasEl = seccion.querySelector('[data-barra-promo-contacto-horas]');
    const minutosEl = seccion.querySelector('[data-barra-promo-contacto-minutos]');
    const segundosEl = seccion.querySelector('[data-barra-promo-contacto-segundos]');

    if (!fechaFinTexto || !contenedor) return;

    const fechaFin = new Date(fechaFinTexto.replace(' ', 'T'));
    if (Number.isNaN(fechaFin.getTime())) return;

    const rellenar = (valor) => String(valor).padStart(2, '0');

    const actualizar = () => {
      const restante = fechaFin.getTime() - Date.now();

      if (restante <= 0) {
        contenedor.hidden = true;
        if (expirado) expirado.hidden = false;
        return;
      }

      const totalSegundos = Math.floor(restante / 1000);
      const dias = Math.floor(totalSegundos / 86400);
      const horas = Math.floor((totalSegundos % 86400) / 3600);
      const minutos = Math.floor((totalSegundos % 3600) / 60);
      const segundos = totalSegundos % 60;

      if (diasEl) diasEl.textContent = rellenar(dias);
      if (horasEl) horasEl.textContent = rellenar(horas);
      if (minutosEl) minutosEl.textContent = rellenar(minutos);
      if (segundosEl) segundosEl.textContent = rellenar(segundos);
    };

    actualizar();
    window.setInterval(actualizar, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["barra-promo-cuenta"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const seccion = document.querySelector('[data-barra-promo-cuenta]');
    if (!seccion) return;

    const respetarMovimiento = seccion.dataset.respetarMovimiento === 'true';
    if (respetarMovimiento) {
      seccion.setAttribute('data-respetar-movimiento', 'true');
    }

    if (seccion.dataset.sticky === 'true') {
      const sentinel = seccion.querySelector('[data-barra-promo-cuenta-sentinel]');
      const envoltorio = seccion.querySelector('[data-barra-promo-cuenta-envoltorio]');

      if (sentinel && envoltorio && 'IntersectionObserver' in window) {
        const reservarEspacio = () => {
          if (seccion.hasAttribute('data-fijada')) {
            seccion.style.minHeight = `${envoltorio.offsetHeight}px`;
          } else {
            seccion.style.minHeight = '';
          }
        };

        const observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              seccion.removeAttribute('data-fijada');
            } else {
              seccion.setAttribute('data-fijada', '');
            }
            reservarEspacio();
          },
          { root: null, threshold: 0 }
        );

        observer.observe(sentinel);
        window.addEventListener('resize', reservarEspacio, { passive: true });
      }
    }

    if (!seccion.hasAttribute('data-barra-promo-cuenta-countdown')) return;

    const fechaFinTexto = seccion.dataset.fechaFin;
    const contenedor = seccion.querySelector('[data-barra-promo-cuenta-countdown-contenedor]');
    const expirado = seccion.querySelector('[data-barra-promo-cuenta-expirado]');
    const diasEl = seccion.querySelector('[data-barra-promo-cuenta-dias]');
    const horasEl = seccion.querySelector('[data-barra-promo-cuenta-horas]');
    const minutosEl = seccion.querySelector('[data-barra-promo-cuenta-minutos]');
    const segundosEl = seccion.querySelector('[data-barra-promo-cuenta-segundos]');

    if (!fechaFinTexto || !contenedor) return;

    const fechaFin = new Date(fechaFinTexto.replace(' ', 'T'));
    if (Number.isNaN(fechaFin.getTime())) return;

    const rellenar = (valor) => String(valor).padStart(2, '0');

    const actualizar = () => {
      const restante = fechaFin.getTime() - Date.now();

      if (restante <= 0) {
        contenedor.hidden = true;
        if (expirado) expirado.hidden = false;
        return;
      }

      const totalSegundos = Math.floor(restante / 1000);
      const dias = Math.floor(totalSegundos / 86400);
      const horas = Math.floor((totalSegundos % 86400) / 3600);
      const minutos = Math.floor((totalSegundos % 3600) / 60);
      const segundos = totalSegundos % 60;

      if (diasEl) diasEl.textContent = rellenar(dias);
      if (horasEl) horasEl.textContent = rellenar(horas);
      if (minutosEl) minutosEl.textContent = rellenar(minutos);
      if (segundosEl) segundosEl.textContent = rellenar(segundos);
    };

    actualizar();
    window.setInterval(actualizar, 1000);

    const botonScroll = seccion.querySelector('[data-barra-promo-cuenta-scroll]');
    if (botonScroll) {
      botonScroll.addEventListener('click', () => {
        const selector = seccion.dataset.scrollDestino;
        if (!selector) return;

        const destino = document.querySelector(selector);
        if (!destino) return;

        const reducido = respetarMovimiento && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        destino.scrollIntoView({ behavior: reducido ? 'auto' : 'smooth', block: 'start' });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["barra-promo-faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const seccion = document.querySelector('[data-barra-promo-faq]');
    if (!seccion) return;

    const respetarMovimiento = seccion.dataset.respetarMovimiento === 'true';
    if (respetarMovimiento) {
      seccion.setAttribute('data-respetar-movimiento', 'true');
    }

    if (seccion.dataset.sticky === 'true') {
      const sentinel = seccion.querySelector('[data-barra-promo-faq-sentinel]');
      const envoltorio = seccion.querySelector('[data-barra-promo-faq-envoltorio]');

      if (sentinel && envoltorio && 'IntersectionObserver' in window) {
        const reservarEspacio = () => {
          if (seccion.hasAttribute('data-fijada')) {
            seccion.style.minHeight = `${envoltorio.offsetHeight}px`;
          } else {
            seccion.style.minHeight = '';
          }
        };

        const observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              seccion.removeAttribute('data-fijada');
            } else {
              seccion.setAttribute('data-fijada', '');
            }
            reservarEspacio();
          },
          { root: null, threshold: 0 }
        );

        observer.observe(sentinel);
        window.addEventListener('resize', reservarEspacio, { passive: true });
      }
    }

    if (!seccion.hasAttribute('data-barra-promo-faq-countdown')) return;

    const fechaFinTexto = seccion.dataset.fechaFin;
    const contenedor = seccion.querySelector('[data-barra-promo-faq-countdown-contenedor]');
    const expirado = seccion.querySelector('[data-barra-promo-faq-expirado]');
    const diasEl = seccion.querySelector('[data-barra-promo-faq-dias]');
    const horasEl = seccion.querySelector('[data-barra-promo-faq-horas]');
    const minutosEl = seccion.querySelector('[data-barra-promo-faq-minutos]');
    const segundosEl = seccion.querySelector('[data-barra-promo-faq-segundos]');

    if (!fechaFinTexto || !contenedor) return;

    const fechaFin = new Date(fechaFinTexto.replace(' ', 'T'));
    if (Number.isNaN(fechaFin.getTime())) return;

    const rellenar = (valor) => String(valor).padStart(2, '0');

    const actualizar = () => {
      const restante = fechaFin.getTime() - Date.now();

      if (restante <= 0) {
        contenedor.hidden = true;
        if (expirado) expirado.hidden = false;
        return;
      }

      const totalSegundos = Math.floor(restante / 1000);
      const dias = Math.floor(totalSegundos / 86400);
      const horas = Math.floor((totalSegundos % 86400) / 3600);
      const minutos = Math.floor((totalSegundos % 3600) / 60);
      const segundos = totalSegundos % 60;

      if (diasEl) diasEl.textContent = rellenar(dias);
      if (horasEl) horasEl.textContent = rellenar(horas);
      if (minutosEl) minutosEl.textContent = rellenar(minutos);
      if (segundosEl) segundosEl.textContent = rellenar(segundos);
    };

    actualizar();
    window.setInterval(actualizar, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["barra-promo-listado-colecciones"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const seccion = document.querySelector('[data-barra-promo-listado-colecciones]');
    if (!seccion) return;

    const respetarMovimiento = seccion.dataset.respetarMovimiento === 'true';
    if (respetarMovimiento) {
      seccion.setAttribute('data-respetar-movimiento', 'true');
    }

    if (seccion.dataset.sticky === 'true') {
      const sentinel = seccion.querySelector('[data-barra-promo-listado-sentinel]');
      const envoltorio = seccion.querySelector('[data-barra-promo-listado-envoltorio]');

      if (sentinel && envoltorio && 'IntersectionObserver' in window) {
        const reservarEspacio = () => {
          if (seccion.hasAttribute('data-fijada')) {
            seccion.style.minHeight = `${envoltorio.offsetHeight}px`;
          } else {
            seccion.style.minHeight = '';
          }
        };

        const observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              seccion.removeAttribute('data-fijada');
            } else {
              seccion.setAttribute('data-fijada', '');
            }
            reservarEspacio();
          },
          { root: null, threshold: 0 }
        );

        observer.observe(sentinel);
        window.addEventListener('resize', reservarEspacio, { passive: true });
      }
    }

    if (!seccion.hasAttribute('data-barra-promo-listado-countdown')) return;

    const fechaFinTexto = seccion.dataset.fechaFin;
    const contenedor = seccion.querySelector('[data-barra-promo-listado-countdown-contenedor]');
    const expirado = seccion.querySelector('[data-barra-promo-listado-expirado]');
    const diasEl = seccion.querySelector('[data-barra-promo-listado-dias]');
    const horasEl = seccion.querySelector('[data-barra-promo-listado-horas]');
    const minutosEl = seccion.querySelector('[data-barra-promo-listado-minutos]');
    const segundosEl = seccion.querySelector('[data-barra-promo-listado-segundos]');

    if (!fechaFinTexto || !contenedor) return;

    const fechaFin = new Date(fechaFinTexto.replace(' ', 'T'));
    if (Number.isNaN(fechaFin.getTime())) return;

    const rellenar = (valor) => String(valor).padStart(2, '0');

    const actualizar = () => {
      const restante = fechaFin.getTime() - Date.now();

      if (restante <= 0) {
        contenedor.hidden = true;
        if (expirado) expirado.hidden = false;
        return;
      }

      const totalSegundos = Math.floor(restante / 1000);
      const dias = Math.floor(totalSegundos / 86400);
      const horas = Math.floor((totalSegundos % 86400) / 3600);
      const minutos = Math.floor((totalSegundos % 3600) / 60);
      const segundos = totalSegundos % 60;

      if (diasEl) diasEl.textContent = rellenar(dias);
      if (horasEl) horasEl.textContent = rellenar(horas);
      if (minutosEl) minutosEl.textContent = rellenar(minutos);
      if (segundosEl) segundosEl.textContent = rellenar(segundos);
    };

    actualizar();
    window.setInterval(actualizar, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["barra-promo-pagina"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const seccion = document.querySelector('[data-barra-promo-pagina]');
    if (!seccion) return;

    const respetarMovimiento = seccion.dataset.respetarMovimiento === 'true';
    if (respetarMovimiento) {
      seccion.setAttribute('data-respetar-movimiento', 'true');
    }

    if (seccion.dataset.sticky === 'true') {
      const sentinel = seccion.querySelector('[data-barra-promo-pagina-sentinel]');
      const envoltorio = seccion.querySelector('[data-barra-promo-pagina-envoltorio]');

      if (sentinel && envoltorio && 'IntersectionObserver' in window) {
        const reservarEspacio = () => {
          if (seccion.hasAttribute('data-fijada')) {
            seccion.style.minHeight = `${envoltorio.offsetHeight}px`;
          } else {
            seccion.style.minHeight = '';
          }
        };

        const observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              seccion.removeAttribute('data-fijada');
            } else {
              seccion.setAttribute('data-fijada', '');
            }
            reservarEspacio();
          },
          { root: null, threshold: 0 }
        );

        observer.observe(sentinel);
        window.addEventListener('resize', reservarEspacio, { passive: true });
      }
    }

    if (!seccion.hasAttribute('data-barra-promo-pagina-countdown')) return;

    const fechaFinTexto = seccion.dataset.fechaFin;
    const contenedor = seccion.querySelector('[data-barra-promo-pagina-countdown-contenedor]');
    const expirado = seccion.querySelector('[data-barra-promo-pagina-expirado]');
    const diasEl = seccion.querySelector('[data-barra-promo-pagina-dias]');
    const horasEl = seccion.querySelector('[data-barra-promo-pagina-horas]');
    const minutosEl = seccion.querySelector('[data-barra-promo-pagina-minutos]');
    const segundosEl = seccion.querySelector('[data-barra-promo-pagina-segundos]');

    if (!fechaFinTexto || !contenedor) return;

    const fechaFin = new Date(fechaFinTexto.replace(' ', 'T'));
    if (Number.isNaN(fechaFin.getTime())) return;

    const rellenar = (valor) => String(valor).padStart(2, '0');

    const actualizar = () => {
      const restante = fechaFin.getTime() - Date.now();

      if (restante <= 0) {
        contenedor.hidden = true;
        if (expirado) expirado.hidden = false;
        return;
      }

      const totalSegundos = Math.floor(restante / 1000);
      const dias = Math.floor(totalSegundos / 86400);
      const horas = Math.floor((totalSegundos % 86400) / 3600);
      const minutos = Math.floor((totalSegundos % 3600) / 60);
      const segundos = totalSegundos % 60;

      if (diasEl) diasEl.textContent = rellenar(dias);
      if (horasEl) horasEl.textContent = rellenar(horas);
      if (minutosEl) minutosEl.textContent = rellenar(minutos);
      if (segundosEl) segundosEl.textContent = rellenar(segundos);
    };

    actualizar();
    window.setInterval(actualizar, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["barra-promo-password"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const seccion = document.querySelector('[data-barra-promo-password]');
    if (!seccion) return;

    const respetarMovimiento = seccion.dataset.respetarMovimiento === 'true';
    if (respetarMovimiento) {
      seccion.setAttribute('data-respetar-movimiento', 'true');
    }

    if (seccion.dataset.sticky === 'true') {
      const sentinel = seccion.querySelector('[data-barra-promo-password-sentinel]');
      const envoltorio = seccion.querySelector('[data-barra-promo-password-envoltorio]');

      if (sentinel && envoltorio && 'IntersectionObserver' in window) {
        const reservarEspacio = () => {
          if (seccion.hasAttribute('data-fijada')) {
            seccion.style.minHeight = `${envoltorio.offsetHeight}px`;
          } else {
            seccion.style.minHeight = '';
          }
        };

        const observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              seccion.removeAttribute('data-fijada');
            } else {
              seccion.setAttribute('data-fijada', '');
            }
            reservarEspacio();
          },
          { root: null, threshold: 0 }
        );

        observer.observe(sentinel);
        window.addEventListener('resize', reservarEspacio, { passive: true });
      }
    }

    if (!seccion.hasAttribute('data-barra-promo-password-countdown')) return;

    const fechaFinTexto = seccion.dataset.fechaFin;
    const contenedor = seccion.querySelector('[data-barra-promo-password-countdown-contenedor]');
    const expirado = seccion.querySelector('[data-barra-promo-password-expirado]');
    const diasEl = seccion.querySelector('[data-barra-promo-password-dias]');
    const horasEl = seccion.querySelector('[data-barra-promo-password-horas]');
    const minutosEl = seccion.querySelector('[data-barra-promo-password-minutos]');
    const segundosEl = seccion.querySelector('[data-barra-promo-password-segundos]');

    if (!fechaFinTexto || !contenedor) return;

    const fechaFin = new Date(fechaFinTexto.replace(' ', 'T'));
    if (Number.isNaN(fechaFin.getTime())) return;

    const rellenar = (valor) => String(valor).padStart(2, '0');

    const actualizar = () => {
      const restante = fechaFin.getTime() - Date.now();

      if (restante <= 0) {
        contenedor.hidden = true;
        if (expirado) expirado.hidden = false;
        return;
      }

      const totalSegundos = Math.floor(restante / 1000);
      const dias = Math.floor(totalSegundos / 86400);
      const horas = Math.floor((totalSegundos % 86400) / 3600);
      const minutos = Math.floor((totalSegundos % 3600) / 60);
      const segundos = totalSegundos % 60;

      if (diasEl) diasEl.textContent = rellenar(dias);
      if (horasEl) horasEl.textContent = rellenar(horas);
      if (minutosEl) minutosEl.textContent = rellenar(minutos);
      if (segundosEl) segundosEl.textContent = rellenar(segundos);
    };

    actualizar();
    window.setInterval(actualizar, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["barra-promo-plp"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const seccion = document.querySelector('[data-barra-promo-plp]');
    if (!seccion) return;

    const respetarMovimiento = seccion.dataset.respetarMovimiento === 'true';
    if (respetarMovimiento) {
      seccion.setAttribute('data-respetar-movimiento', 'true');
    }

    if (seccion.dataset.sticky === 'true') {
      const sentinel = seccion.querySelector('[data-barra-promo-plp-sentinel]');
      const envoltorio = seccion.querySelector('[data-barra-promo-plp-envoltorio]');

      if (sentinel && envoltorio && 'IntersectionObserver' in window) {
        let alturaReservada = 0;

        const reservarEspacio = () => {
          if (seccion.hasAttribute('data-fijada')) {
            alturaReservada = envoltorio.offsetHeight;
            seccion.style.minHeight = `${alturaReservada}px`;
          } else {
            seccion.style.minHeight = '';
          }
        };

        const observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              seccion.removeAttribute('data-fijada');
            } else {
              seccion.setAttribute('data-fijada', '');
            }
            reservarEspacio();
          },
          { root: null, threshold: 0, rootMargin: '0px 0px 0px 0px' }
        );

        observer.observe(sentinel);
        window.addEventListener('resize', reservarEspacio, { passive: true });
      }
    }

    if (!seccion.hasAttribute('data-barra-promo-plp-countdown')) return;

    const contenedor = seccion.querySelector('[data-barra-promo-plp-countdown-contenedor]');
    const expirado = seccion.querySelector('[data-barra-promo-plp-expirado]');
    const diasEl = seccion.querySelector('[data-barra-promo-plp-dias]');
    const horasEl = seccion.querySelector('[data-barra-promo-plp-horas]');
    const minutosEl = seccion.querySelector('[data-barra-promo-plp-minutos]');
    const segundosEl = seccion.querySelector('[data-barra-promo-plp-segundos]');

    if (!contenedor) return;

    const modo = seccion.dataset.countdownModo || 'fecha_fija';
    const mostrarDias = seccion.dataset.mostrarDias === 'true';
    const ocultarExpirado = seccion.dataset.ocultarExpirado === 'true';
    const rellenar = (valor) => String(Math.max(0, valor)).padStart(2, '0');

    function marcarExpirado() {
      contenedor.hidden = true;
      if (expirado) expirado.hidden = false;
      if (ocultarExpirado) {
        seccion.hidden = true;
      }
      return false;
    }

    function obtenerTimestampFin() {
      if (modo === 'duracion') {
        const horas = Number.parseInt(seccion.dataset.duracionHoras || '0', 10) || 0;
        const minutos = Number.parseInt(seccion.dataset.duracionMinutos || '0', 10) || 0;
        const segundosDuracion = Number.parseInt(seccion.dataset.duracionSegundos || '0', 10) || 0;
        const duracionMs = (horas * 3600 + minutos * 60 + segundosDuracion) * 1000;
        if (duracionMs <= 0) return null;

        const promoId = seccion.dataset.idPromocion || seccion.id || 'plp';
        const storageKey = `oferta-limitada-fin:${promoId}`;
        const ahora = Date.now();

        try {
          const guardado = window.localStorage.getItem(storageKey);
          if (guardado) {
            const finGuardado = Number.parseInt(guardado, 10);
            if (!Number.isNaN(finGuardado) && finGuardado > ahora) {
              return finGuardado;
            }
            if (!Number.isNaN(finGuardado) && finGuardado <= ahora) {
              return null;
            }
          }
          const finNuevo = ahora + duracionMs;
          window.localStorage.setItem(storageKey, String(finNuevo));
          return finNuevo;
        } catch (error) {
          return ahora + duracionMs;
        }
      }

      const fechaFinTexto = seccion.dataset.fechaFin;
      if (!fechaFinTexto) return null;
      const fechaFin = new Date(fechaFinTexto.replace(' ', 'T'));
      if (Number.isNaN(fechaFin.getTime())) return null;
      return fechaFin.getTime();
    }

    const timestampFin = obtenerTimestampFin();
    if (timestampFin == null) {
      marcarExpirado();
      return;
    }

    function actualizar() {
      const restante = timestampFin - Date.now();
      if (restante <= 0) {
        marcarExpirado();
        return;
      }

      const totalSegundos = Math.floor(restante / 1000);
      let dias = 0;
      let horas = 0;
      let minutos = 0;
      let segundos = 0;

      if (mostrarDias) {
        dias = Math.floor(totalSegundos / 86400);
        horas = Math.floor((totalSegundos % 86400) / 3600);
        minutos = Math.floor((totalSegundos % 3600) / 60);
        segundos = totalSegundos % 60;
      } else {
        horas = Math.floor(totalSegundos / 3600);
        minutos = Math.floor((totalSegundos % 3600) / 60);
        segundos = totalSegundos % 60;
      }

      if (diasEl) diasEl.textContent = rellenar(dias);
      if (horasEl) horasEl.textContent = rellenar(horas);
      if (minutosEl) minutosEl.textContent = rellenar(minutos);
      if (segundosEl) segundosEl.textContent = rellenar(segundos);
    }

    actualizar();
    window.setInterval(actualizar, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["barra-promo-quiz-tallas"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const seccion = document.querySelector('[data-barra-promo-quiz-tallas]');
    if (!seccion) return;

    const respetarMovimiento = seccion.dataset.respetarMovimiento === 'true';
    if (respetarMovimiento) {
      seccion.setAttribute('data-respetar-movimiento', 'true');
    }

    if (seccion.dataset.sticky === 'true') {
      const sentinel = seccion.querySelector('[data-barra-promo-quiz-tallas-sentinel]');
      const envoltorio = seccion.querySelector('[data-barra-promo-quiz-tallas-envoltorio]');

      if (sentinel && envoltorio && 'IntersectionObserver' in window) {
        const reservarEspacio = () => {
          if (seccion.hasAttribute('data-fijada')) {
            seccion.style.minHeight = `${envoltorio.offsetHeight}px`;
          } else {
            seccion.style.minHeight = '';
          }
        };

        const observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              seccion.removeAttribute('data-fijada');
            } else {
              seccion.setAttribute('data-fijada', '');
            }
            reservarEspacio();
          },
          { root: null, threshold: 0 }
        );

        observer.observe(sentinel);
        window.addEventListener('resize', reservarEspacio, { passive: true });
      }
    }

    if (!seccion.hasAttribute('data-barra-promo-quiz-tallas-countdown')) return;

    const fechaFinTexto = seccion.dataset.fechaFin;
    const contenedor = seccion.querySelector('[data-barra-promo-quiz-tallas-countdown-contenedor]');
    const expirado = seccion.querySelector('[data-barra-promo-quiz-tallas-expirado]');
    const diasEl = seccion.querySelector('[data-barra-promo-quiz-tallas-dias]');
    const horasEl = seccion.querySelector('[data-barra-promo-quiz-tallas-horas]');
    const minutosEl = seccion.querySelector('[data-barra-promo-quiz-tallas-minutos]');
    const segundosEl = seccion.querySelector('[data-barra-promo-quiz-tallas-segundos]');

    if (!fechaFinTexto || !contenedor) return;

    const fechaFin = new Date(fechaFinTexto.replace(' ', 'T'));
    if (Number.isNaN(fechaFin.getTime())) return;

    const rellenar = (valor) => String(valor).padStart(2, '0');

    const actualizar = () => {
      const restante = fechaFin.getTime() - Date.now();

      if (restante <= 0) {
        contenedor.hidden = true;
        if (expirado) expirado.hidden = false;
        return;
      }

      const totalSegundos = Math.floor(restante / 1000);
      const dias = Math.floor(totalSegundos / 86400);
      const horas = Math.floor((totalSegundos % 86400) / 3600);
      const minutos = Math.floor((totalSegundos % 3600) / 60);
      const segundos = totalSegundos % 60;

      if (diasEl) diasEl.textContent = rellenar(dias);
      if (horasEl) horasEl.textContent = rellenar(horas);
      if (minutosEl) minutosEl.textContent = rellenar(minutos);
      if (segundosEl) segundosEl.textContent = rellenar(segundos);
    };

    actualizar();
    window.setInterval(actualizar, 1000);

    const botonScroll = seccion.querySelector('[data-barra-promo-quiz-tallas-scroll]');
    if (botonScroll) {
      botonScroll.addEventListener('click', () => {
        const quiz = document.querySelector('[data-quiz-tallas]');
        if (!quiz) return;

        const reducido = respetarMovimiento && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        quiz.scrollIntoView({ behavior: reducido ? 'auto' : 'smooth', block: 'start' });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["barra-promo-regalo"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const seccion = document.querySelector('[data-barra-promo-regalo]');
    if (!seccion) return;

    const respetarMovimiento = seccion.dataset.respetarMovimiento === 'true';
    if (respetarMovimiento) {
      seccion.setAttribute('data-respetar-movimiento', 'true');
    }

    if (seccion.dataset.sticky === 'true') {
      const sentinel = seccion.querySelector('[data-barra-promo-regalo-sentinel]');
      const envoltorio = seccion.querySelector('[data-barra-promo-regalo-envoltorio]');

      if (sentinel && envoltorio && 'IntersectionObserver' in window) {
        const reservarEspacio = () => {
          if (seccion.hasAttribute('data-fijada')) {
            seccion.style.minHeight = `${envoltorio.offsetHeight}px`;
          } else {
            seccion.style.minHeight = '';
          }
        };

        const observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              seccion.removeAttribute('data-fijada');
            } else {
              seccion.setAttribute('data-fijada', '');
            }
            reservarEspacio();
          },
          { root: null, threshold: 0 }
        );

        observer.observe(sentinel);
        window.addEventListener('resize', reservarEspacio, { passive: true });
      }
    }

    if (!seccion.hasAttribute('data-barra-promo-regalo-countdown')) return;

    const fechaFinTexto = seccion.dataset.fechaFin;
    const contenedor = seccion.querySelector('[data-barra-promo-regalo-countdown-contenedor]');
    const expirado = seccion.querySelector('[data-barra-promo-regalo-expirado]');
    const diasEl = seccion.querySelector('[data-barra-promo-regalo-dias]');
    const horasEl = seccion.querySelector('[data-barra-promo-regalo-horas]');
    const minutosEl = seccion.querySelector('[data-barra-promo-regalo-minutos]');
    const segundosEl = seccion.querySelector('[data-barra-promo-regalo-segundos]');

    if (!fechaFinTexto || !contenedor) return;

    const fechaFin = new Date(fechaFinTexto.replace(' ', 'T'));
    if (Number.isNaN(fechaFin.getTime())) return;

    const rellenar = (valor) => String(valor).padStart(2, '0');

    const actualizar = () => {
      const restante = fechaFin.getTime() - Date.now();

      if (restante <= 0) {
        contenedor.hidden = true;
        if (expirado) expirado.hidden = false;
        return;
      }

      const totalSegundos = Math.floor(restante / 1000);
      const dias = Math.floor(totalSegundos / 86400);
      const horas = Math.floor((totalSegundos % 86400) / 3600);
      const minutos = Math.floor((totalSegundos % 3600) / 60);
      const segundos = totalSegundos % 60;

      if (diasEl) diasEl.textContent = rellenar(dias);
      if (horasEl) horasEl.textContent = rellenar(horas);
      if (minutosEl) minutosEl.textContent = rellenar(minutos);
      if (segundosEl) segundosEl.textContent = rellenar(segundos);
    };

    actualizar();
    window.setInterval(actualizar, 1000);

    const botonScroll = seccion.querySelector('[data-barra-promo-regalo-scroll]');
    if (botonScroll) {
      botonScroll.addEventListener('click', () => {
        const producto = document.querySelector('[data-producto-regalo]');
        if (!producto) return;

        const reducido = respetarMovimiento && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        producto.scrollIntoView({ behavior: reducido ? 'auto' : 'smooth', block: 'start' });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["barra-urgencia"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const contenedor = document.querySelector('[data-barra-urgencia]');
    if (!contenedor) return;

    const lista = contenedor.querySelector('[data-barra-urgencia-lista]');
    const bloques = JSON.parse(contenedor.querySelector('[data-barra-urgencia-bloques]')?.textContent || '[]');
    const variantes = JSON.parse(contenedor.querySelector('[data-barra-urgencia-variantes]')?.textContent || '[]');
    const umbralBajo = Number(contenedor.dataset.umbralBajo) || 5;
    const umbralCritico = Number(contenedor.dataset.umbralCritico) || 2;
    const inventarioMax = Number(contenedor.dataset.inventarioMax) || 20;
    const reubicar = contenedor.dataset.reubicar === 'true';
    const enEditor = contenedor.dataset.editor === 'true';

    const iconos = {
      fuego: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 22c3.5-1.5 6-4.5 6-8.5 0-2.2-1-4.1-2.6-5.4C14.8 9.6 14 11.8 12 13c-2-1.2-2.8-3.4-3.4-4.1C7 11.4 6 13.3 6 15.5 6 17.7 7.2 20 9 21.2 9.8 21.7 10.8 22 12 22z"/></svg>',
      reloj: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20zm1-11V7h-2v7l5 3 .9-1.5-4.9-3z"/></svg>',
      alerta: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3 1 21h22L12 3zm0 6.5a1.25 1.25 0 0 1 1.25 1.25v4.5A1.25 1.25 0 0 1 12 16.5a1.25 1.25 0 0 1-1.25-1.25v-4.5A1.25 1.25 0 0 1 12 9.5zm0 9.25a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"/></svg>',
      agotado: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm4.3 13.7-1.4 1.4L12 13.4l-2.9 2.9-1.4-1.4 2.9-2.9-2.9-2.9 1.4-1.4 2.9 2.9 2.9-2.9 1.4 1.4-2.9 2.9 2.9 2.9z"/></svg>',
    };

    function inventarioGestionado(variante) {
      return variante.inventory_management === 'shopify';
    }

    function cantidadInventario(variante) {
      if (!inventarioGestionado(variante)) return null;
      return Math.max(0, Number(variante.inventory_quantity) || 0);
    }

    const tituloProducto = contenedor.dataset.productoTitulo || '';
    const textoVacioEditor = contenedor.dataset.textoVacioEditor || '';

    function reemplazarTokens(texto, variante) {
      const cantidad = cantidadInventario(variante);
      return (texto || '')
        .replace(/\[\[cantidad\]\]/g, cantidad == null ? '' : String(cantidad))
        .replace(/\[\[producto\]\]/g, tituloProducto);
    }

    function evaluarCondicion(bloque, variante) {
      const cantidad = cantidadInventario(variante);
      switch (bloque.condicion) {
        case 'agotado':
          return !variante.available;
        case 'stock_critico':
          return (
            variante.available &&
            cantidad != null &&
            cantidad > 0 &&
            cantidad <= umbralCritico
          );
        case 'stock_bajo':
          return (
            variante.available &&
            cantidad != null &&
            cantidad > umbralCritico &&
            cantidad <= umbralBajo
          );
        case 'siempre':
          return true;
        default:
          return false;
      }
    }

    function claseAlerta(condicion) {
      if (condicion === 'agotado') return 'barra-urgencia__alerta--agotado';
      if (condicion === 'stock_critico') return 'barra-urgencia__alerta--critico';
      return '';
    }

    function progresoPorcentaje(cantidad) {
      if (cantidad == null) return 0;
      const max = Math.max(inventarioMax, cantidad, 1);
      return Math.min(100, Math.round((cantidad / max) * 100));
    }

    function renderizarAlertas(variante) {
      if (!lista) return;

      const alertas = bloques.filter((bloque) => evaluarCondicion(bloque, variante));
      if (alertas.length === 0 && !enEditor) {
        contenedor.hidden = true;
        lista.innerHTML = '';
        return;
      }

      if (alertas.length === 0 && enEditor) {
        lista.innerHTML =
          '<div class="barra-urgencia__alerta"><p class="barra-urgencia__texto">' +
          textoVacioEditor +
          '</p></div>';
        contenedor.hidden = false;
        return;
      }

      const cantidad = cantidadInventario(variante);
      lista.innerHTML = alertas
        .map((bloque) => {
          const texto = reemplazarTokens(bloque.texto, variante);
          const icono = bloque.tipo_icono && bloque.tipo_icono !== 'ninguno' ? iconos[bloque.tipo_icono] || '' : '';
          const mostrarProgreso =
            bloque.mostrar_progreso &&
            cantidad != null &&
            bloque.condicion !== 'agotado' &&
            bloque.condicion !== 'siempre';
          const progresoHtml = mostrarProgreso
            ? `<div class="barra-urgencia__progreso" aria-hidden="true"><span class="barra-urgencia__progreso-relleno" style="width:${progresoPorcentaje(cantidad)}%;"></span></div>`
            : '';

          return `
            <article class="barra-urgencia__alerta ${claseAlerta(bloque.condicion)}">
              <div class="barra-urgencia__alerta-cuerpo">
                ${icono ? `<span class="barra-urgencia__icono">${icono}</span>` : ''}
                <p class="barra-urgencia__texto">${texto}</p>
              </div>
              ${progresoHtml}
            </article>
          `;
        })
        .join('');

      contenedor.hidden = false;
    }

    function reubicarEnPdp() {
      if (!reubicar) return;
      const ancla = document.querySelector('[data-barra-urgencia-ancla]');
      if (!ancla || ancla.contains(contenedor)) return;
      ancla.appendChild(contenedor);
    }

    function obtenerVarianteInicial() {
      const params = new URLSearchParams(window.location.search);
      const varianteId = Number(params.get('variant'));
      if (varianteId) {
        const encontrada = variantes.find((item) => Number(item.id) === varianteId);
        if (encontrada) return encontrada;
      }
      return variantes.find((item) => item.available) || variantes[0];
    }

    reubicarEnPdp();
    renderizarAlertas(obtenerVarianteInicial());

    document.addEventListener('producto:variante-cambiada', (evento) => {
      if (evento.detail?.variante) {
        renderizarAlertas(evento.detail.variante);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["busqueda-principal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const secciones = document.querySelectorAll('[data-busqueda-principal]');
    if (!secciones.length) return;

    secciones.forEach((seccion) => {
      const drawer = seccion.querySelector('[data-busqueda-principal-drawer]');
      const abrirBotones = seccion.querySelectorAll('[data-busqueda-principal-abrir-filtros]');
      const cerrarBotones = seccion.querySelectorAll('[data-busqueda-principal-cerrar-filtros]');
      const ordenSelect = seccion.querySelector('[data-busqueda-principal-orden-select]');
      const ordenFormulario = seccion.querySelector('[data-busqueda-principal-orden]');
      const grid = seccion.querySelector('[data-busqueda-principal-grid]');
      const densidadBotones = seccion.querySelectorAll('[data-busqueda-principal-densidad]');

      const abrirDrawer = () => {
        if (!drawer) return;
        drawer.hidden = false;
        if (window.NaiaUI) window.NaiaUI.bloquearScroll(drawer);
        else document.body.style.overflow = 'hidden';
        abrirBotones.forEach((boton) => boton.setAttribute('aria-expanded', 'true'));
        seccion.querySelector('[data-busqueda-principal-cerrar-filtros]')?.focus();
      };

      const cerrarDrawer = () => {
        if (!drawer) return;
        drawer.hidden = true;
        if (window.NaiaUI) window.NaiaUI.desbloquearScroll(drawer);
        else document.body.style.overflow = '';
        abrirBotones.forEach((boton) => boton.setAttribute('aria-expanded', 'false'));
      };

      abrirBotones.forEach((boton) => {
        boton.addEventListener('click', abrirDrawer);
      });

      cerrarBotones.forEach((boton) => {
        boton.addEventListener('click', cerrarDrawer);
      });

      document.addEventListener('keydown', (evento) => {
        if (evento.key === 'Escape' && drawer && !drawer.hidden) {
          cerrarDrawer();
        }
      });

      ordenSelect?.addEventListener('change', () => {
        ordenFormulario?.submit();
      });

      densidadBotones.forEach((boton) => {
        boton.addEventListener('click', () => {
          const columnas = boton.dataset.columnas;
          if (!columnas) return;

          seccion.style.setProperty('--busqueda-principal-columnas-escritorio', columnas);
          seccion.style.setProperty('--busqueda-principal-columnas-tablet', columnas);
          seccion.style.setProperty('--busqueda-principal-columnas-movil', columnas);

          densidadBotones.forEach((elemento) => {
            const activo = elemento === boton;
            elemento.classList.toggle('busqueda-principal__densidad-boton--activa', activo);
            elemento.setAttribute('aria-pressed', activo ? 'true' : 'false');
          });
        });
      });

      if (grid) {
        grid.id = grid.id || `busqueda-principal-grid-${seccion.id.replace('shopify-section-', '')}`;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cabecera"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const cabecera = document.querySelector('[data-cabecera]');
    if (!cabecera) return;

    const barra = cabecera.querySelector('[data-cabecera-barra]');
    const drawer = cabecera.querySelector('[data-cabecera-drawer]');
    const drawerPanel = cabecera.querySelector('[data-cabecera-drawer-panel]');
    const megaPanel = cabecera.querySelector('[data-cabecera-mega-panel]');
    const megaContenido = megaPanel ? megaPanel.querySelector('.cabecera__mega-contenido') : null;
    const umbral = Number(cabecera.dataset.umbralScroll || 80);
    const textoContadorMax = cabecera.dataset.textoContadorMax || '';
    let ultimoScroll = window.scrollY;
    let temporizadorMega = null;
    let focoAnterior = null;
    let manejarTabDrawer = null;
    let scrollPendiente = false;
    const megaMenuActivo = Boolean(megaPanel);
    const menuHocb = cabecera.classList.contains('cabecera--menu-hocb');
    const subnavAbreDrawer = cabecera.dataset.subnavAbreDrawer === 'true';
    const drawerRaiz = cabecera.querySelector('[data-cabecera-drawer-raiz]');
    const drawerDrillCabecera = cabecera.querySelector('[data-cabecera-drawer-drill-cabecera]');
    const drawerDrillTitulo = cabecera.querySelector('[data-cabecera-drawer-drill-titulo]');
    const drawerCuerpoWrap = cabecera.querySelector('[data-cabecera-drawer-cuerpo-wrap]');

    function resetDrawerRaiz() {
      if (!menuHocb) return;
      drawerRaiz?.removeAttribute('hidden');
      drawerDrillCabecera?.setAttribute('hidden', '');
      drawerCuerpoWrap?.setAttribute('hidden', '');
      drawerPanel?.removeAttribute('data-drill-activo');
      drawerRaiz?.querySelector('.cabecera__drawer-raiz-item')?.focus();
    }

    function abrirDrawerCategoria(pestanaId, titulo) {
      if (!menuHocb || !pestanaId) return;
      drawerRaiz?.setAttribute('hidden', '');
      drawerDrillCabecera?.removeAttribute('hidden');
      if (drawerDrillTitulo) drawerDrillTitulo.textContent = titulo || '';
      drawerCuerpoWrap?.removeAttribute('hidden');
      drawerPanel?.setAttribute('data-drill-activo', '');
      activarPestanaDrawer(pestanaId);
      marcarSubnavActiva(pestanaId);
      drawerDrillCabecera?.querySelector('[data-cabecera-drawer-volver]')?.focus();
    }

    function marcarSubnavActiva(pestanaId) {
      if (!subnavAbreDrawer) return;
      let enlaceActivo = null;
      cabecera.querySelectorAll('[data-cabecera-subnav-categoria]').forEach((enlace) => {
        const activo = enlace.dataset.pestana === pestanaId;
        if (activo) {
          enlace.setAttribute('aria-current', 'true');
          enlaceActivo = enlace;
        } else if (enlace.getAttribute('aria-current') === 'page') {
          /* mantener página de colección */
        } else {
          enlace.removeAttribute('aria-current');
        }
      });
      enlaceActivo?.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
    }

    function limpiarSubnavActiva() {
      cabecera.querySelectorAll('[data-cabecera-subnav-categoria]').forEach((enlace) => {
        if (enlace.getAttribute('aria-current') === 'page') return;
        enlace.removeAttribute('aria-current');
      });
    }

    function bloquearScroll(owner) {
      if (window.NaiaUI) window.NaiaUI.bloquearScroll(owner);
      else document.body.style.overflow = 'hidden';
    }

    function desbloquearScroll(owner) {
      if (window.NaiaUI) window.NaiaUI.desbloquearScroll(owner);
      else document.body.style.overflow = '';
    }

    const selectoresFoco =
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    function posicionarMega() {
      if (!megaContenido || !barra) return;
      const altoGrupo = document.getElementById('header-group');
      const offset = altoGrupo ? altoGrupo.offsetHeight : barra.getBoundingClientRect().bottom;
      megaContenido.style.top = `${offset}px`;
    }

    function atraparFoco(contenedor) {
      if (window.NaiaUI) {
        window.NaiaUI.atraparFoco(contenedor);
        return;
      }
      if (manejarTabDrawer) contenedor.removeEventListener('keydown', manejarTabDrawer);
      const elementos = Array.from(contenedor.querySelectorAll(selectoresFoco)).filter(
        (el) => !el.closest('[hidden]') && el.offsetParent !== null
      );
      if (!elementos.length) return;
      const primero = elementos[0];
      const ultimo = elementos[elementos.length - 1];
      primero.focus();
      manejarTabDrawer = function manejarTab(evento) {
        if (evento.key !== 'Tab') return;
        if (evento.shiftKey && document.activeElement === primero) {
          evento.preventDefault();
          ultimo.focus();
        } else if (!evento.shiftKey && document.activeElement === ultimo) {
          evento.preventDefault();
          primero.focus();
        }
      };
      contenedor.addEventListener('keydown', manejarTabDrawer);
    }

    function liberarFocoDrawer(contenedor) {
      if (window.NaiaUI) {
        window.NaiaUI.liberarFoco(contenedor);
        return;
      }
      if (manejarTabDrawer && contenedor) {
        contenedor.removeEventListener('keydown', manejarTabDrawer);
        manejarTabDrawer = null;
      }
    }

    function abrirDrawer(opciones) {
      const irACategoria = menuHocb && opciones && opciones.pestana;
      focoAnterior = document.activeElement;
      if (!irACategoria) {
        resetDrawerRaiz();
        limpiarSubnavActiva();
      }
      drawer.hidden = false;
      requestAnimationFrame(() => {
        drawer.setAttribute('data-abierto', '');
        cabecera.querySelector('[data-cabecera-abrir-drawer]').setAttribute('aria-expanded', 'true');
        bloquearScroll(drawer);
        if (irACategoria) {
          abrirDrawerCategoria(opciones.pestana, opciones.titulo || '');
        }
        atraparFoco(drawerPanel);
      });
    }

    function cerrarDrawer() {
      resetDrawerRaiz();
      limpiarSubnavActiva();
      drawer.removeAttribute('data-abierto');
      cabecera.querySelector('[data-cabecera-abrir-drawer]').setAttribute('aria-expanded', 'false');
      desbloquearScroll(drawer);
      liberarFocoDrawer(drawerPanel);
      window.setTimeout(() => {
        drawer.hidden = true;
      }, 280);
      if (focoAnterior) focoAnterior.focus();
    }

    function cerrarMega() {
      if (!megaPanel) return;
      megaPanel.removeAttribute('data-abierto');
      megaPanel.hidden = true;
      cabecera.querySelectorAll('[data-cabecera-mega-trigger]').forEach((item) => {
        item.removeAttribute('data-activo');
        item.querySelector('.cabecera__nav-disparador').setAttribute('aria-expanded', 'false');
      });
    }

    function abrirMega(pestanaId) {
      if (!megaPanel) return;
      posicionarMega();
      megaPanel.hidden = false;
      requestAnimationFrame(() => {
        megaPanel.setAttribute('data-abierto', '');
        activarPestanaMega(pestanaId);
        cabecera.querySelectorAll('[data-cabecera-mega-trigger]').forEach((item) => {
          const activo = item.dataset.pestana === pestanaId;
          item.toggleAttribute('data-activo', activo);
          item.querySelector('.cabecera__nav-disparador').setAttribute('aria-expanded', activo ? 'true' : 'false');
        });
      });
    }

    function activarPestanaMega(pestanaId) {
      cabecera.querySelectorAll('[data-cabecera-mega-tab]').forEach((tab) => {
        const activo = tab.dataset.pestana === pestanaId;
        tab.setAttribute('aria-selected', activo ? 'true' : 'false');
        tab.tabIndex = activo ? 0 : -1;
      });
      cabecera.querySelectorAll('[data-cabecera-mega-cuerpo]').forEach((panel) => {
        panel.hidden = panel.dataset.pestana !== pestanaId;
      });
    }

    function activarPestanaDrawer(pestanaId) {
      cabecera.querySelectorAll('[data-cabecera-drawer-tab]').forEach((tab) => {
        const activo = tab.dataset.pestana === pestanaId;
        tab.setAttribute('aria-selected', activo ? 'true' : 'false');
        tab.tabIndex = activo ? 0 : -1;
      });
      cabecera.querySelectorAll('.cabecera__drawer-panel-pestana[data-cabecera-drawer-cuerpo]').forEach((panel) => {
        panel.hidden = panel.dataset.pestana !== pestanaId;
      });
    }

    function actualizarCarrito(cantidad) {
      const contador = cabecera.querySelector('[data-cabecera-carrito-contador]');
      if (!contador) return;
      const valor = Number(cantidad || 0);
      contador.textContent = valor > 99 ? textoContadorMax : String(valor);
      contador.classList.toggle('cabecera__carrito-contador--vacio', valor <= 0);
    }

    function actualizarDeseos(cantidad) {
      const contador = cabecera.querySelector('[data-cabecera-deseos-contador]');
      if (!contador) return;
      const valor = Number(cantidad || 0);
      contador.textContent = valor > 99 ? textoContadorMax : String(valor);
      contador.classList.toggle('cabecera__deseos-contador--vacio', valor <= 0);
    }

    function raizScroll() {
      const wrapper = document.querySelector('.page-wrapper');
      if (wrapper) {
        const overflow = getComputedStyle(wrapper).overflowY;
        if (overflow === 'auto' || overflow === 'scroll') return wrapper;
      }
      return window;
    }

    function scrollActual() {
      const raiz = raizScroll();
      return raiz === window ? window.scrollY : raiz.scrollTop;
    }

    function actualizarCabeceraScroll() {
      scrollPendiente = false;
      const actual = scrollActual();
      if (actual <= 0) {
        cabecera.classList.remove('cabecera--oculta');
      } else if (actual > ultimoScroll && actual > umbral) {
        cabecera.classList.add('cabecera--oculta');
        if (megaMenuActivo) cerrarMega();
      } else if (actual < ultimoScroll) {
        cabecera.classList.remove('cabecera--oculta');
      }
      ultimoScroll = actual;
    }

    const onScrollCabecera = () => {
      if (scrollPendiente) return;
      scrollPendiente = true;
      requestAnimationFrame(actualizarCabeceraScroll);
    };

    window.addEventListener('scroll', onScrollCabecera, { passive: true });
    document.querySelector('.page-wrapper')?.addEventListener('scroll', onScrollCabecera, { passive: true });
    ultimoScroll = scrollActual();

    cabecera.querySelector('[data-cabecera-abrir-drawer]')?.addEventListener('click', abrirDrawer);
    cabecera.querySelectorAll('[data-cabecera-cerrar-drawer]').forEach((el) => {
      el.addEventListener('click', cerrarDrawer);
    });

    cabecera.querySelectorAll('[data-cabecera-drawer-abrir-categoria]').forEach((boton) => {
      boton.addEventListener('click', () => {
        abrirDrawerCategoria(boton.dataset.pestana, boton.dataset.titulo);
      });
    });
    cabecera.querySelector('[data-cabecera-drawer-volver]')?.addEventListener('click', () => {
      resetDrawerRaiz();
      limpiarSubnavActiva();
    });

    cabecera.querySelectorAll('[data-cabecera-subnav-categoria]').forEach((enlace) => {
      enlace.addEventListener('click', (evento) => {
        if (!subnavAbreDrawer) return;
        if (evento.metaKey || evento.ctrlKey || evento.shiftKey || evento.altKey || evento.button !== 0) return;
        evento.preventDefault();
        const { pestana, titulo } = enlace.dataset;
        if (drawer.hidden || !drawer.hasAttribute('data-abierto')) {
          abrirDrawer({ pestana, titulo });
        } else {
          abrirDrawerCategoria(pestana, titulo);
        }
      });
    });

    if (megaMenuActivo) {
      cabecera.querySelectorAll('[data-cabecera-mega-trigger]').forEach((item) => {
        const disparador = item.querySelector('.cabecera__nav-disparador');
        item.addEventListener('mouseenter', () => {
          window.clearTimeout(temporizadorMega);
          abrirMega(item.dataset.pestana);
        });
        item.addEventListener('mouseleave', () => {
          temporizadorMega = window.setTimeout(cerrarMega, 120);
        });
        disparador.addEventListener('focus', () => abrirMega(item.dataset.pestana));
        disparador.addEventListener('keydown', (evento) => {
          if (disparador.tagName === 'A') {
            if (evento.key === 'Escape') cerrarMega();
            return;
          }
          if (evento.key === 'Enter' || evento.key === ' ') {
            evento.preventDefault();
            abrirMega(item.dataset.pestana);
          }
          if (evento.key === 'Escape') cerrarMega();
        });
      });

      megaPanel.addEventListener('mouseenter', () => window.clearTimeout(temporizadorMega));
      megaPanel.addEventListener('mouseleave', () => {
        temporizadorMega = window.setTimeout(cerrarMega, 120);
      });
      megaPanel.querySelector('[data-cabecera-cerrar-mega]')?.addEventListener('click', cerrarMega);

      cabecera.querySelectorAll('[data-cabecera-mega-tab]').forEach((tab) => {
        tab.addEventListener('click', () => activarPestanaMega(tab.dataset.pestana));
        tab.addEventListener('keydown', (evento) => {
          const tabs = Array.from(cabecera.querySelectorAll('[data-cabecera-mega-tab]'));
          const indice = tabs.indexOf(tab);
          if (evento.key === 'ArrowRight') {
            evento.preventDefault();
            tabs[(indice + 1) % tabs.length].focus();
            activarPestanaMega(tabs[(indice + 1) % tabs.length].dataset.pestana);
          }
          if (evento.key === 'ArrowLeft') {
            evento.preventDefault();
            tabs[(indice - 1 + tabs.length) % tabs.length].focus();
            activarPestanaMega(tabs[(indice - 1 + tabs.length) % tabs.length].dataset.pestana);
          }
        });
      });

      window.addEventListener('resize', posicionarMega);
      posicionarMega();
    }

    cabecera.querySelectorAll('[data-cabecera-drawer-tab]').forEach((tab) => {
      tab.addEventListener('click', () => activarPestanaDrawer(tab.dataset.pestana));
    });

    if (menuHocb) {
      const acordeones = cabecera.querySelectorAll('.cabecera__drawer-acordeon');
      acordeones.forEach((detalle) => {
        detalle.addEventListener('toggle', () => {
          if (!detalle.open) return;
          acordeones.forEach((otro) => {
            if (otro !== detalle) otro.open = false;
          });
        });
      });
    }

    cabecera.querySelectorAll('[data-abrir-buscador]').forEach((boton) => {
      boton.addEventListener('click', () => {
        document.dispatchEvent(new CustomEvent('cabecera:abrir-buscador'));
      });
    });

    cabecera.querySelectorAll('[data-abrir-selector-pais]').forEach((boton) => {
      boton.addEventListener('click', () => {
        document.dispatchEvent(new CustomEvent('cabecera:abrir-selector-pais'));
      });
    });

    cabecera.querySelectorAll('[data-abrir-carrito-drawer]').forEach((enlace) => {
      enlace.addEventListener('click', (evento) => {
        evento.preventDefault();
        document.dispatchEvent(new CustomEvent('cabecera:abrir-carrito'));
      });
    });

    cabecera.querySelectorAll('[data-abrir-lista-deseos]').forEach((boton) => {
      boton.addEventListener('click', () => {
        document.dispatchEvent(new CustomEvent('cabecera:abrir-lista-deseos'));
      });
    });

    document.addEventListener('keydown', (evento) => {
      if (evento.key !== 'Escape') return;
      if (drawer.hasAttribute('data-abierto')) cerrarDrawer();
      if (megaMenuActivo && megaPanel.hasAttribute('data-abierto')) cerrarMega();
    });

    document.addEventListener('cart:updated', (evento) => {
      if (evento.detail && typeof evento.detail.itemCount === 'number') {
        actualizarCarrito(evento.detail.itemCount);
      }
    });

    document.addEventListener('lista-deseos:actualizado', (evento) => {
      if (evento.detail && typeof evento.detail.count === 'number') {
        actualizarDeseos(evento.detail.count);
      }
    });

    fetch('/cart.js')
      .then((respuesta) => respuesta.json())
      .then((carrito) => actualizarCarrito(carrito.item_count))
      .catch(() => {});

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carrito-drawer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const drawer = document.querySelector('[data-carrito-drawer]');
    if (!drawer) return;

    const panel = drawer.querySelector('[data-carrito-drawer-panel]');
    const pie = drawer.querySelector('[data-carrito-drawer-pie]');
    const titulo = drawer.querySelector('[data-carrito-drawer-titulo]');
    const vacioEl = drawer.querySelector('[data-carrito-drawer-vacio]');
    const listaEl = drawer.querySelector('[data-carrito-drawer-lista]');
    const subtotalFila = drawer.querySelector('[data-carrito-drawer-fila-subtotal]');
    const subtotalEl = drawer.querySelector('[data-carrito-drawer-subtotal]');
    const totalEl = drawer.querySelector('[data-carrito-drawer-total]');
    const feedback = drawer.querySelector('[data-carrito-drawer-feedback]');
    const envioGratis = drawer.querySelector('[data-carrito-drawer-envio-gratis]');
    const envioTexto = drawer.querySelector('[data-carrito-drawer-envio-texto]');
    const envioProgreso = drawer.querySelector('[data-carrito-drawer-envio-progreso]');
    const outfitEl = drawer.querySelector('[data-carrito-outfit]');

    const urlCambiar = drawer.dataset.urlCambiar;
    const urlCarrito = drawer.dataset.urlCarrito;
    const urlAnadir = drawer.dataset.urlAnadir || '/cart/add.js';
    const abrirTrasAnadir = drawer.dataset.abrirTrasAnadir === 'true';
    const textoSinImagen = drawer.dataset.textoSinImagen || '';
    const etiquetaVerProducto = drawer.dataset.etiquetaVerProducto || 'Ver producto:';
    const etiquetaDisminuir = drawer.dataset.etiquetaDisminuir || 'Disminuir cantidad';
    const etiquetaAumentar = drawer.dataset.etiquetaAumentar || 'Aumentar cantidad';
    const textoError = 'No hemos podido actualizar el carrito. Inténtalo de nuevo.';
    const textoActualizando = drawer.dataset.textoActualizando || 'Actualizando…';
    const textoEnvioRestante = drawer.dataset.textoEnvioRestante || '';
    const textoEnvioConseguido = drawer.dataset.textoEnvioConseguido || '';
    const mostrarEnvioGratis = drawer.dataset.mostrarEnvioGratis === 'true';
    const umbralEnvio = Number(drawer.dataset.umbralEnvio || 0);

    let focoAnterior = null;
    let manejarTab = null;
    let actualizando = false;

    const selectoresFoco =
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    const formatearPrecio = (centimos, ejemplo) => {
      const numero = Number(centimos) / 100;
      const muestra = ejemplo || '';
      const simbolo = muestra.replace(/[\d\s.,]/g, '').trim() || '€';
      const conDecimales = /\.\d{2}|,\d{2}/.test(muestra);
      const valor = conDecimales ? numero.toFixed(2).replace('.', ',') : Math.round(numero).toString();
      if (muestra.indexOf(simbolo) === 0) return `${simbolo}${valor}`;
      return `${valor} ${simbolo}`;
    };

    const ejemploPrecio = subtotalEl?.textContent?.trim() || totalEl?.textContent?.trim() || '';

    function elementosFoco(contenedor) {
      return Array.from(contenedor.querySelectorAll(selectoresFoco)).filter((el) => {
        if (el.closest('[hidden]')) return false;
        if (el.getAttribute('aria-hidden') === 'true') return false;
        if (el.getAttribute('tabindex') === '-1') return false;
        return true;
      });
    }

    function atraparFoco(contenedor) {
      if (manejarTab) contenedor.removeEventListener('keydown', manejarTab);

      manejarTab = function (evento) {
        if (evento.key !== 'Tab') return;
        const elementos = elementosFoco(contenedor);
        if (!elementos.length) return;
        const primero = elementos[0];
        const ultimo = elementos[elementos.length - 1];
        if (evento.shiftKey && document.activeElement === primero) {
          evento.preventDefault();
          ultimo.focus();
        } else if (!evento.shiftKey && document.activeElement === ultimo) {
          evento.preventDefault();
          primero.focus();
        }
      };

      contenedor.addEventListener('keydown', manejarTab);
    }

    function mostrarFeedback(texto, esError = false) {
      if (!feedback) return;
      feedback.hidden = false;
      feedback.textContent = texto;
      feedback.classList.toggle('carrito-drawer__feedback--error', esError);
    }

    function limpiarFeedback() {
      if (!feedback) return;
      feedback.hidden = true;
      feedback.textContent = '';
      feedback.classList.remove('carrito-drawer__feedback--error');
    }

    function actualizarTitulo(cantidad) {
      if (!titulo) return;
      if (cantidad <= 0) {
        titulo.textContent = 'Tu carrito';
        return;
      }
      const unidad = cantidad === 1 ? 'artículo' : 'artículos';
      titulo.textContent = `Tu carrito · ${cantidad} ${unidad}`;
    }

    function actualizarEnvioGratis(carrito) {
      if (!envioGratis) return;
      if (!mostrarEnvioGratis || !umbralEnvio || carrito.item_count <= 0) {
        envioGratis.hidden = true;
        return;
      }

      envioGratis.hidden = false;
      const umbralCentimos = umbralEnvio * 100;
      const restante = Math.max(0, umbralCentimos - carrito.total_price);
      const progreso = Math.min(100, Math.round((carrito.total_price * 100) / umbralCentimos));

      if (envioProgreso) envioProgreso.style.width = `${progreso}%`;

      if (envioTexto) {
        if (restante > 0) {
          const importe = formatearPrecio(restante, ejemploPrecio);
          envioTexto.textContent = textoEnvioRestante.replace('[[importe]]', importe);
          envioTexto.classList.remove('carrito-drawer__envio-texto--completo');
        } else {
          envioTexto.textContent = textoEnvioConseguido;
          envioTexto.classList.add('carrito-drawer__envio-texto--completo');
        }
      }
    }

    function crearLineaHtml(item) {
      const hayDescuento = Number(item.original_price) > Number(item.final_price);
      const varianteHtml =
        item.variant_title && item.variant_title !== 'Default Title'
          ? `<p class="carrito-drawer__linea-variante">${item.variant_title}</p>`
          : '';

      const imagenHtml = item.image
        ? `<img class="carrito-drawer__linea-imagen" src="${item.image}" alt="${item.product_title || ''}" loading="lazy" width="90" height="112">`
        : `<span class="carrito-drawer__linea-sin-imagen">${textoSinImagen}</span>`;

      const precioUnitario = formatearPrecio(item.final_price, ejemploPrecio);
      const precioUnitarioOriginal = formatearPrecio(item.original_price, ejemploPrecio);
      const precioLinea = formatearPrecio(item.final_line_price, ejemploPrecio);
      const precioHtml = hayDescuento
        ? `<span class="carrito-drawer__linea-precio-actual">${precioUnitario}</span><s class="carrito-drawer__linea-precio-tachado">${precioUnitarioOriginal}</s>`
        : `<span class="carrito-drawer__linea-precio-actual">${precioUnitario}</span>`;
      const loteHtml =
        Number(item.quantity) > 1
          ? `<span class="carrito-drawer__linea-precio-lote">${item.quantity} uds. · ${precioLinea}</span>`
          : '';
      const tituloProducto = item.product_title || '';

      return `
        <li class="carrito-drawer__linea" data-carrito-drawer-linea data-line-key="${item.key}">
          <a class="carrito-drawer__linea-imagen-enlace" href="${item.url}" aria-label="${etiquetaVerProducto} ${tituloProducto}">
            ${imagenHtml}
          </a>
          <div class="carrito-drawer__linea-info">
            <div class="carrito-drawer__linea-cabecera">
              <a class="carrito-drawer__linea-titulo" href="${item.url}">${tituloProducto}</a>
              <button type="button" class="carrito-drawer__linea-eliminar" data-carrito-drawer-eliminar data-line-key="${item.key}" aria-label="Eliminar ${tituloProducto}">Eliminar</button>
            </div>
            ${varianteHtml}
            <div class="carrito-drawer__linea-precio" data-carrito-drawer-linea-precio>${precioHtml}${loteHtml}</div>
            <div class="carrito-drawer__linea-acciones">
              <div class="carrito-drawer__cantidad">
                <button type="button" class="carrito-drawer__cantidad-boton" data-carrito-drawer-cantidad-menos data-line-key="${item.key}" aria-label="${etiquetaDisminuir}"><span aria-hidden="true">−</span></button>
                <input class="carrito-drawer__cantidad-input" type="number" min="0" value="${item.quantity}" data-carrito-drawer-cantidad data-line-key="${item.key}" readonly aria-label="Cantidad">
                <button type="button" class="carrito-drawer__cantidad-boton" data-carrito-drawer-cantidad-mas data-line-key="${item.key}" aria-label="${etiquetaAumentar}"><span aria-hidden="true">+</span></button>
              </div>
            </div>
          </div>
        </li>
      `;
    }

    function ocultarPie(oculto) {
      if (!pie) return;
      pie.hidden = oculto;
      pie.classList.toggle('carrito-drawer__pie--oculto', oculto);
    }

    function emitirCartUpdated(carrito) {
      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          detail: { itemCount: carrito.item_count, desdeDrawer: true },
        })
      );
    }

    function mostrarEstadoVacio() {
      drawer.classList.add('carrito-drawer--vacio');
      if (vacioEl) {
        vacioEl.hidden = false;
        vacioEl.setAttribute('aria-hidden', 'false');
      }
      if (listaEl) {
        listaEl.innerHTML = '';
        listaEl.hidden = true;
      }
      if (outfitEl) outfitEl.hidden = true;
      ocultarPie(true);
    }

    function mostrarEstadoConItems(carrito) {
      drawer.classList.remove('carrito-drawer--vacio');
      if (vacioEl) {
        vacioEl.hidden = true;
        vacioEl.setAttribute('aria-hidden', 'true');
      }
      if (listaEl) {
        listaEl.hidden = false;
        listaEl.innerHTML = carrito.items.map((item) => crearLineaHtml(item)).join('');
      }
      ocultarPie(false);

      if (subtotalEl) subtotalEl.textContent = formatearPrecio(carrito.items_subtotal_price, ejemploPrecio);
      if (totalEl) totalEl.textContent = formatearPrecio(carrito.total_price, ejemploPrecio);
      if (subtotalFila) {
        subtotalFila.hidden = carrito.items_subtotal_price === carrito.total_price;
      }
    }

    function clasificarTipoOutfit(handle, tipo) {
      const texto = `${handle || ''} ${tipo || ''}`.toLowerCase();
      if (/bota|botin|calzado|zapato|sandalia/.test(texto)) return 'calzado';
      if (/panuelo|bufanda|scarf|fular/.test(texto)) return 'panuelo';
      if (/accesorio|cintur|bolso|pendiente|collar|joya/.test(texto)) return 'accesorio';
      return 'prenda';
    }

    function puntuarOutfit(card, cartTipos, cartIds) {
      const id = String(card.dataset.productId || '');
      if (!id || cartIds.has(id)) return Number.NEGATIVE_INFINITY;
      let score = Number(card.dataset.prioridad || 0);
      const tipo = card.dataset.tipo || 'accesorio';
      if (cartTipos.has('prenda')) {
        if (tipo === 'panuelo') score += 30;
        if (tipo === 'calzado') score += 25;
        if (tipo === 'accesorio') score += 20;
      }
      if (cartTipos.has(tipo) && tipo !== 'prenda') score -= 15;
      return score;
    }

    function actualizarOutfit(carrito) {
      if (!outfitEl) return;
      if (!carrito || carrito.item_count <= 0) {
        outfitEl.hidden = true;
        return;
      }

      const cards = Array.from(outfitEl.querySelectorAll('[data-outfit-card]'));
      const cartIds = new Set((carrito.items || []).map((item) => String(item.product_id)));
      const cartTipos = new Set(
        (carrito.items || []).map((item) => clasificarTipoOutfit(item.handle, item.product_type))
      );
      const max = Math.min(4, Math.max(2, Number(outfitEl.dataset.maxOutfit || 4)));

      const ranked = cards
        .map((card) => ({ card, score: puntuarOutfit(card, cartTipos, cartIds) }))
        .filter((entry) => entry.score > Number.NEGATIVE_INFINITY)
        .sort((a, b) => b.score - a.score);

      cards.forEach((card) => {
        card.hidden = true;
      });

      const visibles = ranked.slice(0, max);
      visibles.forEach((entry) => {
        entry.card.hidden = false;
      });

      outfitEl.hidden = visibles.length === 0;
    }

    function varianteOutfit(card) {
      if (!card) return '';
      const select = card.querySelector('select[data-outfit-variante]');
      if (select) return select.value;
      const hidden = card.querySelector('input[data-outfit-variante]');
      return hidden ? hidden.value : '';
    }

    async function validarTarjetasOutfit() {
      if (!outfitEl) return;
      const cards = outfitEl.querySelectorAll('[data-outfit-card][data-handle]');
      for (const card of cards) {
        const handle = card.dataset.handle;
        if (!handle) continue;
        try {
          const respuesta = await fetch(`/products/${handle}.js`, { headers: { Accept: 'application/json' } });
          if (!respuesta.ok) {
            card.remove();
          }
        } catch (error) {
          /* mantener tarjeta si la red falla; no asumir 404 */
        }
      }
      const restantes = outfitEl.querySelectorAll('[data-outfit-card]:not([hidden])');
      if (restantes.length === 0) {
        outfitEl.hidden = true;
      }
    }

    async function anadirOutfit(card) {
      if (actualizando || !card) return;
      const variantId = Number(varianteOutfit(card));
      if (!variantId) {
        mostrarFeedback(textoError, true);
        return;
      }

      const boton = card.querySelector('[data-outfit-anadir]');
      actualizando = true;
      drawer.setAttribute('aria-busy', 'true');
      if (boton) boton.disabled = true;
      mostrarFeedback(textoActualizando);

      const controlador = new AbortController();
      const temporizador = window.setTimeout(() => controlador.abort(), 20000);

      try {
        const respuesta = await fetch(urlAnadir, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
          signal: controlador.signal,
        });
        const data = await respuesta.json();
        if (!respuesta.ok || data.status) {
          mostrarFeedback(data.description || data.message || textoError, true);
          return;
        }

        const item = data.items?.[0];
        if (item && String(item.variant_id) !== String(variantId)) {
          mostrarFeedback(textoError, true);
          return;
        }

        const carrito = await refrescarCarrito({ emitEvent: true });
        if (carrito) limpiarFeedback();
      } catch (error) {
        try {
          const carrito = await fetch(urlCarrito, { headers: { Accept: 'application/json' } }).then((r) => r.json());
          const linea = carrito?.items?.find((i) => String(i.variant_id) === String(variantId));
          if (linea) {
            await refrescarCarrito({ emitEvent: true });
            limpiarFeedback();
          } else {
            mostrarFeedback(textoError, true);
          }
        } catch (e2) {
          mostrarFeedback(textoError, true);
        }
      } finally {
        window.clearTimeout(temporizador);
        actualizando = false;
        drawer.removeAttribute('aria-busy');
        if (boton) boton.disabled = false;
      }
    }

    function renderizarCarrito(carrito) {
      actualizarTitulo(carrito.item_count);
      actualizarEnvioGratis(carrito);

      if (carrito.item_count <= 0) {
        mostrarEstadoVacio();
        return;
      }

      mostrarEstadoConItems(carrito);
      actualizarOutfit(carrito);
    }

    function refrescarCarrito({ emitEvent = false } = {}) {
      return fetch(urlCarrito, { headers: { Accept: 'application/json' } })
        .then((respuesta) => respuesta.json())
        .then((carrito) => {
          renderizarCarrito(carrito);
          if (emitEvent) emitirCartUpdated(carrito);
          return carrito;
        });
    }

    function abrirDrawer() {
      focoAnterior = document.activeElement;
      drawer.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(() => {
        drawer.setAttribute('data-abierto', '');
        if (window.NaiaUI) window.NaiaUI.bloquearScroll(drawer);
        else document.body.style.overflow = 'hidden';
        refrescarCarrito({ emitEvent: false }).finally(() => {
          const cerrar = drawer.querySelector('[data-carrito-drawer-cerrar]');
          if (cerrar) cerrar.focus();
          atraparFoco(panel);
        });
      });
    }

    function cerrarDrawer() {
      drawer.removeAttribute('data-abierto');
      drawer.setAttribute('aria-hidden', 'true');
      if (window.NaiaUI) {
        window.NaiaUI.desbloquearScroll(drawer);
        window.NaiaUI.liberarFoco(panel);
      } else document.body.style.overflow = '';
      limpiarFeedback();
      drawer.removeAttribute('aria-busy');
      window.setTimeout(() => {
        drawer.hidden = true;
      }, 300);
      if (focoAnterior) focoAnterior.focus();
    }

    function restaurarLinea(linea) {
      if (!linea) return;
      linea.classList.remove('carrito-drawer__linea--eliminando');
      linea.removeAttribute('aria-busy');
    }

    async function cambiarCantidad(lineKey, cantidad) {
      if (actualizando) return;
      const cantidadSegura = Math.max(0, Number(cantidad) || 0);
      const linea = drawer.querySelector(`[data-carrito-drawer-linea][data-line-key="${lineKey}"]`);

      actualizando = true;
      drawer.setAttribute('aria-busy', 'true');
      if (linea) {
        linea.classList.add('carrito-drawer__linea--eliminando');
        linea.setAttribute('aria-busy', 'true');
      }
      mostrarFeedback(textoActualizando);

      const controlador = new AbortController();
      const temporizador = window.setTimeout(() => controlador.abort(), 20000);

      try {
        const respuesta = await fetch(urlCambiar, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ id: lineKey, quantity: cantidadSegura }),
          signal: controlador.signal,
        });

        const carrito = await respuesta.json();

        if (!respuesta.ok || carrito.status) {
          mostrarFeedback(carrito.description || carrito.message || textoError, true);
          restaurarLinea(linea);
          return;
        }

        renderizarCarrito(carrito);
        emitirCartUpdated(carrito);
        limpiarFeedback();
      } catch (error) {
        mostrarFeedback(textoError, true);
        restaurarLinea(linea);
      } finally {
        window.clearTimeout(temporizador);
        actualizando = false;
        drawer.removeAttribute('aria-busy');
      }
    }

    drawer.addEventListener('click', (evento) => {
      const menos = evento.target.closest('[data-carrito-drawer-cantidad-menos]');
      if (menos && drawer.contains(menos)) {
        evento.preventDefault();
        const lineKey = menos.dataset.lineKey;
        const input = drawer.querySelector(`[data-carrito-drawer-cantidad][data-line-key="${lineKey}"]`);
        const cantidad = Math.max(0, Number(input?.value || 1) - 1);
        cambiarCantidad(lineKey, cantidad);
        return;
      }

      const mas = evento.target.closest('[data-carrito-drawer-cantidad-mas]');
      if (mas && drawer.contains(mas)) {
        evento.preventDefault();
        const lineKey = mas.dataset.lineKey;
        const input = drawer.querySelector(`[data-carrito-drawer-cantidad][data-line-key="${lineKey}"]`);
        const cantidad = Number(input?.value || 0) + 1;
        cambiarCantidad(lineKey, cantidad);
        return;
      }

      const eliminar = evento.target.closest('[data-carrito-drawer-eliminar]');
      if (eliminar && drawer.contains(eliminar)) {
        evento.preventDefault();
        cambiarCantidad(eliminar.dataset.lineKey, 0);
        return;
      }

      const anadirOutfitBtn = evento.target.closest('[data-outfit-anadir]');
      if (anadirOutfitBtn && drawer.contains(anadirOutfitBtn)) {
        evento.preventDefault();
        anadirOutfit(anadirOutfitBtn.closest('[data-outfit-card]'));
      }
    });

    drawer.addEventListener('change', (evento) => {
      const select = evento.target.closest('select[data-outfit-variante]');
      if (!select || !drawer.contains(select)) return;
      const card = select.closest('[data-outfit-card]');
      const option = select.selectedOptions[0];
      if (!card || !option) return;
      const precioEl = card.querySelector('[data-outfit-precio]');
      const imagen = card.querySelector('.carrito-drawer__outfit-imagen');
      if (precioEl && option.dataset.precioTexto) {
        precioEl.textContent = option.dataset.precioTexto;
      }
      if (imagen && option.dataset.imagen) {
        imagen.src = option.dataset.imagen;
      }
    });

    drawer.querySelectorAll('[data-carrito-drawer-cerrar]').forEach((boton) => {
      boton.addEventListener('click', cerrarDrawer);
    });

    document.addEventListener('cabecera:abrir-carrito', abrirDrawer);

    document.addEventListener('cart:updated', (evento) => {
      if (evento.detail?.desdeDrawer) return;
      if (!drawer.hasAttribute('data-abierto') && abrirTrasAnadir && evento.detail?.abrirDrawer) {
        abrirDrawer();
        return;
      }
      refrescarCarrito({ emitEvent: false }).catch(() => {});
    });

    void validarTarjetasOutfit().then(() => refrescarCarrito({ emitEvent: false }).catch(() => {}));

    document.addEventListener('keydown', (evento) => {
      if (evento.key === 'Escape' && drawer.hasAttribute('data-abierto')) {
        cerrarDrawer();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carrito-principal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const secciones = document.querySelectorAll('[data-carrito-principal]');
    if (!secciones.length) return;

    const formatearPrecio = (centimos, ejemplo) => {
      const numero = Number(centimos) / 100;
      const muestra = ejemplo || '';
      const simbolo = muestra.replace(/[\d\s.,]/g, '').trim() || '€';
      const conDecimales = /\.\d{2}|,\d{2}/.test(muestra);
      const valor = conDecimales ? numero.toFixed(2).replace('.', ',') : Math.round(numero).toString();
      if (muestra.indexOf(simbolo) === 0) return `${simbolo}${valor}`;
      return `${valor} ${simbolo}`;
    };

    secciones.forEach((seccion) => {
      const urlCambiar = seccion.dataset.urlCambiar;
      const feedback = seccion.querySelector('[data-carrito-principal-feedback]');
      const subtotalEl = seccion.querySelector('[data-carrito-principal-subtotal]');
      const totalEl = seccion.querySelector('[data-carrito-principal-total]');
      const contadorEl = seccion.querySelector('[data-carrito-principal-contador]');
      const textoError = seccion.dataset.textoError || '';
      const textoActualizando = seccion.dataset.textoActualizando || '';
      const ejemploPrecio = subtotalEl?.textContent?.trim() || totalEl?.textContent?.trim();

      const mostrarFeedback = (texto, esError = false) => {
        if (!feedback) return;
        feedback.hidden = false;
        feedback.textContent = texto;
        feedback.classList.toggle('carrito-principal__feedback--error', esError);
      };

      const limpiarFeedback = () => {
        if (!feedback) return;
        feedback.hidden = true;
        feedback.textContent = '';
        feedback.classList.remove('carrito-principal__feedback--error');
      };

      const actualizarTotales = (carrito) => {
        if (subtotalEl) subtotalEl.textContent = formatearPrecio(carrito.items_subtotal_price, ejemploPrecio);
        if (totalEl) totalEl.textContent = formatearPrecio(carrito.total_price, ejemploPrecio);
        if (contadorEl) contadorEl.textContent = String(carrito.item_count);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { itemCount: carrito.item_count } }));
      };

      const cambiarCantidad = async (lineKey, cantidad) => {
        const linea = seccion.querySelector(`[data-carrito-principal-linea][data-line-key="${lineKey}"]`);
        if (linea) linea.classList.add('carrito-principal__linea--eliminando');
        mostrarFeedback(textoActualizando);

        try {
          const respuesta = await fetch(urlCambiar, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({ id: lineKey, quantity: cantidad }),
          });

          const carrito = await respuesta.json();

          if (carrito.status) {
            mostrarFeedback(carrito.description || carrito.message || textoError, true);
            if (linea) linea.classList.remove('carrito-principal__linea--eliminando');
            return;
          }

          if (carrito.item_count === 0) {
            window.location.reload();
            return;
          }

          const item = carrito.items.find((elemento) => elemento.key === lineKey);

          if (!item || cantidad <= 0) {
            linea?.remove();
          } else if (linea) {
            linea.classList.remove('carrito-principal__linea--eliminando');
            const input = linea.querySelector('[data-carrito-principal-cantidad]');
            if (input) input.value = String(item.quantity);

            const precioLinea = linea.querySelector('[data-carrito-principal-linea-precio]');
            if (precioLinea) {
              const actual = formatearPrecio(item.final_line_price, ejemploPrecio);
              const original = formatearPrecio(item.original_line_price, ejemploPrecio);
              if (item.original_line_price > item.final_line_price) {
                precioLinea.innerHTML = `<span class="carrito-principal__linea-precio-actual">${actual}</span><s class="carrito-principal__linea-precio-tachado">${original}</s>`;
              } else {
                precioLinea.innerHTML = `<span class="carrito-principal__linea-precio-actual">${actual}</span>`;
              }
            }
          }

          actualizarTotales(carrito);
          limpiarFeedback();
        } catch (error) {
          mostrarFeedback(textoError, true);
          if (linea) linea.classList.remove('carrito-principal__linea--eliminando');
        }
      };

      seccion.addEventListener('click', (evento) => {
        const menos = evento.target.closest('[data-carrito-principal-cantidad-menos]');
        if (menos && seccion.contains(menos)) {
          evento.preventDefault();
          const lineKey = menos.dataset.lineKey;
          const input = seccion.querySelector(`[data-carrito-principal-cantidad][data-line-key="${lineKey}"]`);
          const cantidad = Math.max(0, Number(input?.value || 1) - 1);
          cambiarCantidad(lineKey, cantidad);
          return;
        }

        const mas = evento.target.closest('[data-carrito-principal-cantidad-mas]');
        if (mas && seccion.contains(mas)) {
          evento.preventDefault();
          const lineKey = mas.dataset.lineKey;
          const input = seccion.querySelector(`[data-carrito-principal-cantidad][data-line-key="${lineKey}"]`);
          const cantidad = Number(input?.value || 0) + 1;
          cambiarCantidad(lineKey, cantidad);
          return;
        }

        const eliminar = evento.target.closest('[data-carrito-principal-eliminar]');
        if (eliminar && seccion.contains(eliminar)) {
          evento.preventDefault();
          cambiarCantidad(eliminar.dataset.lineKey, 0);
        }
      });

      seccion.addEventListener('change', (evento) => {
        const input = evento.target.closest('[data-carrito-principal-cantidad]');
        if (!input || !seccion.contains(input)) return;
        const cantidad = Math.max(0, Number(input.value || 0));
        cambiarCantidad(input.dataset.lineKey, cantidad);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carrusel-productos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const seccion = document.querySelector('[data-carrusel-productos]');
    if (!seccion) return;

    const titulo = seccion.querySelector('[data-carrusel-productos-titulo]');
    const contadorValor = seccion.querySelector('[data-carrusel-productos-contador-valor]');
    const verTodo = seccion.querySelector('[data-carrusel-productos-ver-todo]');
    const paneles = Array.from(seccion.querySelectorAll('[data-carrusel-productos-panel]'));
    const pestanas = Array.from(seccion.querySelectorAll('[data-carrusel-productos-pestana]'));
    const btnAnterior = seccion.querySelector('[data-carrusel-productos-anterior]');
    const btnSiguiente = seccion.querySelector('[data-carrusel-productos-siguiente]');

    function panelActivo() {
      return paneles.find((panel) => !panel.hidden) || paneles[0];
    }

    function pistaActiva() {
      const panel = panelActivo();
      return panel ? panel.querySelector('[data-carrusel-productos-pista]') : null;
    }

    function actualizarCabecera(panel) {
      if (!panel) return;
      if (titulo && panel.dataset.titulo) titulo.textContent = panel.dataset.titulo;
      if (contadorValor && panel.dataset.contador) contadorValor.textContent = panel.dataset.contador;
      if (verTodo && panel.dataset.enlace) verTodo.href = panel.dataset.enlace;
    }

    function activarPanel(indice) {
      paneles.forEach((panel, i) => {
        panel.hidden = i !== indice;
      });
      pestanas.forEach((pestana, i) => {
        const activa = i === indice;
        pestana.classList.toggle('carrusel-productos__pestana--activa', activa);
        pestana.setAttribute('aria-selected', activa ? 'true' : 'false');
        pestana.tabIndex = activa ? 0 : -1;
      });
      actualizarCabecera(paneles[indice]);
      const pista = paneles[indice]?.querySelector('[data-carrusel-productos-pista]');
      if (pista) pista.scrollLeft = 0;
    }

    function desplazar(direccion) {
      const pista = pistaActiva();
      if (!pista) return;
      const item = pista.querySelector('.carrusel-productos__item');
      if (!item) return;
      const estilos = getComputedStyle(pista);
      const gap = parseFloat(estilos.columnGap || estilos.gap || '0') || 0;
      const distancia = item.getBoundingClientRect().width + gap;
      pista.scrollBy({ left: direccion * distancia, behavior: 'smooth' });
    }

    pestanas.forEach((pestana) => {
      pestana.addEventListener('click', () => activarPanel(Number(pestana.dataset.indice)));
      pestana.addEventListener('keydown', (evento) => {
        const indice = pestanas.indexOf(pestana);
        if (evento.key === 'ArrowRight') {
          evento.preventDefault();
          pestanas[(indice + 1) % pestanas.length].focus();
          activarPanel((indice + 1) % pestanas.length);
        }
        if (evento.key === 'ArrowLeft') {
          evento.preventDefault();
          pestanas[(indice - 1 + pestanas.length) % pestanas.length].focus();
          activarPanel((indice - 1 + pestanas.length) % pestanas.length);
        }
      });
    });

    btnAnterior?.addEventListener('click', () => desplazar(-1));
    btnSiguiente?.addEventListener('click', () => desplazar(1));

    paneles.forEach((panel) => {
      const pista = panel.querySelector('[data-carrusel-productos-pista]');
      if (!pista) return;
      pista.addEventListener('keydown', (evento) => {
        if (panel.hidden) return;
        if (evento.key === 'ArrowLeft') {
          evento.preventDefault();
          desplazar(-1);
        }
        if (evento.key === 'ArrowRight') {
          evento.preventDefault();
          desplazar(1);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coleccion-principal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const secciones = document.querySelectorAll('[data-coleccion-principal]');
    if (!secciones.length) return;

    secciones.forEach((seccion) => {
      const drawer = seccion.querySelector('[data-coleccion-principal-drawer]');
      const abrirBotones = seccion.querySelectorAll('[data-coleccion-principal-abrir-filtros]');
      const cerrarBotones = seccion.querySelectorAll('[data-coleccion-principal-cerrar-filtros]');
      const ordenSelect = seccion.querySelector('[data-coleccion-principal-orden-select]');
      const ordenFormulario = seccion.querySelector('[data-coleccion-principal-orden]');
      const grid = seccion.querySelector('[data-coleccion-principal-grid]');
      const densidadBotones = seccion.querySelectorAll('[data-coleccion-principal-densidad]');

      const abrirDrawer = () => {
        if (!drawer) return;
        drawer.hidden = false;
        if (window.NaiaUI) window.NaiaUI.bloquearScroll(drawer);
        else document.body.style.overflow = 'hidden';
        abrirBotones.forEach((boton) => boton.setAttribute('aria-expanded', 'true'));
        seccion.querySelector('[data-coleccion-principal-cerrar-filtros]')?.focus();
      };

      const cerrarDrawer = () => {
        if (!drawer) return;
        drawer.hidden = true;
        if (window.NaiaUI) window.NaiaUI.desbloquearScroll(drawer);
        else document.body.style.overflow = '';
        abrirBotones.forEach((boton) => boton.setAttribute('aria-expanded', 'false'));
      };

      abrirBotones.forEach((boton) => {
        boton.addEventListener('click', abrirDrawer);
      });

      cerrarBotones.forEach((boton) => {
        boton.addEventListener('click', cerrarDrawer);
      });

      document.addEventListener('keydown', (evento) => {
        if (evento.key === 'Escape' && drawer && !drawer.hidden) {
          cerrarDrawer();
        }
      });

      ordenSelect?.addEventListener('change', () => {
        ordenFormulario?.submit();
      });

      densidadBotones.forEach((boton) => {
        boton.addEventListener('click', () => {
          const columnas = boton.dataset.columnas;
          if (!columnas) return;

          seccion.style.setProperty('--coleccion-principal-columnas-escritorio', columnas);
          seccion.style.setProperty('--coleccion-principal-columnas-tablet', columnas);
          seccion.style.setProperty('--coleccion-principal-columnas-movil', columnas);

          densidadBotones.forEach((elemento) => {
            const activo = elemento === boton;
            elemento.classList.toggle('coleccion-principal__densidad-boton--activa', activo);
            elemento.setAttribute('aria-pressed', activo ? 'true' : 'false');
          });
        });
      });

      if (grid) {
        grid.id = grid.id || `coleccion-principal-grid-${seccion.id.replace('shopify-section-', '')}`;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["comparador-productos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const raiz = document.querySelector('[data-comparador-productos]');
    if (!raiz) return;

    const barra = raiz.querySelector('[data-comparador-barra]');
    const barraTitulo = raiz.querySelector('[data-comparador-barra-titulo]');
    const barraLista = raiz.querySelector('[data-comparador-barra-lista]');
    const modal = raiz.querySelector('[data-comparador-modal]');
    const modalPanel = raiz.querySelector('[data-comparador-modal-panel]');
    const tablaContenedor = raiz.querySelector('[data-comparador-tabla-contenedor]');
    const feedback = raiz.querySelector('[data-comparador-feedback]');

    const claveAlmacen = raiz.dataset.claveAlmacen || 'comparador-productos-horizon';
    const maxProductos = Number(raiz.dataset.maxProductos) || 3;
    const minProductos = Number(raiz.dataset.minProductos) || 2;
    const textoSinImagen = raiz.dataset.textoSinImagen || '';
    const textoDisponible = raiz.dataset.textoDisponible || '';
    const textoAgotado = raiz.dataset.textoAgotado || '';
    const etiquetaQuitar = raiz.dataset.etiquetaQuitar || '';
    const textoQuitar = raiz.dataset.textoQuitar || '';
    const etiquetaVerProducto = raiz.dataset.etiquetaVerProducto || '';
    const textoMaxAlcanzado = raiz.dataset.textoMaxAlcanzado || '';
    const textoMinRequerido = raiz.dataset.textoMinRequerido || '';
    const etiquetaPrecio = raiz.dataset.etiquetaFilaPrecio || '';
    const etiquetaDisponibilidad = raiz.dataset.etiquetaFilaDisponibilidad || '';
    const etiquetaMarca = raiz.dataset.etiquetaFilaMarca || '';
    const etiquetaTipo = raiz.dataset.etiquetaFilaTipo || '';
    const etiquetaOpciones = raiz.dataset.etiquetaFilaOpciones || '';
    const mostrarPrecio = raiz.dataset.mostrarPrecio === 'true';
    const mostrarDisponibilidad = raiz.dataset.mostrarDisponibilidad === 'true';
    const mostrarMarca = raiz.dataset.mostrarMarca === 'true';
    const mostrarTipo = raiz.dataset.mostrarTipo === 'true';
    const mostrarOpciones = raiz.dataset.mostrarOpciones === 'true';
    const textoCargando = raiz.dataset.textoCargando || '';
    const etiquetaColumnaProducto = raiz.dataset.etiquetaColumnaProducto || '';
    const tituloBarraBase = raiz.dataset.tituloBarra || barraTitulo?.textContent?.trim() || '';

    let items = [];
    let focoAnterior = null;

    function leerAlmacen() {
      try {
        const crudo = window.localStorage.getItem(claveAlmacen);
        items = crudo ? JSON.parse(crudo) : [];
        if (!Array.isArray(items)) items = [];
      } catch (error) {
        items = [];
      }
    }

    function guardarAlmacen() {
      window.localStorage.setItem(claveAlmacen, JSON.stringify(items));
      emitirActualizado();
      renderizarBarra();
    }

    function emitirActualizado() {
      document.dispatchEvent(
        new CustomEvent('comparador:actualizado', {
          detail: {
            count: items.length,
            ids: items.map((item) => String(item.id)),
          },
        })
      );
    }

    function formatearPrecio(importe, ejemplo) {
      if (!Number.isFinite(importe)) return '';
      const valor = importe / 100;
      if (ejemplo && /[€$£]/.test(ejemplo)) {
        const simbolo = ejemplo.match(/[€$£]/)?.[0] || '€';
        return `${valor.toFixed(2).replace('.', ',')} ${simbolo}`;
      }
      return valor.toFixed(2);
    }

    function productoDesdeDataset(elemento) {
      return {
        id: Number(elemento.dataset.productoId),
        handle: elemento.dataset.productoHandle || '',
        title: elemento.dataset.productoTitulo || '',
        url: elemento.dataset.productoUrl || '',
        image: elemento.dataset.productoImagen || '',
        price: Number(elemento.dataset.productoPrecio || 0),
        priceFormatted: elemento.dataset.productoPrecioFormateado || '',
        vendor: elemento.dataset.productoMarca || '',
        type: elemento.dataset.productoTipo || '',
        available: elemento.dataset.productoDisponible !== 'false',
        variantId: Number(elemento.dataset.varianteId || 0),
      };
    }

    function sincronizarBotonesToggle() {
      const ids = new Set(items.map((item) => String(item.id)));
      document.querySelectorAll('[data-comparador-toggle]').forEach((boton) => {
        const activo = ids.has(String(boton.dataset.productoId));
        boton.setAttribute('aria-pressed', activo ? 'true' : 'false');
        boton.classList.toggle('comparador-toggle--activo', activo);
      });
    }

    function renderizarBarra() {
      sincronizarBotonesToggle();

      if (!barra || !barraLista) return;

      if (items.length <= 0) {
        barra.hidden = true;
        barra.setAttribute('aria-hidden', 'true');
        barra.removeAttribute('data-visible');
        if (barraTitulo) {
          barraTitulo.textContent = tituloBarraBase.replace(/\[\[count\]\]/g, '0');
        }
        return;
      }

      barra.hidden = false;
      barra.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(() => barra.setAttribute('data-visible', ''));

      if (barraTitulo) {
        barraTitulo.textContent = tituloBarraBase.replace('[[count]]', String(items.length));
      }

      barraLista.innerHTML = items
        .map(
          (item) => `
          <li class="comparador-productos__barra-item">
            ${
              item.image
                ? `<img class="comparador-productos__barra-miniatura" src="${item.image}" alt="" width="36" height="44" loading="lazy">`
                : `<span class="comparador-productos__barra-miniatura" aria-hidden="true"></span>`
            }
            <span class="comparador-productos__barra-nombre">${item.title || ''}</span>
            <button type="button" class="comparador-productos__barra-quitar" data-comparador-quitar data-producto-id="${item.id}" aria-label="${etiquetaQuitar} ${item.title || ''}">×</button>
          </li>
        `
        )
        .join('');
    }

    function alternarProducto(producto) {
      if (!producto || !producto.id) return;

      const indice = items.findIndex((item) => String(item.id) === String(producto.id));
      if (indice >= 0) {
        items.splice(indice, 1);
        guardarAlmacen();
        return;
      }

      if (items.length >= maxProductos) {
        mostrarFeedback(textoMaxAlcanzado.replace('[[max]]', String(maxProductos)), true);
        window.setTimeout(limpiarFeedback, 2600);
        return;
      }

      items.push(producto);
      guardarAlmacen();
    }

    function quitarProducto(productoId) {
      items = items.filter((item) => String(item.id) !== String(productoId));
      guardarAlmacen();
      if (modal.hasAttribute('data-abierto')) {
        if (items.length >= minProductos) {
          renderizarTabla();
        } else {
          cerrarModal();
        }
      }
    }

    function limpiarTodo() {
      items = [];
      guardarAlmacen();
      cerrarModal();
    }

    function mostrarFeedback(mensaje, esError) {
      if (!feedback) return;
      feedback.hidden = false;
      feedback.textContent = mensaje;
      feedback.classList.toggle('comparador-productos__feedback--error', Boolean(esError));
    }

    function limpiarFeedback() {
      if (!feedback) return;
      feedback.hidden = true;
      feedback.textContent = '';
      feedback.classList.remove('comparador-productos__feedback--error');
    }

    async function obtenerProductoActualizado(item) {
      if (!item.handle) return item;
      try {
        const respuesta = await fetch(`/products/${item.handle}.js`, { headers: { Accept: 'application/json' } });
        const producto = await respuesta.json();
        const variante = producto.variants.find((v) => v.available) || producto.variants[0];
        const ejemplo = item.priceFormatted || '';
        return {
          ...item,
          title: producto.title,
          url: `/products/${producto.handle}`,
          image: producto.featured_image || item.image,
          price: variante ? variante.price : item.price,
          priceFormatted: variante ? formatearPrecio(variante.price, ejemplo) : item.priceFormatted,
          vendor: producto.vendor || item.vendor,
          type: producto.type || item.type,
          available: producto.available,
          variantId: variante ? variante.id : item.variantId,
          options: producto.options || [],
          optionNames: (producto.options || []).map((nombre, indice) => ({
            name: nombre,
            values: [
              ...new Set(
                producto.variants.map((variante) => variante[`option${indice + 1}`]).filter(Boolean)
              ),
            ],
          })),
        };
      } catch (error) {
        return item;
      }
    }

    function crearCeldaProducto(item) {
      const imagenHtml = item.image
        ? `<img class="comparador-productos__producto-imagen" src="${item.image}" alt="" width="140" height="175" loading="lazy">`
        : `<span class="comparador-productos__producto-imagen">${textoSinImagen}</span>`;

      return `
        <td class="comparador-productos__celda-producto">
          ${imagenHtml}
          <a class="comparador-productos__producto-titulo" href="${item.url}">${item.title || ''}</a>
          <a class="comparador-productos__producto-enlace" href="${item.url}">${etiquetaVerProducto}</a>
          <button type="button" class="comparador-productos__producto-quitar" data-comparador-quitar data-producto-id="${item.id}">${textoQuitar}</button>
        </td>
      `;
    }

    function crearFila(etiqueta, valores) {
      return `
        <tr>
          <th scope="row">${etiqueta}</th>
          ${valores.map((valor) => `<td>${valor}</td>`).join('')}
        </tr>
      `;
    }

    async function renderizarTabla() {
      if (!tablaContenedor) return;
      limpiarFeedback();

      if (items.length < minProductos) {
        mostrarFeedback(textoMinRequerido.replace('[[min]]', String(minProductos)), true);
        tablaContenedor.innerHTML = '';
        return;
      }

      tablaContenedor.innerHTML = `<p class="comparador-productos__feedback">${textoCargando}</p>`;

      const productos = await Promise.all(items.map((item) => obtenerProductoActualizado(item)));
      items = productos;
      window.localStorage.setItem(claveAlmacen, JSON.stringify(items));
      emitirActualizado();
      renderizarBarra();

      const filaProductos = `
        <tr>
          <th scope="row">${etiquetaColumnaProducto}</th>
          ${productos.map((item) => crearCeldaProducto(item)).join('')}
        </tr>
      `;

      let cuerpo = filaProductos;

      if (mostrarPrecio) {
        cuerpo += crearFila(
          etiquetaPrecio,
          productos.map((item) => item.priceFormatted || formatearPrecio(item.price, ''))
        );
      }

      if (mostrarDisponibilidad) {
        cuerpo += crearFila(
          etiquetaDisponibilidad,
          productos.map((item) => (item.available ? textoDisponible : textoAgotado))
        );
      }

      if (mostrarMarca) {
        cuerpo += crearFila(
          etiquetaMarca,
          productos.map((item) => item.vendor || '—')
        );
      }

      if (mostrarTipo) {
        cuerpo += crearFila(
          etiquetaTipo,
          productos.map((item) => item.type || '—')
        );
      }

      if (mostrarOpciones) {
        cuerpo += crearFila(
          etiquetaOpciones,
          productos.map((item) => {
            if (!item.optionNames || item.optionNames.length === 0) return '—';
            const lista = item.optionNames
              .map((opcion) => `<li><strong>${opcion.name}:</strong> ${opcion.values.join(', ')}</li>`)
              .join('');
            return `<ul class="comparador-productos__celda-opciones">${lista}</ul>`;
          })
        );
      }

      tablaContenedor.innerHTML = `<table class="comparador-productos__tabla"><tbody>${cuerpo}</tbody></table>`;
    }

    function atraparFoco(contenedor) {
      const elementos = contenedor.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      if (elementos.length === 0) return;
      const primero = elementos[0];
      const ultimo = elementos[elementos.length - 1];

      contenedor.addEventListener('keydown', function manejarTab(evento) {
        if (evento.key !== 'Tab') return;
        if (evento.shiftKey && document.activeElement === primero) {
          evento.preventDefault();
          ultimo.focus();
        } else if (!evento.shiftKey && document.activeElement === ultimo) {
          evento.preventDefault();
          primero.focus();
        }
      });
    }

    async function abrirModal() {
      if (items.length < minProductos) {
        mostrarFeedback(textoMinRequerido.replace('[[min]]', String(minProductos)), true);
        window.setTimeout(limpiarFeedback, 2600);
        return;
      }

      focoAnterior = document.activeElement;
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      await renderizarTabla();

      requestAnimationFrame(() => {
        modal.setAttribute('data-abierto', '');
        if (window.NaiaUI) window.NaiaUI.bloquearScroll(modal);
        else document.body.style.overflow = 'hidden';
        const cerrar = modal.querySelector('[data-comparador-cerrar]');
        if (cerrar) cerrar.focus();
        atraparFoco(modalPanel);
      });
    }

    function cerrarModal() {
      modal.removeAttribute('data-abierto');
      modal.setAttribute('aria-hidden', 'true');
      if (window.NaiaUI) window.NaiaUI.desbloquearScroll(modal);
      else document.body.style.overflow = '';
      limpiarFeedback();
      window.setTimeout(() => {
        modal.hidden = true;
      }, 300);
      if (focoAnterior) focoAnterior.focus();
    }

    raiz.querySelector('[data-comparador-limpiar]')?.addEventListener('click', limpiarTodo);
    raiz.querySelector('[data-comparador-abrir-modal]')?.addEventListener('click', abrirModal);

    raiz.querySelectorAll('[data-comparador-cerrar]').forEach((boton) => {
      boton.addEventListener('click', cerrarModal);
    });

    raiz.addEventListener('click', (evento) => {
      const quitar = evento.target.closest('[data-comparador-quitar]');
      if (quitar && raiz.contains(quitar)) {
        quitarProducto(quitar.dataset.productoId);
      }
    });

    document.addEventListener('click', (evento) => {
      const toggle = evento.target.closest('[data-comparador-toggle]');
      if (!toggle) return;
      evento.preventDefault();
      alternarProducto(productoDesdeDataset(toggle));
    });

    document.addEventListener('comparador:abrir', abrirModal);
    document.addEventListener('comparador:alternar', (evento) => {
      if (evento.detail?.producto) alternarProducto(evento.detail.producto);
    });

    document.addEventListener('keydown', (evento) => {
      if (evento.key === 'Escape' && modal.hasAttribute('data-abierto')) {
        cerrarModal();
      }
    });

    leerAlmacen();
    renderizarBarra();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["compartir-producto"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const contenedor = document.querySelector('[data-compartir-producto]');
    if (!contenedor) return;

    const reubicar = contenedor.dataset.reubicar === 'true';
    const url = contenedor.dataset.url || window.location.href;
    const titulo = contenedor.dataset.titulo || document.title;
    const feedback = contenedor.querySelector('[data-compartir-producto-feedback]');
    const botonCopiar = contenedor.querySelector('[data-compartir-producto-copiar]');
    const textoCopiar = contenedor.querySelector('[data-compartir-producto-copiar-texto]');
    const botonNativo = contenedor.querySelector('[data-compartir-producto-nativo]');

    const mostrarFeedback = (mensaje) => {
      if (!feedback) return;
      feedback.hidden = false;
      feedback.textContent = mensaje;
      window.clearTimeout(mostrarFeedback.temporizador);
      mostrarFeedback.temporizador = window.setTimeout(() => {
        feedback.hidden = true;
        feedback.textContent = '';
      }, 2600);
    };

    const reubicarEnPdp = () => {
      if (!reubicar) return;
      const ancla = document.querySelector('[data-compartir-producto-ancla]');
      if (!ancla || ancla.contains(contenedor)) return;
      ancla.appendChild(contenedor);
    };

    if (botonNativo && navigator.share) {
      botonNativo.hidden = false;
      botonNativo.addEventListener('click', async () => {
        try {
          await navigator.share({ title: titulo, url });
        } catch (error) {
          if (error?.name !== 'AbortError') {
            mostrarFeedback(contenedor.dataset.textoErrorCopiar || '');
          }
        }
      });
    }

    botonCopiar?.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(url);
        mostrarFeedback(contenedor.dataset.textoCopiado || '');
        if (textoCopiar) {
          const original = textoCopiar.textContent;
          textoCopiar.textContent = contenedor.dataset.textoCopiado || original;
          window.setTimeout(() => {
            textoCopiar.textContent = original;
          }, 2000);
        }
      } catch (error) {
        mostrarFeedback(contenedor.dataset.textoErrorCopiar || '');
      }
    });

    reubicarEnPdp();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["completa-el-look"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const seccion = document.querySelector('[data-completa-el-look]');
    if (!seccion) return;

    const urlAnadir = seccion.dataset.urlAnadir;
    const urlCarrito = seccion.dataset.urlCarrito;
    const textoAnadiendo = seccion.dataset.textoAnadiendo || '';
    const textoExito = seccion.dataset.textoExito || '';
    const textoError = seccion.dataset.textoError || '';
    const feedback = seccion.querySelector('[data-completa-look-feedback]');
    const botonTodo = seccion.querySelector('[data-completa-look-anadir-todo]');
    const items = seccion.querySelectorAll('[data-completa-look-item]');

    const mostrarFeedback = (mensaje, esError = false) => {
      if (!feedback) return;
      feedback.hidden = false;
      feedback.textContent = mensaje;
      feedback.classList.toggle('completa-el-look__feedback--error', esError);
    };

    const ocultarFeedback = () => {
      if (!feedback) return;
      feedback.hidden = true;
      feedback.textContent = '';
      feedback.classList.remove('completa-el-look__feedback--error');
    };

    const anadirVariante = async (varianteId) => {
      const respuesta = await fetch(urlAnadir, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ id: Number(varianteId), quantity: 1 }),
      });

      if (!respuesta.ok) {
        throw new Error('add_failed');
      }

      return respuesta.json();
    };

    const emitirCarritoActualizado = async () => {
      const carrito = await fetch(urlCarrito, { headers: { Accept: 'application/json' } }).then((r) => r.json());
      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          detail: { cart: carrito },
        })
      );
      return carrito;
    };

    const manejarAnadir = async (varianteId, boton) => {
      if (!varianteId) return;
      ocultarFeedback();
      const textoOriginal = boton?.textContent || '';
      if (boton) {
        boton.disabled = true;
        boton.textContent = textoAnadiendo;
      }

      try {
        await anadirVariante(varianteId);
        await emitirCarritoActualizado();
        mostrarFeedback(textoExito);
      } catch (error) {
        mostrarFeedback(textoError, true);
      } finally {
        if (boton) {
          boton.disabled = boton.dataset.disponible === 'false';
          boton.textContent = textoOriginal;
        }
      }
    };

    seccion.querySelectorAll('[data-completa-look-anadir-item]').forEach((boton) => {
      boton.addEventListener('click', () => {
        manejarAnadir(boton.dataset.varianteId, boton);
      });
    });

    botonTodo?.addEventListener('click', async () => {
      ocultarFeedback();
      const disponibles = Array.from(items).filter((item) => item.dataset.disponible === 'true');
      if (!disponibles.length) {
        mostrarFeedback(textoError, true);
        return;
      }

      const textoOriginal = botonTodo.textContent;
      botonTodo.disabled = true;
      botonTodo.textContent = textoAnadiendo;

      try {
        for (const item of disponibles) {
          await anadirVariante(item.dataset.varianteId);
        }
        await emitirCarritoActualizado();
        mostrarFeedback(textoExito);
      } catch (error) {
        mostrarFeedback(textoError, true);
      } finally {
        botonTodo.disabled = false;
        botonTodo.textContent = textoOriginal;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cta-guia-tallas"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const seccion = document.querySelector('[data-cta-guia-tallas]');
    if (!seccion) return;

    const reubicar = seccion.dataset.reubicar === 'true';

    const reubicarEnPdp = () => {
      if (!reubicar) return;
      const ancla = document.querySelector('[data-cta-guia-tallas-ancla]');
      if (!ancla || ancla.contains(seccion)) return;
      ancla.appendChild(seccion);
    };

    reubicarEnPdp();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cuenta-acceso"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const seccion = document.querySelector('[data-cuenta-acceso]');
    if (!seccion) return;

    const exito = seccion.querySelector('[data-cuenta-acceso-exito]');
    if (exito) exito.focus();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cuenta-direcciones"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const seccion = document.querySelector('[data-cuenta-direcciones]');
    if (!seccion) return;

    const formularioNuevo = seccion.querySelector('[data-cuenta-direcciones-formulario-nuevo]');
    const btnMostrarNueva = seccion.querySelector('[data-cuenta-direcciones-mostrar-nueva]');
    const btnCancelarNueva = seccion.querySelector('[data-cuenta-direcciones-cancelar-nueva]');

    if (btnMostrarNueva && formularioNuevo) {
      btnMostrarNueva.addEventListener('click', function () {
        formularioNuevo.hidden = false;
        btnMostrarNueva.hidden = true;
        seccion.querySelectorAll('[data-cuenta-direcciones-formulario-editar]').forEach(function (el) { el.hidden = true; });
      });
    }

    if (btnCancelarNueva && formularioNuevo && btnMostrarNueva) {
      btnCancelarNueva.addEventListener('click', function () {
        formularioNuevo.hidden = true;
        btnMostrarNueva.hidden = false;
      });
    }

    seccion.querySelectorAll('[data-cuenta-direcciones-editar]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const id = btn.getAttribute('data-cuenta-direcciones-editar');
        seccion.querySelectorAll('[data-cuenta-direcciones-formulario-editar]').forEach(function (el) { el.hidden = true; });
        const formulario = seccion.querySelector('[data-cuenta-direcciones-formulario-editar="' + id + '"]');
        if (formulario) formulario.hidden = false;
        if (formularioNuevo) formularioNuevo.hidden = true;
        if (btnMostrarNueva) btnMostrarNueva.hidden = false;
      });
    });

    if (typeof Shopify !== 'undefined' && Shopify.CountryProvinceSelector) {
      seccion.querySelectorAll('[data-cuenta-direcciones-pais]').forEach(function (selectPais) {
        const idPais = selectPais.id;
        const idProvincia = selectPais.getAttribute('data-provincia-id');
        if (idPais && idProvincia) {
          new Shopify.CountryProvinceSelector(idPais, idProvincia);
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-lookbook"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const seccion = document.querySelector('[data-editorial-lookbook]');
    if (!seccion) return;

    const cerrarPopovers = function (excepto) {
      seccion.querySelectorAll('[data-editorial-lookbook-hotspot]').forEach(function (hotspot) {
        if (excepto && hotspot === excepto) return;
        const boton = hotspot.querySelector('.editorial-lookbook__hotspot-boton');
        const popover = hotspot.querySelector('.editorial-lookbook__popover');
        if (!boton || !popover) return;
        popover.hidden = true;
        boton.setAttribute('aria-expanded', 'false');
      });
    };

    seccion.querySelectorAll('[data-editorial-lookbook-hotspot]').forEach(function (hotspot) {
      const boton = hotspot.querySelector('.editorial-lookbook__hotspot-boton');
      const popover = hotspot.querySelector('.editorial-lookbook__popover');
      const cerrar = hotspot.querySelector('[data-editorial-lookbook-cerrar-popover]');
      if (!boton || !popover) return;

      boton.addEventListener('click', function () {
        const abierto = !popover.hidden;
        cerrarPopovers(hotspot);
        popover.hidden = abierto;
        boton.setAttribute('aria-expanded', abierto ? 'false' : 'true');
      });

      if (cerrar) {
        cerrar.addEventListener('click', function () {
          popover.hidden = true;
          boton.setAttribute('aria-expanded', 'false');
          boton.focus();
        });
      }
    });

    document.addEventListener('click', function (evento) {
      if (!seccion.contains(evento.target)) {
        cerrarPopovers(null);
      }
    });

    document.addEventListener('keydown', function (evento) {
      if (evento.key === 'Escape') {
        cerrarPopovers(null);
      }
    });

    if (!seccion.hasAttribute('data-modo-carrusel')) return;

    const looks = Array.from(seccion.querySelectorAll('[data-editorial-lookbook-look]'));
    const indicadores = Array.from(seccion.querySelectorAll('[data-editorial-lookbook-indicador]'));
    const btnAnterior = seccion.querySelector('[data-editorial-lookbook-anterior]');
    const btnSiguiente = seccion.querySelector('[data-editorial-lookbook-siguiente]');
    const autoplay = seccion.getAttribute('data-autoplay') === 'true';
    const intervalo = parseInt(seccion.getAttribute('data-intervalo') || '6000', 10);
    let indiceActivo = 0;
    let temporizador = null;

    const mostrarLook = function (indice) {
      if (!looks.length) return;
      indiceActivo = (indice + looks.length) % looks.length;

      looks.forEach(function (look, i) {
        const activo = i === indiceActivo;
        look.hidden = !activo;
        look.setAttribute('aria-hidden', activo ? 'false' : 'true');
        look.classList.toggle('editorial-lookbook__look--activo', activo);
      });

      indicadores.forEach(function (indicador, i) {
        const activo = i === indiceActivo;
        indicador.classList.toggle('editorial-lookbook__indicador--activo', activo);
        indicador.setAttribute('aria-selected', activo ? 'true' : 'false');
        indicador.tabIndex = activo ? 0 : -1;
      });

      cerrarPopovers(null);
    };

    const reiniciarAutoplay = function () {
      if (!autoplay) return;
      if (temporizador) window.clearInterval(temporizador);
      temporizador = window.setInterval(function () {
        mostrarLook(indiceActivo + 1);
      }, intervalo);
    };

    if (btnAnterior) {
      btnAnterior.addEventListener('click', function () {
        mostrarLook(indiceActivo - 1);
        reiniciarAutoplay();
      });
    }

    if (btnSiguiente) {
      btnSiguiente.addEventListener('click', function () {
        mostrarLook(indiceActivo + 1);
        reiniciarAutoplay();
      });
    }

    indicadores.forEach(function (indicador) {
      indicador.addEventListener('click', function () {
        const indice = parseInt(indicador.getAttribute('data-indice') || '0', 10);
        mostrarLook(indice);
        reiniciarAutoplay();
      });

      indicador.addEventListener('keydown', function (evento) {
        if (evento.key === 'ArrowRight') {
          evento.preventDefault();
          mostrarLook(indiceActivo + 1);
          reiniciarAutoplay();
        }
        if (evento.key === 'ArrowLeft') {
          evento.preventDefault();
          mostrarLook(indiceActivo - 1);
          reiniciarAutoplay();
        }
      });
    });

    reiniciarAutoplay();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-drawer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const drawer = document.querySelector('[data-faq-drawer]');
    if (!drawer) return;
    const panel = drawer.querySelector('[data-faq-panel]');
    let focoAnterior = null;
    let closeTimer = null;

    function atraparFoco(contenedor) {
      if (window.NaiaUI) {
        window.NaiaUI.atraparFoco(contenedor);
        return;
      }
      const focusables = contenedor.querySelectorAll('button, [href], input, summary, [tabindex]:not([tabindex="-1"])');
      if (!focusables.length) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      first.focus();
      contenedor.addEventListener('keydown', (e) => {
        if (e.key !== 'Tab') return;
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      });
    }

    function abrirDrawer() {
      if (closeTimer) {
        window.clearTimeout(closeTimer);
        closeTimer = null;
      }
      focoAnterior = document.activeElement;
      drawer.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(() => {
        drawer.setAttribute('data-abierto', '');
        if (window.NaiaUI) window.NaiaUI.bloquearScroll(drawer);
        else document.body.style.overflow = 'hidden';
        const cerrar = drawer.querySelector('[data-faq-cerrar]');
        if (cerrar) cerrar.focus();
        atraparFoco(panel);
      });
    }

    function cerrarDrawer() {
      if (closeTimer) {
        window.clearTimeout(closeTimer);
        closeTimer = null;
      }
      drawer.removeAttribute('data-abierto');
      drawer.setAttribute('aria-hidden', 'true');
      if (window.NaiaUI) {
        window.NaiaUI.desbloquearScroll(drawer);
        window.NaiaUI.liberarFoco(panel);
      } else document.body.style.overflow = '';
      closeTimer = window.setTimeout(() => {
        closeTimer = null;
        if (!drawer.hasAttribute('data-abierto')) {
          drawer.hidden = true;
        }
      }, 300);
      if (focoAnterior) focoAnterior.focus();
    }

    drawer.querySelectorAll('[data-faq-cerrar]').forEach((b) => b.addEventListener('click', cerrarDrawer));

    document.querySelectorAll('[data-abrir-faq]').forEach((b) => {
      b.addEventListener('click', (e) => {
        e.preventDefault();
        abrirDrawer();
      });
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.hasAttribute('data-abierto')) cerrarDrawer();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grid-social"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const seccion = document.querySelector('[data-grid-social]');
    if (!seccion) return;

    const pista = seccion.querySelector('[data-grid-social-pista]');
    if (!pista) return;

    const btnAnterior = seccion.querySelector('[data-grid-social-anterior]');
    const btnSiguiente = seccion.querySelector('[data-grid-social-siguiente]');

    const desplazar = function (direccion) {
      const ancho = pista.clientWidth;
      if (!ancho) return;
      pista.scrollBy({ left: direccion * ancho * 0.85, behavior: 'smooth' });
    };

    if (btnAnterior) {
      btnAnterior.addEventListener('click', function () {
        desplazar(-1);
      });
    }

    if (btnSiguiente) {
      btnSiguiente.addEventListener('click', function () {
        desplazar(1);
      });
    }

    pista.addEventListener('keydown', function (evento) {
      if (evento.key === 'ArrowLeft') {
        evento.preventDefault();
        desplazar(-1);
      }

      if (evento.key === 'ArrowRight') {
        evento.preventDefault();
        desplazar(1);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["guia-tallas-drawer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const drawer = document.querySelector('[data-guia-tallas-drawer]');
    if (!drawer) return;

    const panel = drawer.querySelector('[data-guia-tallas-panel]');
    const pestanas = Array.from(drawer.querySelectorAll('[data-guia-tallas-pestana]'));
    const panelesTabla = Array.from(drawer.querySelectorAll('[data-guia-tallas-tabla-panel]'));
    const panelGenerico = drawer.querySelector('[data-guia-tallas-generica]');
    const panelProducto = drawer.querySelector('[data-guia-tallas-producto]');
    const subtituloEl = drawer.querySelector('[data-guia-tallas-subtitulo]');
    const subtituloDefault = subtituloEl?.textContent?.trim() || '';
    const guiasUrl = drawer.dataset.guiasProductoUrl || '';

    let focoAnterior = null;
    let guiasPorProducto = null;
    let guiasCarga = null;
    let closeTimer = null;

    function cargarGuiasProducto() {
      if (guiasPorProducto) return Promise.resolve(guiasPorProducto);
      if (!guiasUrl) return Promise.resolve({});
      if (!guiasCarga) {
        guiasCarga = fetch(guiasUrl)
          .then((res) => (res.ok ? res.json() : {}))
          .catch(() => ({}))
          .then((data) => {
            guiasPorProducto = data && typeof data === 'object' ? data : {};
            return guiasPorProducto;
          });
      }
      return guiasCarga;
    }

    function escaparHtml(texto) {
      return String(texto ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function renderGuiaProducto(guia) {
      if (!panelProducto || !guia) return;
      const filas = (guia.rows || [])
        .map(
          (fila) =>
            `<tr>${fila.map((celda) => `<td>${escaparHtml(celda)}</td>`).join('')}</tr>`
        )
        .join('');
      const encabezados = (guia.headers || [])
        .map((h) => `<th scope="col">${escaparHtml(h)}</th>`)
        .join('');

      panelProducto.innerHTML = `
        <h3 class="guia-tallas-drawer__producto-titulo">${escaparHtml(guia.title || '')}</h3>
        <p class="guia-tallas-drawer__unidad">${escaparHtml(guia.unitLabel || 'Medidas en cm')}</p>
        <div class="guia-tallas-drawer__tabla-scroll">
          <table class="guia-tallas-drawer__tabla">
            <caption class="guia-tallas-drawer__tabla-caption">${escaparHtml(guia.title || 'Guía de tallas')}</caption>
            <thead><tr>${encabezados}</tr></thead>
            <tbody>${filas}</tbody>
          </table>
        </div>
        ${guia.note ? `<p class="guia-tallas-drawer__nota">${escaparHtml(guia.note)}</p>` : ''}
      `;
    }

    function mostrarGuiaGenerica() {
      if (panelProducto) {
        panelProducto.hidden = true;
        panelProducto.innerHTML = '';
      }
      if (panelGenerico) panelGenerico.hidden = false;
      if (subtituloEl) {
        if (subtituloDefault) {
          subtituloEl.textContent = subtituloDefault;
          subtituloEl.hidden = false;
        } else {
          subtituloEl.hidden = true;
        }
      }
    }

    async function prepararContenido(handle) {
      const guias = await cargarGuiasProducto();
      const guia = handle && guias[handle] ? guias[handle] : null;
      if (guia) {
        renderGuiaProducto(guia);
        if (panelProducto) panelProducto.hidden = false;
        if (panelGenerico) panelGenerico.hidden = true;
        if (subtituloEl && guia.title) {
          subtituloEl.textContent = guia.title;
          subtituloEl.hidden = false;
        }
        return;
      }
      mostrarGuiaGenerica();
    }

    function handleDesdeBoton(boton) {
      if (!boton) return '';
      if (boton.dataset.productoHandle) return boton.dataset.productoHandle;
      const principal = boton.closest('[data-producto-principal]');
      return principal?.dataset?.productoHandle || '';
    }

    const selectoresFoco =
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    function atraparFoco(contenedor) {
      const elementos = Array.from(contenedor.querySelectorAll(selectoresFoco)).filter(
        (el) => !el.closest('[hidden]')
      );
      if (!elementos.length) return;

      const primero = elementos[0];
      const ultimo = elementos[elementos.length - 1];

      contenedor.addEventListener('keydown', function manejarTab(evento) {
        if (evento.key !== 'Tab') return;
        if (evento.shiftKey && document.activeElement === primero) {
          evento.preventDefault();
          ultimo.focus();
        } else if (!evento.shiftKey && document.activeElement === ultimo) {
          evento.preventDefault();
          primero.focus();
        }
      });
    }

    function activarPestana(indice) {
      pestanas.forEach((pestana, i) => {
        const activa = i === indice;
        pestana.classList.toggle('guia-tallas-drawer__pestana--activa', activa);
        pestana.setAttribute('aria-selected', activa ? 'true' : 'false');
        pestana.tabIndex = activa ? 0 : -1;
      });

      panelesTabla.forEach((panelTabla, i) => {
        const activo = i === indice;
        panelTabla.hidden = !activo;
        panelTabla.classList.toggle('guia-tallas-drawer__tabla-panel--activa', activo);
      });
    }

    function abrirDrawer(handle) {
      if (closeTimer) {
        window.clearTimeout(closeTimer);
        closeTimer = null;
      }
      focoAnterior = document.activeElement;
      drawer.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(() => {
        drawer.setAttribute('data-abierto', '');
        if (window.NaiaUI) window.NaiaUI.bloquearScroll(drawer);
        else document.body.style.overflow = 'hidden';
        const cerrar = drawer.querySelector('[data-guia-tallas-cerrar]');
        if (cerrar) cerrar.focus();
        atraparFoco(panel);
      });
    }

    function cerrarDrawer() {
      if (closeTimer) {
        window.clearTimeout(closeTimer);
        closeTimer = null;
      }
      drawer.removeAttribute('data-abierto');
      drawer.setAttribute('aria-hidden', 'true');
      if (window.NaiaUI) window.NaiaUI.desbloquearScroll(drawer);
      else document.body.style.overflow = '';
      closeTimer = window.setTimeout(() => {
        closeTimer = null;
        if (!drawer.hasAttribute('data-abierto')) {
          drawer.hidden = true;
        }
      }, 300);
      if (focoAnterior) focoAnterior.focus();
    }

    drawer.querySelectorAll('[data-guia-tallas-cerrar]').forEach((boton) => {
      boton.addEventListener('click', cerrarDrawer);
    });

    pestanas.forEach((pestana) => {
      pestana.addEventListener('click', () => activarPestana(Number(pestana.dataset.indice)));
      pestana.addEventListener('keydown', (evento) => {
        const indice = pestanas.indexOf(pestana);
        if (evento.key === 'ArrowRight') {
          evento.preventDefault();
          const siguiente = (indice + 1) % pestanas.length;
          pestanas[siguiente].focus();
          activarPestana(siguiente);
        }
        if (evento.key === 'ArrowLeft') {
          evento.preventDefault();
          const anterior = (indice - 1 + pestanas.length) % pestanas.length;
          pestanas[anterior].focus();
          activarPestana(anterior);
        }
      });
    });

    document.addEventListener('producto:abrir-guia-tallas', (evento) => {
      const handle = evento.detail?.handle || '';
      prepararContenido(handle).then(() => abrirDrawer(handle));
    });

    document.querySelectorAll('[data-abrir-guia-tallas]').forEach((boton) => {
      boton.addEventListener('click', (evento) => {
        evento.preventDefault();
        const handle = handleDesdeBoton(boton);
        prepararContenido(handle).then(() => abrirDrawer(handle));
      });
    });

    document.addEventListener('keydown', (evento) => {
      if (evento.key === 'Escape' && drawer.hasAttribute('data-abierto')) {
        cerrarDrawer();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["guia-tallas-pagina"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const seccion = document.querySelector('[data-guia-tallas-pagina]');
    if (!seccion) return;

    const pestanas = Array.from(seccion.querySelectorAll('[data-guia-tallas-pestana]'));
    const panelesTabla = Array.from(seccion.querySelectorAll('[data-guia-tallas-tabla-panel]'));
    if (!pestanas.length) return;

    function activarPestana(indice) {
      pestanas.forEach((pestana, i) => {
        const activa = i === indice;
        pestana.classList.toggle('guia-tallas-drawer__pestana--activa', activa);
        pestana.setAttribute('aria-selected', activa ? 'true' : 'false');
        pestana.tabIndex = activa ? 0 : -1;
      });

      panelesTabla.forEach((panelTabla, i) => {
        const activo = i === indice;
        panelTabla.hidden = !activo;
        panelTabla.classList.toggle('guia-tallas-drawer__tabla-panel--activa', activo);
      });
    }

    pestanas.forEach((pestana) => {
      pestana.addEventListener('click', () => activarPestana(Number(pestana.dataset.indice)));
      pestana.addEventListener('keydown', (evento) => {
        const indice = pestanas.indexOf(pestana);
        if (evento.key === 'ArrowRight') {
          evento.preventDefault();
          const siguiente = (indice + 1) % pestanas.length;
          pestanas[siguiente].focus();
          activarPestana(siguiente);
        }
        if (evento.key === 'ArrowLeft') {
          evento.preventDefault();
          const anterior = (indice - 1 + pestanas.length) % pestanas.length;
          pestanas[anterior].focus();
          activarPestana(anterior);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const seccion = document.querySelector('[data-hero-video]');
    if (!seccion || seccion.dataset.modoCarrusel !== 'true') return;

    const pista = seccion.querySelector('[data-hero-video-pista]');
    const diapositivas = Array.from(seccion.querySelectorAll('.hero-video__diapositiva'));
    const puntos = Array.from(seccion.querySelectorAll('[data-hero-video-punto]'));
    const btnAnterior = seccion.querySelector('[data-hero-video-anterior]');
    const btnSiguiente = seccion.querySelector('[data-hero-video-siguiente]');

    if (diapositivas.length <= 1) return;

    let indice = 0;
    let temporizador = null;
    const autoplay = seccion.dataset.autoplay === 'true';
    const intervalo = Number(seccion.dataset.intervalo || 6000);
    const pausaHover = seccion.dataset.pausaHover === 'true';
    const movimientoReducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function irA(nuevoIndice) {
      indice = (nuevoIndice + diapositivas.length) % diapositivas.length;
      pista.style.transform = `translate3d(-${indice * 100}%, 0, 0)`;
      puntos.forEach((punto, i) => {
        const activo = i === indice;
        punto.classList.toggle('hero-video__punto--activo', activo);
        punto.setAttribute('aria-selected', activo ? 'true' : 'false');
      });
      diapositivas.forEach((slide, i) => {
        slide.hidden = i !== indice;
        slide.setAttribute('aria-hidden', i === indice ? 'false' : 'true');
      });
      reiniciarAutoplay();
    }

    function reiniciarAutoplay() {
      window.clearInterval(temporizador);
      if (!autoplay || movimientoReducido) return;
      temporizador = window.setInterval(() => irA(indice + 1), intervalo);
    }

    btnAnterior?.addEventListener('click', () => irA(indice - 1));
    btnSiguiente?.addEventListener('click', () => irA(indice + 1));
    puntos.forEach((punto) => {
      punto.addEventListener('click', () => irA(Number(punto.dataset.indice)));
    });

    seccion.addEventListener('keydown', (evento) => {
      if (evento.key === 'ArrowLeft') irA(indice - 1);
      if (evento.key === 'ArrowRight') irA(indice + 1);
    });

    if (pausaHover) {
      seccion.addEventListener('mouseenter', () => window.clearInterval(temporizador));
      seccion.addEventListener('mouseleave', reiniciarAutoplay);
    }

    diapositivas.forEach((slide, i) => {
      slide.hidden = i !== 0;
      slide.setAttribute('aria-hidden', i === 0 ? 'false' : 'true');
      slide.tabIndex = i === 0 ? 0 : -1;
    });

    seccion.tabIndex = 0;
    reiniciarAutoplay();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lista-deseos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const drawer = document.querySelector('[data-lista-deseos]');
    if (!drawer) return;

    const panel = drawer.querySelector('[data-lista-deseos-panel]');
    const contenido = drawer.querySelector('[data-lista-deseos-contenido]');
    const tituloEl = drawer.querySelector('[data-lista-deseos-titulo]');
    const feedback = drawer.querySelector('[data-lista-deseos-feedback]');
    const vacioHtml = drawer.querySelector('[data-lista-deseos-vacio]')?.outerHTML || '';

    const claveAlmacen = drawer.dataset.claveAlmacen || 'lista-deseos-horizon';
    const urlAnadir = drawer.dataset.urlAnadir;
    const urlCarrito = drawer.dataset.urlCarrito;
    const tituloConContador = drawer.dataset.tituloConContador || '';
    const tituloVacio = drawer.dataset.tituloVacio || '';
    const textoSinImagen = drawer.dataset.textoSinImagen || '';
    const etiquetaVerProducto = drawer.dataset.etiquetaVerProducto || '';
    const etiquetaEliminar = drawer.dataset.etiquetaEliminar || '';
    const textoEliminar = drawer.dataset.textoEliminar || '';
    const etiquetaAnadirCarrito = drawer.dataset.etiquetaAnadirCarrito || '';
    const textoAnadiendo = drawer.dataset.textoAnadiendo || '';
    const textoAnadido = drawer.dataset.textoAnadido || '';
    const textoErrorCarrito = drawer.dataset.textoErrorCarrito || '';
    const textoContadorMax = drawer.dataset.textoContadorMaximo || '99+';
    const abrirTrasAnadir = drawer.dataset.abrirTrasAnadir === 'true';
    const mostrarToastTrasAnadir = drawer.dataset.mostrarToastTrasAnadir === 'true';

    let focoAnterior = null;
    let items = [];

    function leerAlmacen() {
      try {
        const crudo = window.localStorage.getItem(claveAlmacen);
        items = crudo ? JSON.parse(crudo) : [];
        if (!Array.isArray(items)) items = [];
      } catch (error) {
        items = [];
      }
    }

    function guardarAlmacen() {
      window.localStorage.setItem(claveAlmacen, JSON.stringify(items));
      emitirActualizado();
      renderizarLista();
    }

    function emitirActualizado() {
      document.dispatchEvent(
        new CustomEvent('lista-deseos:actualizado', {
          detail: {
            count: items.length,
            ids: items.map((item) => String(item.id)),
          },
        })
      );
    }

    function actualizarTitulo() {
      if (!tituloEl) return;
      if (items.length <= 0) {
        tituloEl.textContent = tituloVacio;
        return;
      }
      const contador = items.length > 99 ? textoContadorMax : String(items.length);
      tituloEl.textContent = tituloConContador.replace('[[count]]', contador);
    }

    function sincronizarBotonesToggle() {
      const ids = new Set(items.map((item) => String(item.id)));
      document.querySelectorAll('[data-lista-deseos-toggle]').forEach((boton) => {
        const activo = ids.has(String(boton.dataset.productoId));
        boton.setAttribute('aria-pressed', activo ? 'true' : 'false');
        boton.classList.toggle('lista-deseos-toggle--activo', activo);
      });
    }

    function crearLineaHtml(item) {
      const imagenHtml = item.image
        ? `<img class="lista-deseos__linea-imagen" src="${item.image}" alt="" width="96" height="120" loading="lazy">`
        : `<span class="lista-deseos__linea-sin-imagen">${textoSinImagen}</span>`;

      const deshabilitado = item.available === false ? 'disabled' : '';

      return `
        <li class="lista-deseos__linea" data-lista-deseos-linea data-producto-id="${item.id}">
          <a class="lista-deseos__linea-imagen-enlace" href="${item.url}" aria-label="${etiquetaVerProducto} ${item.title || ''}">
            ${imagenHtml}
          </a>
          <div class="lista-deseos__linea-info">
            <div class="lista-deseos__linea-cabecera">
              <a class="lista-deseos__linea-titulo" href="${item.url}">${item.title || ''}</a>
              <button type="button" class="lista-deseos__linea-eliminar" data-lista-deseos-quitar data-producto-id="${item.id}" aria-label="${etiquetaEliminar} ${item.title || ''}">${textoEliminar}</button>
            </div>
            <div class="lista-deseos__linea-precio">${item.priceFormatted || ''}</div>
            <div class="lista-deseos__linea-acciones">
              <button type="button" class="lista-deseos__boton-carrito" data-lista-deseos-anadir-carrito data-producto-id="${item.id}" ${deshabilitado}>${etiquetaAnadirCarrito}</button>
            </div>
          </div>
        </li>
      `;
    }

    function renderizarLista() {
      actualizarTitulo();
      sincronizarBotonesToggle();

      if (items.length <= 0) {
        drawer.classList.add('lista-deseos--vacio');
        contenido.innerHTML = vacioHtml;
        return;
      }

      drawer.classList.remove('lista-deseos--vacio');
      const listaHtml = items.map((item) => crearLineaHtml(item)).join('');
      contenido.innerHTML = `<ul class="lista-deseos__lista" role="list" data-lista-deseos-lista>${listaHtml}</ul>`;
    }

    function mostrarFeedback(mensaje, esError) {
      if (!feedback) return;
      feedback.hidden = false;
      feedback.textContent = mensaje;
      feedback.classList.toggle('lista-deseos__feedback--error', Boolean(esError));
    }

    function limpiarFeedback() {
      if (!feedback) return;
      feedback.hidden = true;
      feedback.textContent = '';
      feedback.classList.remove('lista-deseos__feedback--error');
    }

    function productoDesdeDataset(elemento) {
      return {
        id: Number(elemento.dataset.productoId),
        handle: elemento.dataset.productoHandle || '',
        title: elemento.dataset.productoTitulo || '',
        url: elemento.dataset.productoUrl || '',
        image: elemento.dataset.productoImagen || '',
        price: Number(elemento.dataset.productoPrecio || 0),
        priceFormatted: elemento.dataset.productoPrecioFormateado || '',
        variantId: Number(elemento.dataset.varianteId || 0),
        available: elemento.dataset.productoDisponible !== 'false',
      };
    }

    function alternarProducto(producto) {
      if (!producto || !producto.id) return;
      const indice = items.findIndex((item) => String(item.id) === String(producto.id));
      if (indice >= 0) {
        items.splice(indice, 1);
      } else {
        items.unshift(producto);
      }
      guardarAlmacen();
    }

    function quitarProducto(productoId) {
      items = items.filter((item) => String(item.id) !== String(productoId));
      guardarAlmacen();
    }

    function atraparFoco(contenedor) {
      const elementos = contenedor.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      if (elementos.length === 0) return;
      const primero = elementos[0];
      const ultimo = elementos[elementos.length - 1];

      contenedor.addEventListener('keydown', function manejarTab(evento) {
        if (evento.key !== 'Tab') return;
        if (evento.shiftKey && document.activeElement === primero) {
          evento.preventDefault();
          ultimo.focus();
        } else if (!evento.shiftKey && document.activeElement === ultimo) {
          evento.preventDefault();
          primero.focus();
        }
      });
    }

    async function refrescarItemsDesdeServidor() {
      if (!items.length) return;
      const siguientes = [];
      let huboCambios = false;
      for (const item of items) {
        if (!item.handle) {
          siguientes.push(item);
          continue;
        }
        try {
          const respuesta = await fetch(`/products/${item.handle}.js`, { headers: { Accept: 'application/json' } });
          if (!respuesta.ok) {
            huboCambios = true;
            continue;
          }
          const producto = await respuesta.json();
          const hayStock = (producto.variants || []).some((v) => v.available);
          const variante = producto.variants.find((v) => v.available) || producto.variants[0];
          siguientes.push({
            ...item,
            id: producto.id,
            title: producto.title,
            url: `/products/${producto.handle}`,
            available: hayStock,
            variantId: variante ? variante.id : item.variantId,
          });
          if (item.available !== hayStock || String(item.id) !== String(producto.id)) huboCambios = true;
        } catch (error) {
          siguientes.push(item);
        }
      }
      if (huboCambios || siguientes.length !== items.length) {
        items = siguientes;
        guardarAlmacen();
      } else {
        renderizarLista();
      }
    }

    function abrirDrawer() {
      focoAnterior = document.activeElement;
      leerAlmacen();
      renderizarLista();
      void refrescarItemsDesdeServidor();
      drawer.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(() => {
        drawer.setAttribute('data-abierto', '');
        if (window.NaiaUI) window.NaiaUI.bloquearScroll(drawer);
        else document.body.style.overflow = 'hidden';
        const cerrar = drawer.querySelector('[data-lista-deseos-cerrar]');
        if (cerrar) cerrar.focus();
        atraparFoco(panel);
      });
    }

    function cerrarDrawer() {
      drawer.removeAttribute('data-abierto');
      drawer.setAttribute('aria-hidden', 'true');
      if (window.NaiaUI) window.NaiaUI.desbloquearScroll(drawer);
      else document.body.style.overflow = '';
      limpiarFeedback();
      window.setTimeout(() => {
        drawer.hidden = true;
      }, 300);
      if (focoAnterior) focoAnterior.focus();
    }

    async function resolverVariante(item) {
      if (item.variantId) return item.variantId;
      if (!item.handle) return null;
      try {
        const respuesta = await fetch(`/products/${item.handle}.js`, { headers: { Accept: 'application/json' } });
        const producto = await respuesta.json();
        const variante = producto.variants.find((v) => v.available) || producto.variants[0];
        return variante ? variante.id : null;
      } catch (error) {
        return null;
      }
    }

    async function anadirAlCarrito(productoId) {
      const item = items.find((elemento) => String(elemento.id) === String(productoId));
      if (!item) return;

      mostrarFeedback(textoAnadiendo);
      const boton = drawer.querySelector(`[data-lista-deseos-anadir-carrito][data-producto-id="${productoId}"]`);
      if (boton) boton.disabled = true;

      try {
        const varianteId = await resolverVariante(item);
        if (!varianteId) {
          mostrarFeedback(textoErrorCarrito, true);
          if (boton) boton.disabled = false;
          return;
        }

        const respuesta = await fetch(urlAnadir, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ items: [{ id: Number(varianteId), quantity: 1 }] }),
        });

        const resultado = await respuesta.json();
        if (resultado.status) {
          mostrarFeedback(resultado.description || resultado.message || textoErrorCarrito, true);
          if (boton) boton.disabled = false;
          return;
        }

        const carritoRespuesta = await fetch(urlCarrito, { headers: { Accept: 'application/json' } });
        const carrito = await carritoRespuesta.json();

        document.dispatchEvent(
          new CustomEvent('cart:updated', {
            detail: {
              itemCount: carrito.item_count,
              mostrarToast: mostrarToastTrasAnadir,
              abrirDrawer: abrirTrasAnadir,
              productoTitulo: item.title,
              productoImagen: item.image,
            },
          })
        );

        mostrarFeedback(textoAnadido);
        window.setTimeout(limpiarFeedback, 1800);
      } catch (error) {
        mostrarFeedback(textoErrorCarrito, true);
      } finally {
        if (boton) boton.disabled = item.available === false;
      }
    }

    drawer.querySelectorAll('[data-lista-deseos-cerrar]').forEach((boton) => {
      boton.addEventListener('click', cerrarDrawer);
    });

    drawer.addEventListener('click', (evento) => {
      const quitar = evento.target.closest('[data-lista-deseos-quitar]');
      if (quitar && drawer.contains(quitar)) {
        quitarProducto(quitar.dataset.productoId);
        return;
      }

      const anadirCarrito = evento.target.closest('[data-lista-deseos-anadir-carrito]');
      if (anadirCarrito && drawer.contains(anadirCarrito)) {
        anadirAlCarrito(anadirCarrito.dataset.productoId);
      }
    });

    document.addEventListener('click', (evento) => {
      const toggle = evento.target.closest('[data-lista-deseos-toggle]');
      if (!toggle) return;

      evento.preventDefault();
      alternarProducto(productoDesdeDataset(toggle));
    });

    document.addEventListener('cabecera:abrir-lista-deseos', abrirDrawer);
    document.addEventListener('lista-deseos:abrir', abrirDrawer);

    document.addEventListener('lista-deseos:alternar', (evento) => {
      if (evento.detail && evento.detail.producto) {
        alternarProducto(evento.detail.producto);
      }
    });

    document.addEventListener('keydown', (evento) => {
      if (evento.key === 'Escape' && drawer.hasAttribute('data-abierto')) {
        cerrarDrawer();
      }
    });

    leerAlmacen();
    renderizarLista();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquesina-logos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const seccion = document.querySelector('[data-marquesina-logos]');
    if (!seccion) return;

    const pista = seccion.querySelector('[data-marquesina-logos-pista]');
    if (!pista) return;

    const respetarMovimiento = seccion.dataset.respetarMovimiento === 'true';
    const sinMovimiento =
      respetarMovimiento && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (sinMovimiento) {
      pista.classList.add('marquesina-logos__pista--sin-movimiento');
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-inicio"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const seccion = document.querySelector('[data-newsletter-inicio]');
    if (!seccion) return;

    const formulario = seccion.querySelector('[data-newsletter-inicio-formulario]');
    const boton = seccion.querySelector('[data-newsletter-inicio-boton]');
    const textoEnviando = seccion.dataset.textoEnviando || '';
    const textoBoton = seccion.dataset.textoBoton || '';

    if (!formulario || !boton) return;

    formulario.addEventListener('submit', function () {
      boton.disabled = true;
      boton.textContent = textoEnviando;
      window.setTimeout(function () {
        boton.disabled = false;
        boton.textContent = textoBoton;
      }, 4000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["numeros-confianza"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const seccion = document.querySelector('[data-numeros-confianza]');
    if (!seccion) return;

    const respetarMovimiento = seccion.dataset.respetarMovimiento === 'true';
    const movimientoReducido = respetarMovimiento && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (respetarMovimiento) {
      seccion.setAttribute('data-respetar-movimiento', 'true');
    }

    const items = [...seccion.querySelectorAll('[data-numeros-confianza-item]')];

    const formatearNumero = (valor, decimales, sufijo) => {
      const opciones = decimales > 0
        ? { minimumFractionDigits: decimales, maximumFractionDigits: decimales }
        : { maximumFractionDigits: 0 };
      const formateado = Number(valor).toLocaleString('es-ES', opciones);
      return `${formateado}${sufijo || ''}`;
    };

    const animarContador = (item) => {
      if (item.dataset.animar !== 'true' || movimientoReducido) return;

      const valorEl = item.querySelector('[data-numeros-confianza-valor]');
      const objetivo = Number(item.dataset.valor || 0);
      const sufijo = item.dataset.sufijo || '';
      const decimales = Number(item.dataset.decimales || 0);
      if (!valorEl || !objetivo) return;

      const duracion = 1200;
      const inicio = performance.now();

      const tick = (ahora) => {
        const progreso = Math.min(1, (ahora - inicio) / duracion);
        const actual = objetivo * progreso;
        valorEl.textContent = formatearNumero(actual, decimales, sufijo);
        if (progreso < 1) {
          requestAnimationFrame(tick);
        }
      };

      requestAnimationFrame(tick);
    };

    const revelar = (item) => {
      item.setAttribute('data-visible', '');
      animarContador(item);
    };

    if (movimientoReducido) {
      items.forEach(revelar);
      return;
    }

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            revelar(entry.target);
            obs.unobserve(entry.target);
          });
        },
        { threshold: 0.35 }
      );

      items.forEach((item, indice) => {
        item.style.transitionDelay = `${indice * 80}ms`;
        observer.observe(item);
      });
    } else {
      items.forEach(revelar);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oferta-limitada"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const seccion = document.querySelector('[data-oferta-limitada]');
    if (!seccion) return;

    const reubicar = seccion.dataset.reubicar === 'true';
    const ocultarExpirado = seccion.dataset.ocultarExpirado === 'true';
    const enEditor = seccion.dataset.editor === 'true';

    function reubicarEnPdp() {
      if (!reubicar) return;
      const ancla = document.querySelector('[data-oferta-limitada-ancla]');
      if (!ancla || ancla.contains(seccion)) return;
      ancla.appendChild(seccion);
    }

    reubicarEnPdp();

    seccion.querySelectorAll('[data-oferta-limitada-copiar]').forEach((boton) => {
      boton.addEventListener('click', async () => {
        const codigo = boton.dataset.codigo || boton.textContent.trim();
        const feedback = seccion.querySelector('[data-oferta-limitada-codigo-feedback]');
        try {
          await navigator.clipboard.writeText(codigo);
          if (feedback) {
            feedback.hidden = false;
            window.setTimeout(() => {
              feedback.hidden = true;
            }, 1800);
          }
        } catch (error) {
          if (feedback) {
            feedback.textContent = codigo;
            feedback.hidden = false;
          }
        }
      });
    });

    if (!seccion.hasAttribute('data-oferta-limitada-countdown')) return;

    const contenedor = seccion.querySelector('[data-oferta-limitada-countdown-contenedor]');
    const expirado = seccion.querySelector('[data-oferta-limitada-expirado]');
    const diasEl = seccion.querySelector('[data-oferta-limitada-dias]');
    const horasEl = seccion.querySelector('[data-oferta-limitada-horas]');
    const minutosEl = seccion.querySelector('[data-oferta-limitada-minutos]');
    const segundosEl = seccion.querySelector('[data-oferta-limitada-segundos]');

    if (!contenedor) return;

    const modo = seccion.dataset.countdownModo || 'fecha_fija';
    const mostrarDias = seccion.dataset.mostrarDias === 'true';
    const rellenar = (valor) => String(Math.max(0, valor)).padStart(2, '0');

    function marcarExpirado() {
      contenedor.hidden = true;
      if (expirado) expirado.hidden = false;
      if (ocultarExpirado && !enEditor) {
        seccion.hidden = true;
      }
      return false;
    }

    function obtenerTimestampFin() {
      if (modo === 'duracion') {
        const horas = Number.parseInt(seccion.dataset.duracionHoras || '0', 10) || 0;
        const minutos = Number.parseInt(seccion.dataset.duracionMinutos || '0', 10) || 0;
        const segundosDuracion = Number.parseInt(seccion.dataset.duracionSegundos || '0', 10) || 0;
        const duracionMs = (horas * 3600 + minutos * 60 + segundosDuracion) * 1000;
        if (duracionMs <= 0) return null;

        const promoId = seccion.dataset.idPromocion || seccion.id || 'oferta';
        const storageKey = `oferta-limitada-fin:${promoId}`;
        const ahora = Date.now();

        try {
          const guardado = window.localStorage.getItem(storageKey);
          if (guardado) {
            const finGuardado = Number.parseInt(guardado, 10);
            if (!Number.isNaN(finGuardado) && finGuardado > ahora) {
              return finGuardado;
            }
            if (!Number.isNaN(finGuardado) && finGuardado <= ahora) {
              return null;
            }
          }
          const finNuevo = ahora + duracionMs;
          window.localStorage.setItem(storageKey, String(finNuevo));
          return finNuevo;
        } catch (error) {
          return ahora + duracionMs;
        }
      }

      const fechaFinTexto = seccion.dataset.fechaFin;
      if (!fechaFinTexto) return null;
      const fechaFin = new Date(fechaFinTexto.replace(' ', 'T'));
      if (Number.isNaN(fechaFin.getTime())) return null;
      return fechaFin.getTime();
    }

    const timestampFin = obtenerTimestampFin();
    if (timestampFin == null) {
      marcarExpirado();
      return;
    }

    function actualizarCountdown() {
      const restante = timestampFin - Date.now();
      if (restante <= 0) return marcarExpirado();

      const totalSegundos = Math.floor(restante / 1000);
      let dias = 0;
      let horas = 0;
      let minutos = 0;
      let segundos = 0;

      if (mostrarDias) {
        dias = Math.floor(totalSegundos / 86400);
        horas = Math.floor((totalSegundos % 86400) / 3600);
        minutos = Math.floor((totalSegundos % 3600) / 60);
        segundos = totalSegundos % 60;
      } else {
        horas = Math.floor(totalSegundos / 3600);
        minutos = Math.floor((totalSegundos % 3600) / 60);
        segundos = totalSegundos % 60;
      }

      if (diasEl) diasEl.textContent = rellenar(dias);
      if (horasEl) horasEl.textContent = rellenar(horas);
      if (minutosEl) minutosEl.textContent = rellenar(minutos);
      if (segundosEl) segundosEl.textContent = rellenar(segundos);
      return true;
    }

    if (!actualizarCountdown()) return;

    const intervalo = window.setInterval(() => {
      if (!actualizarCountdown()) {
        window.clearInterval(intervalo);
      }
    }, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pagina-404"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var secciones = document.querySelectorAll('[data-pagina-404-busqueda]');
    if (!secciones.length) return;

    secciones.forEach(function (formulario) {
      formulario.addEventListener('submit', function (evento) {
        var campo = formulario.querySelector('input[name="q"]');
        if (!campo) return;
        var valor = campo.value.trim();
        if (!valor) {
          evento.preventDefault();
          campo.focus();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pagina-contacto"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var secciones = document.querySelectorAll('[data-pagina-contacto]');
    if (!secciones.length) return;

    secciones.forEach(function (seccion) {
      var formulario = seccion.querySelector('[data-pagina-contacto-formulario]');
      if (!formulario) return;

      var boton = formulario.querySelector('[data-pagina-contacto-boton]');
      var exito = formulario.querySelector('[data-pagina-contacto-exito]');
      var error = formulario.querySelector('[data-pagina-contacto-error]');

      if (exito) {
        exito.focus();
      } else if (error) {
        error.focus();
      }

      formulario.addEventListener('submit', function () {
        if (!boton) return;
        boton.disabled = true;
        boton.setAttribute('aria-busy', 'true');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pagina-contenido"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var contenedores = document.querySelectorAll('[data-pagina-contenido-acordeones]');
    if (!contenedores.length) return;

    contenedores.forEach(function (contenedor) {
      var acordeones = contenedor.querySelectorAll('[data-pagina-contenido-acordeon]');

      acordeones.forEach(function (acordeon) {
        acordeon.addEventListener('toggle', function () {
          if (!acordeon.open) return;

          acordeones.forEach(function (otro) {
            if (otro !== acordeon) {
              otro.open = false;
            }
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pagina-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var secciones = document.querySelectorAll('[data-pagina-faq]');
    if (!secciones.length) return;

    secciones.forEach(function (seccion) {
      var campoBusqueda = seccion.querySelector('[data-pagina-faq-busqueda]');
      var acordeones = seccion.querySelectorAll('[data-pagina-faq-acordeon]');
      var titulosCategoria = seccion.querySelectorAll('[data-pagina-faq-categoria-titulo]');
      var sinResultados = seccion.querySelector('[data-pagina-faq-sin-resultados]');
      var filtros = seccion.querySelectorAll('[data-pagina-faq-filtro]');
      var filtroActivo = 'todas';

      function normalizar(texto) {
        return (texto || '').toLowerCase().trim();
      }

      function aplicarFiltros() {
        var termino = campoBusqueda ? normalizar(campoBusqueda.value) : '';
        var visibles = 0;

        acordeones.forEach(function (acordeon) {
          var categoria = acordeon.getAttribute('data-pagina-faq-categoria') || '';
          var texto = normalizar(acordeon.getAttribute('data-pagina-faq-texto'));
          var coincideCategoria = filtroActivo === 'todas' || categoria === filtroActivo;
          var coincideBusqueda = !termino || texto.indexOf(termino) !== -1;
          var mostrar = coincideCategoria && coincideBusqueda;

          acordeon.hidden = !mostrar;
          if (mostrar) visibles += 1;
        });

        titulosCategoria.forEach(function (titulo) {
          var cat = titulo.getAttribute('data-pagina-faq-categoria-titulo') || '';
          var hayVisibles = false;

          acordeones.forEach(function (acordeon) {
            if (acordeon.hidden) return;
            if ((acordeon.getAttribute('data-pagina-faq-categoria') || '') === cat) {
              hayVisibles = true;
            }
          });

          titulo.hidden = !hayVisibles;
        });

        if (sinResultados) {
          sinResultados.hidden = visibles > 0;
        }
      }

      if (campoBusqueda) {
        campoBusqueda.addEventListener('input', aplicarFiltros);
      }

      filtros.forEach(function (filtro) {
        filtro.addEventListener('click', function () {
          filtroActivo = filtro.getAttribute('data-pagina-faq-filtro') || 'todas';

          filtros.forEach(function (boton) {
            var activo = boton === filtro;
            boton.classList.toggle('pagina-faq__filtro--activo', activo);
            boton.setAttribute('aria-pressed', activo ? 'true' : 'false');
          });

          aplicarFiltros();
        });
      });

      seccion.querySelectorAll('[data-pagina-faq-acordeon]').forEach(function (acordeon) {
        acordeon.addEventListener('toggle', function () {
          if (!acordeon.open) return;

          seccion.querySelectorAll('[data-pagina-faq-acordeon]').forEach(function (otro) {
            if (otro !== acordeon && !otro.hidden) {
              otro.open = false;
            }
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pagina-password"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var botones = document.querySelectorAll('[data-pagina-password-abrir]');
    if (!botones.length) return;

    botones.forEach(function (boton) {
      boton.addEventListener('click', function () {
        var dialogo = document.querySelector('#password-form');
        if (!dialogo) return;

        if (typeof dialogo.showDialog === 'function') {
          dialogo.showDialog();
          return;
        }

        var dialog = dialogo.querySelector('dialog');
        if (dialog && typeof dialog.showModal === 'function') {
          dialog.showModal();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pie-pagina"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const pie = document.querySelector('[data-pie-pagina]');
    if (!pie) return;

    const mqEscritorio = window.matchMedia('(min-width: 750px)');

    pie.querySelectorAll('[data-pie-pagina-acordeon]').forEach(function (boton) {
      boton.addEventListener('click', function () {
        if (mqEscritorio.matches) return;

        const expandido = boton.getAttribute('aria-expanded') === 'true';
        const panel = boton.closest('[data-pie-pagina-columna]')?.querySelector('[data-pie-pagina-panel]');
        boton.setAttribute('aria-expanded', expandido ? 'false' : 'true');

        if (panel) {
          panel.classList.toggle('pie-pagina__columna-panel--abierto', !expandido);
        }
      });
    });

    const formulario = pie.querySelector('[data-pie-pagina-newsletter]');
    const boton = pie.querySelector('[data-pie-pagina-newsletter-boton]');
    const textoEnviando = pie.dataset.textoEnviando || '';
    const textoBoton = pie.dataset.textoBotonNewsletter || '';

    if (formulario && boton) {
      formulario.addEventListener('submit', function () {
        boton.disabled = true;
        boton.textContent = textoEnviando;
        window.setTimeout(function () {
          boton.disabled = false;
          boton.textContent = textoBoton;
        }, 4000);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pie-password"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var botones = document.querySelectorAll('[data-pie-password-abrir]');
    if (!botones.length) return;

    botones.forEach(function (boton) {
      boton.addEventListener('click', function () {
        var dialogo = document.querySelector('#password-form');
        if (!dialogo) return;

        if (typeof dialogo.showDialog === 'function') {
          dialogo.showDialog();
          return;
        }

        var dialog = dialogo.querySelector('dialog');
        if (dialog && typeof dialog.showModal === 'function') {
          dialog.showModal();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-newsletter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const seccion = document.querySelector('[data-popup-newsletter]');
    if (!seccion) return;

    const dialogo = seccion.querySelector('[data-popup-newsletter-dialogo]');
    const vistaFormulario = seccion.querySelector('[data-popup-newsletter-vista="formulario"]');
    const vistaExito = seccion.querySelector('[data-popup-newsletter-vista="exito"]');
    const pasoInteres = seccion.querySelector('[data-popup-newsletter-paso="interes"]');
    const pasoEmail = seccion.querySelector('[data-popup-newsletter-paso="email"]');
    const formulario = seccion.querySelector('[data-popup-newsletter-formulario]');
    const botonEnviar = seccion.querySelector('[data-popup-newsletter-enviar]');
    const errorEl = seccion.querySelector('[data-popup-newsletter-error]');
    const tagBase = seccion.querySelector('[data-popup-newsletter-tag-base]');
    const notaEl = seccion.querySelector('[data-popup-newsletter-nota]');

    const claveStorage = seccion.dataset.claveStorage || 'popup-newsletter';
    const claveSuscrito = claveStorage + '-suscrito';
    const retrasoEscritorio = parseInt(seccion.getAttribute('data-retraso') || '8000', 10);
    const retrasoMovil = parseInt(seccion.getAttribute('data-retraso-movil') || '12000', 10);
    const esMovil = window.matchMedia('(max-width: 749px)').matches;
    const retraso = esMovil ? retrasoMovil : retrasoEscritorio;
    const activarScroll = seccion.getAttribute('data-scroll') === 'true';
    const scrollPorcentaje = parseInt(seccion.getAttribute('data-scroll-porcentaje') || '35', 10);
    const activarExitIntent = seccion.getAttribute('data-exit-intent') === 'true';
    const diasOculto = parseInt(seccion.getAttribute('data-dias-oculto') || '7', 10);
    const soloInicio = seccion.getAttribute('data-solo-inicio') === 'true';
    const esInicio = seccion.getAttribute('data-es-inicio') === 'true';
    const esEditor = seccion.getAttribute('data-editor') === 'true';
    const dosPasos = seccion.getAttribute('data-modo-dos-pasos') === 'true';
    const requerirInteraccion = seccion.getAttribute('data-requerir-interaccion') !== 'false';
    const excluirCheckout = seccion.getAttribute('data-excluir-checkout') !== 'false';
    const esperarCookies = seccion.getAttribute('data-esperar-cookies') !== 'false';
    const pageType = seccion.getAttribute('data-page-type') || '';
    const variante = seccion.getAttribute('data-variante') || '';
    const analitica = seccion.getAttribute('data-analitica') === 'true';

    let abierto = false;
    let activado = false;
    let ultimoFoco = null;
    let interaccionRealizada = false;
    let tiempoRetrasoCumplido = false;

    const registrarEvento = function (nombre, extra) {
      if (!analitica) return;
      var payload = Object.assign({ event: nombre, popup_variant: variante, popup_source: 'popup-newsletter' }, extra || {});
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    };

    const consentimientoCookiesPendiente = function () {
      var aviso = document.querySelector('[data-aviso-cookies]');
      if (!aviso) return false;
      var clave = aviso.dataset.claveAlmacen || 'aviso-cookies-consentimiento';
      try {
        var datos = window.localStorage.getItem(clave);
        if (!datos) return true;
        var parsed = JSON.parse(datos);
        return !parsed || !parsed.valor;
      } catch (error) {
        return true;
      }
    };

    const bannerCookiesVisible = function () {
      if (!esperarCookies) return false;
      var aviso = document.querySelector('[data-aviso-cookies]');
      if (!aviso) return consentimientoCookiesPendiente();
      if (aviso.hasAttribute('data-visible') || aviso.hasAttribute('data-cookie-pendiente')) {
        return true;
      }
      if (consentimientoCookiesPendiente()) return true;
      return false;
    };

    const paginaExcluida = function () {
      if (!excluirCheckout) return false;
      if (pageType === 'cart') return true;
      var path = window.location.pathname || '';
      if (path.indexOf('/checkout') !== -1) return true;
      if (path.indexOf('/checkouts/') !== -1) return true;
      return false;
    };

    const debeOcultarse = function () {
      try {
        if (localStorage.getItem(claveSuscrito) === '1') return true;
        const valor = localStorage.getItem(claveStorage);
        if (!valor) return false;
        const expira = parseInt(valor, 10);
        return Date.now() < expira;
      } catch (error) {
        return false;
      }
    };

    const marcarOculto = function () {
      try {
        const expira = Date.now() + diasOculto * 86400000;
        localStorage.setItem(claveStorage, String(expira));
      } catch (error) {
        return;
      }
    };

    const marcarSuscrito = function () {
      try {
        localStorage.setItem(claveSuscrito, '1');
        localStorage.removeItem(claveStorage);
      } catch (error) {
        return;
      }
    };

    const puedeMostrarse = function () {
      if (esEditor) return true;
      if (paginaExcluida()) return false;
      if (debeOcultarse()) return false;
      if (soloInicio && !esInicio) return false;
      return true;
    };

    const elementosEnfocables = function () {
      return Array.from(
        seccion.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
      ).filter(function (elemento) {
        return elemento.offsetParent !== null || elemento === document.activeElement;
      });
    };

    const trapFoco = function (evento) {
      if (!abierto || evento.key !== 'Tab') return;
      const elementos = elementosEnfocables();
      if (!elementos.length) return;

      const primero = elementos[0];
      const ultimo = elementos[elementos.length - 1];

      if (evento.shiftKey && document.activeElement === primero) {
        evento.preventDefault();
        ultimo.focus();
      } else if (!evento.shiftKey && document.activeElement === ultimo) {
        evento.preventDefault();
        primero.focus();
      }
    };

    const abrir = function () {
      if (abierto || !puedeMostrarse()) return;
      if (bannerCookiesVisible()) return;
      abierto = true;
      ultimoFoco = document.activeElement;
      seccion.hidden = false;
      seccion.setAttribute('aria-hidden', 'false');
      if (window.NaiaUI) window.NaiaUI.bloquearScroll(seccion);
      else document.body.style.overflow = 'hidden';
      const foco = seccion.querySelector('[data-popup-newsletter-cerrar]');
      if (foco) foco.focus();
      registrarEvento('popup_newsletter_view');
    };

    const cerrar = function (motivo) {
      if (!abierto) return;
      abierto = false;
      seccion.hidden = true;
      seccion.setAttribute('aria-hidden', 'true');
      if (window.NaiaUI) window.NaiaUI.desbloquearScroll(seccion);
      else document.body.style.overflow = '';
      marcarOculto();
      registrarEvento('popup_newsletter_close', { close_reason: motivo || 'user' });
      if (ultimoFoco && typeof ultimoFoco.focus === 'function') ultimoFoco.focus();
    };

    const mostrarExito = function () {
      if (vistaFormulario) vistaFormulario.hidden = true;
      if (vistaExito) vistaExito.hidden = false;
    };

    const obtenerInteresSeleccionado = function () {
      const input = seccion.querySelector('[data-popup-newsletter-interes]:checked');
      return input ? input.value : '';
    };

    const prepararTags = function () {
      if (!tagBase) return;
      const interes = obtenerInteresSeleccionado();
      tagBase.value = interes ? 'newsletter, ' + interes : 'newsletter';
      if (notaEl && interes) notaEl.value = interes;
    };

    seccion.querySelectorAll('[data-popup-newsletter-cerrar]').forEach(function (boton) {
      boton.addEventListener('click', function () {
        cerrar('click');
      });
    });

    document.addEventListener('keydown', function (evento) {
      if (evento.key === 'Escape' && abierto) cerrar('escape');
      trapFoco(evento);
    });

    if (dosPasos && pasoInteres && pasoEmail) {
      seccion.querySelector('[data-popup-newsletter-continuar]')?.addEventListener('click', function () {
        pasoInteres.hidden = true;
        pasoEmail.hidden = false;
        prepararTags();
        seccion.querySelector('[data-popup-newsletter-email]')?.focus();
      });

      seccion.querySelector('[data-popup-newsletter-volver]')?.addEventListener('click', function () {
        pasoEmail.hidden = true;
        pasoInteres.hidden = false;
      });
    }

    if (formulario) {
      formulario.addEventListener('submit', function (evento) {
        evento.preventDefault();
        if (dosPasos) prepararTags();

        if (botonEnviar) {
          botonEnviar.disabled = true;
          botonEnviar.textContent = seccion.dataset.textoEnviando || '';
        }
        if (errorEl) errorEl.hidden = true;

        const datos = new FormData(formulario);
        datos.append('form_type', 'customer');

        const emailCapturado =
          seccion.querySelector('[data-popup-newsletter-email]')?.value || '';
        const casillaConsentimiento = seccion.querySelector('[data-popup-newsletter-consentimiento]');
        const consentimiento = casillaConsentimiento ? casillaConsentimiento.checked === true : true;

        fetch('/contact', {
          method: 'POST',
          body: datos,
          headers: {
            Accept: 'text/html',
          },
        })
          .then(function (respuesta) {
            if (respuesta.ok || respuesta.redirected) {
              if (typeof window.naiaKlaviyoSuscribir === 'function') {
                window.naiaKlaviyoSuscribir(emailCapturado, {
                  interes: obtenerInteresSeleccionado(),
                  source: 'Popup newsletter',
                  marketingConsent: consentimiento,
                  variante: variante,
                });
              }
              marcarSuscrito();
              registrarEvento('popup_newsletter_submit', { success: true });
              mostrarExito();
              return;
            }
            throw new Error('submit-failed');
          })
          .catch(function () {
            registrarEvento('popup_newsletter_submit', { success: false });
            if (errorEl) {
              errorEl.hidden = false;
              errorEl.textContent = seccion.dataset.textoErrorEnvio || '';
            }
          })
          .finally(function () {
            if (botonEnviar) {
              botonEnviar.disabled = false;
              botonEnviar.textContent = seccion.dataset.textoBotonEnviar || '';
            }
          });
      });
    }

    const activarUnaVez = function () {
      if (activado) return;
      if (!puedeMostrarse()) return;
      if (bannerCookiesVisible()) {
        window.setTimeout(activarUnaVez, 1500);
        return;
      }
      activado = true;
      abrir();
    };

    const intentarAbrirProgramado = function () {
      if (requerirInteraccion && !interaccionRealizada) return;
      if (!tiempoRetrasoCumplido) return;
      activarUnaVez();
    };

    const marcarInteraccion = function () {
      if (interaccionRealizada) return;
      interaccionRealizada = true;
      intentarAbrirProgramado();
    };

    if (esEditor) {
      abrir();
      return;
    }

    if (!puedeMostrarse()) return;

    ['scroll', 'pointerdown', 'keydown'].forEach(function (evt) {
      window.addEventListener(evt, marcarInteraccion, { passive: true });
    });

    window.setTimeout(function () {
      tiempoRetrasoCumplido = true;
      intentarAbrirProgramado();
    }, retraso);

    if (activarScroll) {
      const onScroll = function () {
        marcarInteraccion();
        const alto = document.documentElement.scrollHeight - window.innerHeight;
        if (alto <= 0) return;
        const porcentaje = (window.scrollY / alto) * 100;
        if (porcentaje >= scrollPorcentaje) {
          tiempoRetrasoCumplido = true;
          intentarAbrirProgramado();
          window.removeEventListener('scroll', onScroll);
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    if (activarExitIntent) {
      document.addEventListener('mouseout', function (evento) {
        if (evento.clientY <= 0) {
          interaccionRealizada = true;
          tiempoRetrasoCumplido = true;
          intentarAbrirProgramado();
        }
      });
    }

    document.addEventListener('popup-newsletter:abrir', function () {
      activado = false;
      abrir();
    });

    document.addEventListener('aviso-cookies:actualizado', function () {
      if (activado || !puedeMostrarse()) return;
      tiempoRetrasoCumplido = true;
      intentarAbrirProgramado();
    });

    document.addEventListener('aviso-cookies:visible', function () {
      if (abierto) cerrar('cookies');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["preguntas-producto"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const seccion = document.querySelector('[data-preguntas-producto]');
    if (!seccion) return;

    const modoAcordeon = seccion.dataset.modoAcordeon || 'multiple';
    const acordeones = seccion.querySelectorAll('[data-preguntas-acordeon]');
    const botonGuia = seccion.querySelector('[data-preguntas-abrir-guia]');

    if (modoAcordeon === 'unico') {
      acordeones.forEach((acordeon) => {
        acordeon.addEventListener('toggle', () => {
          if (!acordeon.open) return;
          acordeones.forEach((otro) => {
            if (otro !== acordeon) otro.open = false;
          });
        });
      });
    }

    botonGuia?.addEventListener('click', () => {
      document.dispatchEvent(new CustomEvent('producto:abrir-guia-tallas'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["producto-principal"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function esFinDeSemana(fecha, excluir) {
      if (!excluir) return false;
      const dia = fecha.getDay();
      return dia === 0 || dia === 6;
    }

    function sumarDiasLaborables(inicio, dias, excluirFines) {
      const fecha = new Date(inicio.getTime());
      let restantes = Math.max(0, Number(dias) || 0);
      while (restantes > 0) {
        fecha.setDate(fecha.getDate() + 1);
        if (esFinDeSemana(fecha, excluirFines)) continue;
        restantes -= 1;
      }
      return fecha;
    }

    function formatearFechaMadrid(fecha) {
      const partes = new Intl.DateTimeFormat('es-ES', {
        timeZone: 'Europe/Madrid',
        weekday: 'short',
        day: 'numeric',
        month: 'short',
      }).formatToParts(fecha);
      const mapa = {};
      partes.forEach((p) => {
        if (p.type !== 'literal') mapa[p.type] = p.value;
      });
      const diaSem = (mapa.weekday || '').replace('.', '').slice(0, 3).toLowerCase();
      const mes = (mapa.month || '').replace('.', '').slice(0, 3).toLowerCase();
      return `${diaSem} ${mapa.day} ${mes}`.trim();
    }

    function horaCortePasada(horaCorte) {
      const partes = String(horaCorte || '14:00').split(':');
      const h = Number(partes[0]) || 14;
      const m = Number(partes[1]) || 0;
      const ahora = new Date();
      const madrid = new Date(ahora.toLocaleString('en-US', { timeZone: 'Europe/Madrid' }));
      return madrid.getHours() > h || (madrid.getHours() === h && madrid.getMinutes() >= m);
    }

    function inicioDesdePedido(excluirFines, horaCorte) {
      const madrid = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Madrid' }));
      madrid.setHours(12, 0, 0, 0);
      if (horaCortePasada(horaCorte)) {
        madrid.setDate(madrid.getDate() + 1);
      }
      while (esFinDeSemana(madrid, excluirFines)) {
        madrid.setDate(madrid.getDate() + 1);
      }
      return madrid;
    }

    function actualizarEnvioEstimado(bloque) {
      const destino = bloque.querySelector('[data-producto-principal-envio-estimado-texto]');
      if (!destino) return;
      const min = Number(bloque.dataset.envioDiasMin || 5);
      const max = Number(bloque.dataset.envioDiasMax || 8);
      const excluir = bloque.dataset.envioExcluirFines !== 'false';
      const horaCorte = bloque.dataset.envioHoraCorte || '14:00';
      const antes = bloque.dataset.envioTextoAntes || 'Envío gratis · Recíbelo entre el';
      const entre = bloque.dataset.envioTextoEntre || 'y el';
      const despues = bloque.dataset.envioTextoDespues || '';
      const inicio = inicioDesdePedido(excluir, horaCorte);
      const fechaMin = sumarDiasLaborables(inicio, min, excluir);
      const fechaMax = sumarDiasLaborables(inicio, max, excluir);
      destino.textContent = `${antes} ${formatearFechaMadrid(fechaMin)} ${entre} ${formatearFechaMadrid(fechaMax)}${despues ? ` ${despues}` : ''}`;
    }

    function initEnvioEstimado() {
      document.querySelectorAll('[data-producto-principal-compra-confianza]').forEach(actualizarEnvioEstimado);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initEnvioEstimado);
    } else {
      initEnvioEstimado();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["producto-regalo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const seccion = document.querySelector('[data-producto-regalo]');
    if (!seccion) return;

    const variantes = JSON.parse(seccion.querySelector('[data-producto-regalo-variantes]')?.textContent || '[]');
    const opciones = JSON.parse(seccion.querySelector('[data-producto-regalo-opciones]')?.textContent || '[]');
    const inputVariante = seccion.querySelector('[data-producto-regalo-variante-id]');
    const precioValor = seccion.querySelector('[data-producto-regalo-precio-valor]');
    const boton = seccion.querySelector('[data-producto-regalo-boton]');
    const formulario = seccion.querySelector('[data-producto-regalo-formulario]');
    const camposDestinatario = seccion.querySelector('[data-producto-regalo-campos]');
    const radiosModo = seccion.querySelectorAll('[data-producto-regalo-modo]');
    const campoMensaje = seccion.querySelector('[data-producto-regalo-campo="message"]');
    const contador = seccion.querySelector('[data-producto-regalo-contador]');
    const regionViva = seccion.querySelector('[data-producto-regalo-vivo]');
    const campoOffset = seccion.querySelector('[data-producto-regalo-offset]');
    const maxCaracteres = Number(seccion.dataset.maxCaracteres || 200);
    const plantillaContador = seccion.dataset.textoContadorCaracteres || '';

    let seleccion = {};
    opciones.forEach(function (nombre, indice) {
      const posicion = indice + 1;
      const pillActiva = seccion.querySelector('[data-producto-regalo-pill][data-opcion="' + posicion + '"].producto-regalo__pill--activa');
      seleccion[posicion] = pillActiva ? pillActiva.dataset.valor : null;
    });

    const formatearPrecio = function (centimos, ejemplo) {
      const numero = Number(centimos) / 100;
      const muestra = ejemplo || '';
      const simbolo = muestra.replace(/[\d\s.,]/g, '').trim() || '€';
      const conDecimales = /\.\d{2}|,\d{2}/.test(muestra);
      const valor = conDecimales ? numero.toFixed(2).replace('.', ',') : Math.round(numero).toString();
      if (muestra.indexOf(simbolo) === 0) return simbolo + valor;
      return valor + ' ' + simbolo;
    };

    const encontrarVariante = function () {
      return variantes.find(function (variante) {
        return Object.entries(seleccion).every(function (entrada) {
          const posicion = entrada[0];
          const valor = entrada[1];
          if (!valor) return true;
          return variante['option' + posicion] === valor;
        });
      });
    };

    const actualizarVariante = function (variante) {
      if (!variante || !inputVariante) return;
      inputVariante.value = variante.id;

      if (precioValor) {
        const ejemplo = precioValor.textContent.trim();
        precioValor.textContent = formatearPrecio(variante.price, ejemplo);
      }

      if (boton) {
        boton.disabled = !variante.available;
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variante.id);
      window.history.replaceState({}, '', url.toString());
    };

    seccion.addEventListener('click', function (evento) {
      const pill = evento.target.closest('[data-producto-regalo-pill]');
      if (!pill || !seccion.contains(pill) || pill.classList.contains('producto-regalo__pill--agotada')) return;

      const posicion = pill.dataset.opcion;
      seleccion[posicion] = pill.dataset.valor;

      seccion.querySelectorAll('[data-producto-regalo-pill][data-opcion="' + posicion + '"]').forEach(function (elemento) {
        const activa = elemento === pill;
        elemento.classList.toggle('producto-regalo__pill--activa', activa);
        elemento.setAttribute('aria-pressed', activa ? 'true' : 'false');
      });

      const etiquetaValor = seccion.querySelector('[data-producto-regalo-valor-opcion="' + posicion + '"]');
      if (etiquetaValor) etiquetaValor.textContent = pill.dataset.valor;

      actualizarVariante(encontrarVariante());
    });

    const camposRecipiente = seccion.querySelectorAll('[data-producto-regalo-campo]');
    let flagControl = null;

    const limpiarCampos = function () {
      camposRecipiente.forEach(function (campo) {
        campo.value = '';
      });
      actualizarContador();
    };

    const actualizarContador = function () {
      if (!contador || !campoMensaje) return;
      contador.textContent = plantillaContador
        .replace('[actual]', String(campoMensaje.value.length))
        .replace('[max]', String(maxCaracteres));
    };

    const formatearFecha = function (fecha) {
      const year = fecha.getFullYear();
      const month = String(fecha.getMonth() + 1).padStart(2, '0');
      const day = String(fecha.getDate()).padStart(2, '0');
      return year + '-' + month + '-' + day;
    };

    const configurarFecha = function () {
      const campoFecha = seccion.querySelector('[data-producto-regalo-campo="send_on"]');
      if (!campoFecha) return;
      const hoy = new Date();
      const max = new Date();
      max.setDate(hoy.getDate() + 90);
      campoFecha.setAttribute('min', formatearFecha(hoy));
      campoFecha.setAttribute('max', formatearFecha(max));
    };

    const modoDestinatarioActivo = function () {
      const seleccionado = seccion.querySelector('[data-producto-regalo-modo]:checked');
      return seleccionado && seleccionado.value === 'recipient';
    };

    const actualizarModoEnvio = function () {
      const esDestinatario = modoDestinatarioActivo();

      if (camposDestinatario) {
        camposDestinatario.hidden = !esDestinatario;
      }

      camposRecipiente.forEach(function (campo) {
        campo.disabled = !esDestinatario;
        if (!esDestinatario) {
          campo.removeAttribute('required');
          campo.removeAttribute('aria-invalid');
        }
      });

      const campoEmail = seccion.querySelector('[data-producto-regalo-campo="email"]');
      if (campoEmail && esDestinatario) {
        campoEmail.setAttribute('required', 'required');
      }

      if (flagControl) {
        flagControl.remove();
        flagControl = null;
      }

      if (esDestinatario && formulario) {
        flagControl = document.createElement('input');
        flagControl.type = 'hidden';
        flagControl.name = 'properties[__shopify_send_gift_card_to_recipient]';
        flagControl.value = 'on';
        formulario.appendChild(flagControl);

        if (campoOffset) {
          campoOffset.disabled = false;
          campoOffset.value = String(new Date().getTimezoneOffset());
        }

        configurarFecha();

        if (regionViva) {
          regionViva.textContent = seccion.dataset.textoCamposVisibles || '';
        }

        if (campoEmail) campoEmail.focus();
      } else {
        limpiarCampos();

        if (campoOffset) {
          campoOffset.disabled = true;
          campoOffset.value = '';
        }

        if (regionViva) {
          regionViva.textContent = seccion.dataset.textoCamposOcultos || '';
        }
      }
    };

    radiosModo.forEach(function (radio) {
      radio.addEventListener('change', actualizarModoEnvio);
    });

    if (campoMensaje) {
      campoMensaje.addEventListener('input', actualizarContador);
      actualizarContador();
    }

    if (seccion.dataset.formConErrores === 'true') {
      const radioDestinatario = seccion.querySelector('[data-producto-regalo-modo][value="recipient"]');
      if (radioDestinatario) {
        radioDestinatario.checked = true;
      }
    }

    actualizarModoEnvio();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["productos-vistos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const seccion = document.querySelector('[data-productos-vistos]');
    if (!seccion) return;

    const pista = seccion.querySelector('[data-productos-vistos-pista]');
    const estado = seccion.querySelector('[data-productos-vistos-estado]');
    const editorVacio = seccion.querySelector('[data-productos-vistos-editor-vacio]');
    const btnAnterior = seccion.querySelector('[data-productos-vistos-anterior]');
    const btnSiguiente = seccion.querySelector('[data-productos-vistos-siguiente]');

    const claveAlmacen = seccion.dataset.claveAlmacen || 'productos-vistos-handles';
    const limiteGuardado = Number(seccion.dataset.limiteGuardado || 12);
    const limiteMostrar = Number(seccion.dataset.limiteMostrar || 8);
    const excluirActual = seccion.dataset.excluirActual === 'true';
    const handleActual = seccion.dataset.productoHandle || '';
    const textoSinImagen = seccion.dataset.textoSinImagen || '';
    const etiquetaVerProducto = seccion.dataset.etiquetaVerProducto || '';
    const textoAgotado = seccion.dataset.textoAgotado || '';
    const textoCargando = seccion.dataset.textoCargando || '';
    const textoVacio = seccion.dataset.textoVacio || '';
    const esEditor = seccion.dataset.esEditor === 'true';

    const formatoDinero = seccion.dataset.moneyFormat || '';
    const codigoMoneda = seccion.dataset.currency || '';

    function formatearConDelimitadores(centimos, precision, miles, decimal) {
      const n = Number(centimos);
      if (!Number.isFinite(n)) return '0';
      const fijo = (n / 100).toFixed(precision == null ? 2 : precision);
      const partes = fijo.split('.');
      const entero = partes[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + (miles || ','));
      const decimales = partes[1] ? (decimal || '.') + partes[1] : '';
      return entero + decimales;
    }

    function formatearPrecioShopify(centimos, formato) {
      const plantilla = String(formato || '').replace(/<[^>]*>/g, '');
      const marcador = /\{\{\s*(\w+)\s*\}\}/;
      const match = plantilla.match(marcador);
      if (!match) {
        if (plantilla) return plantilla;
        return formatearConDelimitadores(centimos, 2, '.', ',');
      }

      let valor = '';
      switch (match[1]) {
        case 'amount':
          valor = formatearConDelimitadores(centimos, 2, ',', '.');
          break;
        case 'amount_no_decimals':
          valor = formatearConDelimitadores(centimos, 0, ',', '.');
          break;
        case 'amount_with_comma_separator':
          valor = formatearConDelimitadores(centimos, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          valor = formatearConDelimitadores(centimos, 0, '.', ',');
          break;
        case 'amount_with_apostrophe_separator':
          valor = formatearConDelimitadores(centimos, 2, "'", '.');
          break;
        case 'amount_with_space_separator':
          valor = formatearConDelimitadores(centimos, 2, ' ', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          valor = formatearConDelimitadores(centimos, 0, ' ', ',');
          break;
        case 'amount_with_period_and_space_separator':
          valor = formatearConDelimitadores(centimos, 2, ' ', '.');
          break;
        case 'currency':
          valor = codigoMoneda;
          break;
        default:
          valor = formatearConDelimitadores(centimos, 2, '.', ',');
      }

      return plantilla.replace(marcador, valor);
    }

    function formatearPrecio(centimos) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        const formateado = window.Shopify.formatMoney(centimos, formatoDinero);
        if (formateado && String(formateado).indexOf('{{') === -1) {
          return formateado;
        }
      }
      return formatearPrecioShopify(centimos, formatoDinero);
    }

    function leerHandles() {
      try {
        const datos = window.localStorage.getItem(claveAlmacen);
        const lista = datos ? JSON.parse(datos) : [];
        return Array.isArray(lista) ? lista.filter(Boolean) : [];
      } catch (error) {
        return [];
      }
    }

    function guardarHandles(handles) {
      try {
        window.localStorage.setItem(claveAlmacen, JSON.stringify(handles));
      } catch (error) {
        /* almacenamiento no disponible */
      }
    }

    function registrarVista(handle) {
      if (!handle) return;
      const actuales = leerHandles().filter((item) => item !== handle);
      actuales.unshift(handle);
      guardarHandles(actuales.slice(0, limiteGuardado));
    }

    function obtenerHandlesParaMostrar() {
      let handles = leerHandles();
      if (excluirActual && handleActual) {
        handles = handles.filter((item) => item !== handleActual);
      }
      return handles.slice(0, limiteMostrar);
    }

    function crearTarjeta(producto) {
      const li = document.createElement('li');
      li.className = 'productos-vistos__item';

      const enlace = document.createElement('a');
      enlace.className = 'productos-vistos__tarjeta';
      enlace.href = producto.url;
      enlace.setAttribute('aria-label', `${etiquetaVerProducto} ${producto.title || ''}`);

      const media = document.createElement('div');
      media.className = 'productos-vistos__media';

      if (producto.featured_image) {
        const img = document.createElement('img');
        img.className = 'productos-vistos__imagen';
        img.src = producto.featured_image;
        img.alt = producto.title || '';
        img.loading = 'lazy';
        img.width = 400;
        img.height = 500;
        media.appendChild(img);
      } else {
        const placeholder = document.createElement('span');
        placeholder.className = 'productos-vistos__sin-imagen';
        placeholder.textContent = textoSinImagen;
        media.appendChild(placeholder);
      }

      if (!producto.available) {
        const badge = document.createElement('span');
        badge.className = 'productos-vistos__badge productos-vistos__badge--agotado';
        badge.textContent = textoAgotado;
        media.appendChild(badge);
      } else if (producto.compare_at_price && producto.compare_at_price > producto.price) {
        const ahorro = Math.floor(((producto.compare_at_price - producto.price) * 100) / producto.compare_at_price);
        if (ahorro > 0) {
          const badge = document.createElement('span');
          badge.className = 'productos-vistos__badge productos-vistos__badge--descuento';
          badge.textContent = `-${ahorro}%`;
          media.appendChild(badge);
        }
      }

      const info = document.createElement('div');
      info.className = 'productos-vistos__info';

      const nombre = document.createElement('p');
      nombre.className = 'productos-vistos__nombre';
      nombre.textContent = producto.title || '';

      const precios = document.createElement('div');
      precios.className = 'productos-vistos__precios';

      const actual = document.createElement('span');
      actual.className = 'productos-vistos__precio-actual';
      actual.textContent = formatearPrecio(producto.price);
      precios.appendChild(actual);

      if (producto.compare_at_price && producto.compare_at_price > producto.price) {
        const tachado = document.createElement('s');
        tachado.className = 'productos-vistos__precio-tachado';
        tachado.textContent = formatearPrecio(producto.compare_at_price);
        precios.appendChild(tachado);
      }

      info.appendChild(nombre);
      info.appendChild(precios);
      enlace.appendChild(media);
      enlace.appendChild(info);
      li.appendChild(enlace);
      return li;
    }

    async function cargarProducto(handle) {
      const respuesta = await fetch(`/products/${encodeURIComponent(handle)}.js`, {
        headers: { Accept: 'application/json' },
      });
      if (!respuesta.ok) throw new Error('producto no encontrado');
      return respuesta.json();
    }

    function mostrarEstado(texto) {
      if (!estado) return;
      if (!texto) {
        estado.hidden = true;
        estado.textContent = '';
        return;
      }
      estado.hidden = false;
      estado.textContent = texto;
    }

    function ocultarSeccion() {
      seccion.hidden = true;
      if (editorVacio) editorVacio.hidden = false;
    }

    function mostrarSeccion() {
      seccion.hidden = false;
      if (editorVacio) editorVacio.hidden = true;
    }

    async function renderizar() {
      const handles = obtenerHandlesParaMostrar();

      if (!handles.length) {
        if (esEditor) {
          mostrarSeccion();
          mostrarEstado(textoVacio);
          pista.innerHTML = '';
        } else {
          ocultarSeccion();
        }
        return;
      }

      mostrarSeccion();
      mostrarEstado(textoCargando);
      pista.innerHTML = '';

      const resultados = await Promise.allSettled(handles.map((handle) => cargarProducto(handle)));
      const productos = resultados
        .filter((resultado) => resultado.status === 'fulfilled')
        .map((resultado) => resultado.value);

      pista.innerHTML = '';
      mostrarEstado('');

      if (!productos.length) {
        if (esEditor) {
          mostrarEstado(textoVacio);
        } else {
          ocultarSeccion();
        }
        return;
      }

      productos.forEach((producto) => {
        pista.appendChild(crearTarjeta(producto));
      });
    }

    function desplazar(direccion) {
      const item = pista.querySelector('.productos-vistos__item');
      if (!item) return;
      const estilos = getComputedStyle(pista);
      const gap = parseFloat(estilos.columnGap || estilos.gap || '0') || 0;
      const distancia = item.getBoundingClientRect().width + gap;
      pista.scrollBy({ left: direccion * distancia, behavior: 'smooth' });
    }

    if (handleActual) {
      registrarVista(handleActual);
    }

    renderizar();

    btnAnterior?.addEventListener('click', () => desplazar(-1));
    btnSiguiente?.addEventListener('click', () => desplazar(1));

    pista?.addEventListener('keydown', (evento) => {
      if (evento.key === 'ArrowLeft') {
        evento.preventDefault();
        desplazar(-1);
      }
      if (evento.key === 'ArrowRight') {
        evento.preventDefault();
        desplazar(1);
      }
    });

    document.addEventListener('producto:visto', (evento) => {
      if (evento.detail?.handle) {
        registrarVista(evento.detail.handle);
        renderizar();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["progreso-envio-gratis"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const contenedor = document.querySelector('[data-progreso-envio-gratis]');
    if (!contenedor) return;

    const activo = contenedor.dataset.activo === 'true';
    const reubicar = contenedor.dataset.reubicar === 'true';
    const umbral = Number(contenedor.dataset.umbral || 0);
    const incluirProducto = contenedor.dataset.incluirProducto === 'true';
    const urlCarrito = contenedor.dataset.urlCarrito;
    const esEditor = contenedor.dataset.editor === 'true';

    const textoEl = contenedor.querySelector('[data-progreso-envio-texto]');
    const barraEl = contenedor.querySelector('[data-progreso-envio-barra]');
    const porcentajeEl = contenedor.querySelector('[data-progreso-envio-porcentaje]');
    const hitos = contenedor.querySelectorAll('[data-progreso-envio-hito]');

    const textos = {
      restante: contenedor.dataset.textoRestante || '',
      conseguido: contenedor.dataset.textoConseguido || '',
      vacio: contenedor.dataset.textoVacio || '',
      simulado: contenedor.dataset.textoSimulado || '',
    };

    let precioProducto = Number(contenedor.dataset.productoPrecio || 0);
    let productoDisponible = contenedor.dataset.productoDisponible === 'true';
    let ejemploPrecio = textoEl?.textContent?.trim() || '';

    const formatearPrecio = (centimos) => {
      const numero = Number(centimos) / 100;
      const simbolo = ejemploPrecio.replace(/[\d\s.,]/g, '').trim() || '€';
      const conDecimales = /\.\d{2}|,\d{2}/.test(ejemploPrecio);
      const valor = conDecimales ? numero.toFixed(2).replace('.', ',') : Math.round(numero).toString();
      if (ejemploPrecio.indexOf(simbolo) === 0) return `${simbolo}${valor}`;
      return `${valor} ${simbolo}`;
    };

    const reemplazarTokens = (plantilla, valores) =>
      Object.entries(valores).reduce(
        (texto, [token, valor]) => texto.replaceAll(`[[${token}]]`, valor),
        plantilla
      );

    const calcularTotal = (carrito) => {
      let total = Number(carrito?.total_price || 0);
      if (incluirProducto && productoDisponible) {
        total += precioProducto;
      }
      return total;
    };

    const actualizarHitos = (totalCentimos) => {
      hitos.forEach((hito) => {
        const minimo = Number(hito.dataset.importeMinimo || 0);
        hito.classList.toggle('progreso-envio-gratis__hito--activo', totalCentimos >= minimo);
      });
    };

    const renderizar = (carrito) => {
      if (!activo && !esEditor) {
        contenedor.hidden = true;
        return;
      }

      contenedor.hidden = false;

      if (!umbral) return;

      const umbralCentimos = umbral * 100;
      const total = calcularTotal(carrito);
      const restante = Math.max(0, umbralCentimos - total);
      const progreso = Math.min(100, Math.round((total * 100) / umbralCentimos));

      if (barraEl) barraEl.style.width = `${progreso}%`;
      if (porcentajeEl) porcentajeEl.textContent = `${progreso}%`;
      actualizarHitos(total);

      if (!textoEl) return;

      if (restante > 0) {
        const importe = formatearPrecio(restante);
        const umbralFormateado = formatearPrecio(umbralCentimos);
        let mensaje = reemplazarTokens(textos.restante, {
          importe,
          umbral: umbralFormateado,
          progreso: String(progreso),
        });

        if ((carrito?.item_count || 0) <= 0 && incluirProducto && productoDisponible && textos.simulado) {
          mensaje = `${mensaje} ${textos.simulado}`;
        } else if ((carrito?.item_count || 0) <= 0 && textos.vacio) {
          mensaje = textos.vacio.replace('[[importe]]', importe).replace('[[umbral]]', umbralFormateado);
        }

        textoEl.textContent = mensaje;
        textoEl.classList.remove('progreso-envio-gratis__texto--completo');
      } else {
        textoEl.textContent = textos.conseguido;
        textoEl.classList.add('progreso-envio-gratis__texto--completo');
      }
    };

    const reubicarEnPdp = () => {
      if (!reubicar) return;
      const ancla = document.querySelector('[data-progreso-envio-ancla]');
      if (!ancla || ancla.contains(contenedor)) return;
      ancla.appendChild(contenedor);
    };

    const refrescarCarrito = () =>
      fetch(urlCarrito, { headers: { Accept: 'application/json' } })
        .then((respuesta) => respuesta.json())
        .then((carrito) => {
          renderizar(carrito);
          return carrito;
        })
        .catch(() => renderizar({ item_count: 0, total_price: 0 }));

    document.addEventListener('cart:updated', (evento) => {
      if (evento.detail?.cart) {
        renderizar(evento.detail.cart);
      } else {
        refrescarCarrito();
      }
    });

    document.addEventListener('producto:variante-cambiada', (evento) => {
      const variante = evento.detail?.variante;
      if (!variante) return;
      precioProducto = Number(variante.price || 0);
      productoDisponible = Boolean(variante.available);
      contenedor.dataset.productoPrecio = String(precioProducto);
      contenedor.dataset.productoDisponible = productoDisponible ? 'true' : 'false';
      refrescarCarrito();
    });

    reubicarEnPdp();
    refrescarCarrito();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["progreso-regalo-carrito"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const contenedor = document.querySelector('[data-progreso-regalo-carrito]');
    if (!contenedor) return;

    const activo = contenedor.dataset.activo === 'true';
    const esEditor = contenedor.dataset.editor === 'true';
    const ocultarVacio = contenedor.dataset.ocultarVacio === 'true';
    const urlCarrito = contenedor.dataset.urlCarrito;
    const textos = {
      restante: contenedor.dataset.textoRestante || '',
      conseguido: contenedor.dataset.textoConseguido || '',
      vacio: contenedor.dataset.textoCarritoVacio || '',
      generico: contenedor.dataset.textoRegaloGenerico || 'Regalo',
    };

    const textoEl = contenedor.querySelector('[data-progreso-regalo-texto]');
    const barraEl = contenedor.querySelector('[data-progreso-regalo-barra]');
    const porcentajeEl = contenedor.querySelector('[data-progreso-regalo-porcentaje]');
    const mediaEl = contenedor.querySelector('[data-progreso-regalo-media]');
    const imagenEl = contenedor.querySelector('[data-progreso-regalo-imagen]');
    const nivelesEl = contenedor.querySelectorAll('[data-progreso-regalo-nivel]');

    let regalos = [];
    const scriptRegalos = contenedor.querySelector('[data-progreso-regalo-datos]');

    if (scriptRegalos) {
      try {
        regalos = JSON.parse(scriptRegalos.textContent || '[]');
      } catch (error) {
        regalos = [];
      }
    }

    regalos.sort((a, b) => a.importeMinimo - b.importeMinimo);

    const formatearPrecio = (centimos) => {
      if (window.Shopify?.formatMoney) {
        return window.Shopify.formatMoney(centimos);
      }
      const valor = (centimos / 100).toFixed(2).replace('.', ',');
      return `${valor} €`;
    };

    const reemplazarTokens = (plantilla, valores) =>
      Object.entries(valores).reduce(
        (texto, [token, valor]) => texto.replaceAll(`[[${token}]]`, valor),
        plantilla || ''
      );

    const encontrarRegaloActivo = (totalCentimos) => {
      let conseguido = null;

      for (const regalo of regalos) {
        if (totalCentimos >= regalo.importeMinimo) {
          conseguido = regalo;
        } else {
          return { activo: regalo, conseguido, umbral: regalo.importeMinimo };
        }
      }

      if (conseguido) {
        return { activo: conseguido, conseguido, umbral: conseguido.importeMinimo };
      }

      return { activo: regalos[0] || null, conseguido: null, umbral: regalos[0]?.importeMinimo || 0 };
    };

    const actualizarNiveles = (totalCentimos) => {
      nivelesEl.forEach((nivel) => {
        const minimo = Number(nivel.dataset.importeMinimo || 0);
        nivel.classList.toggle('progreso-regalo-carrito__nivel--activo', totalCentimos >= minimo);
      });
    };

    const actualizarImagen = (regalo) => {
      if (!mediaEl || !imagenEl || !regalo) return;

      if (regalo.imagen) {
        mediaEl.hidden = false;
        imagenEl.hidden = false;
        imagenEl.src = regalo.imagen;
        imagenEl.alt = regalo.nombreProducto || textos.generico;
      } else {
        mediaEl.hidden = true;
        imagenEl.removeAttribute('src');
        imagenEl.alt = '';
      }
    };

    const renderizar = (carrito) => {
      const itemCount = Number(carrito?.item_count || 0);
      const total = Number(carrito?.total_price || 0);

      if (!activo && !esEditor) {
        contenedor.hidden = true;
        return;
      }

      if (ocultarVacio && itemCount <= 0 && !esEditor) {
        contenedor.hidden = true;
        return;
      }

      contenedor.hidden = false;

      if (!regalos.length) return;

      const { activo: regaloActivo, conseguido, umbral } = encontrarRegaloActivo(total);
      const restante = Math.max(0, umbral - total);
      const progreso = umbral > 0 ? Math.min(100, Math.round((total * 100) / umbral)) : 0;
      const completo = restante <= 0 && itemCount > 0 && conseguido != null;

      contenedor.classList.toggle('progreso-regalo-carrito--completo', completo);

      if (barraEl) barraEl.style.width = `${progreso}%`;
      if (porcentajeEl) porcentajeEl.textContent = `${progreso}%`;
      actualizarNiveles(total);
      actualizarImagen(regaloActivo);

      if (!textoEl) return;

      const importe = formatearPrecio(restante);
      const umbralFormateado = formatearPrecio(umbral);
      const nombreProducto = regaloActivo?.nombreProducto || textos.generico;

      if (itemCount <= 0) {
        textoEl.textContent = reemplazarTokens(textos.vacio, {
          importe,
          restante: importe,
          umbral: umbralFormateado,
          producto: nombreProducto,
          progreso: String(progreso),
        });
        return;
      }

      if (completo) {
        const mensajeConseguido = regaloActivo?.textoConseguido || textos.conseguido;
        textoEl.textContent = reemplazarTokens(mensajeConseguido, {
          importe,
          restante: importe,
          umbral: umbralFormateado,
          producto: nombreProducto,
          progreso: String(progreso),
        });
        return;
      }

      textoEl.textContent = reemplazarTokens(textos.restante, {
        importe,
        restante: importe,
        umbral: umbralFormateado,
        producto: nombreProducto,
        progreso: String(progreso),
      });
    };

    const refrescarCarrito = () =>
      fetch(urlCarrito, { headers: { Accept: 'application/json' } })
        .then((respuesta) => respuesta.json())
        .then((carrito) => {
          renderizar(carrito);
          return carrito;
        })
        .catch(() => renderizar({ item_count: 0, total_price: 0 }));

    document.addEventListener('cart:updated', (evento) => {
      if (evento.detail?.cart) {
        renderizar(evento.detail.cart);
      } else {
        refrescarCarrito();
      }
    });

    renderizar({
      item_count: Number(contenedor.dataset.cartItemCount) || 0,
      total_price: Number(contenedor.dataset.cartTotalPrice) || 0,
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prueba-social"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const contenedor = document.querySelector('[data-prueba-social]');
    if (!contenedor) return;

    const activo = contenedor.dataset.activo === 'true';
    const intervaloMs = Math.max(5, Number(contenedor.dataset.intervalo || 12)) * 1000;
    const duracionMs = Math.max(2000, Number(contenedor.dataset.duracion || 5000));
    const retrasoMs = Math.max(0, Number(contenedor.dataset.retraso || 3)) * 1000;
    const pausarHover = contenedor.dataset.pausarHover === 'true';
    const respetarMovimiento = contenedor.dataset.respetarMovimiento === 'true';
    const plantilla = contenedor.dataset.plantilla || '[[nombre]] de [[ciudad]] acaba de comprar [[producto]]';
    const panel = contenedor.querySelector('[data-prueba-social-panel]');
    const media = contenedor.querySelector('[data-prueba-social-media]');
    const imagen = contenedor.querySelector('[data-prueba-social-imagen]');
    const mensaje = contenedor.querySelector('[data-prueba-social-mensaje]');
    const tiempoEl = contenedor.querySelector('[data-prueba-social-tiempo]');
    const cerrar = contenedor.querySelector('[data-prueba-social-cerrar]');

    if (respetarMovimiento) {
      contenedor.setAttribute('data-respetar-movimiento', 'true');
    }

    let avisos = [];
    const scriptAvisos = contenedor.querySelector('[data-prueba-social-avisos]');

    if (scriptAvisos) {
      try {
        avisos = JSON.parse(scriptAvisos.textContent || '[]');
      } catch (error) {
        avisos = [];
      }
    }

    if (!activo || !avisos.length) return;

    let indice = 0;
    let temporizadorOcultar = null;
    let temporizadorSiguiente = null;
    let pausado = false;
    let cerradoSesion = false;

    const reemplazarTokens = (texto, aviso) =>
      (texto || '')
        .replaceAll('[[nombre]]', aviso.nombre || '')
        .replaceAll('[[ciudad]]', aviso.ciudad || '')
        .replaceAll('[[producto]]', aviso.producto || '')
        .replaceAll('[[tiempo]]', aviso.tiempo || '');

    const ocultar = () => {
      contenedor.removeAttribute('data-visible');
      window.clearTimeout(temporizadorOcultar);
      temporizadorOcultar = window.setTimeout(() => {
        contenedor.hidden = true;
      }, 280);
    };

    const mostrarAviso = (aviso) => {
      if (cerradoSesion || pausado) return;

      mensaje.textContent = reemplazarTokens(plantilla, aviso);

      if (aviso.tiempo && tiempoEl) {
        tiempoEl.hidden = false;
        tiempoEl.textContent = aviso.tiempo;
      } else if (tiempoEl) {
        tiempoEl.hidden = true;
        tiempoEl.textContent = '';
      }

      if (aviso.imagen && media && imagen) {
        media.hidden = false;
        imagen.src = aviso.imagen;
        imagen.alt = aviso.producto || '';
      } else if (media && imagen) {
        media.hidden = true;
        imagen.removeAttribute('src');
        imagen.alt = '';
      }

      contenedor.hidden = false;
      requestAnimationFrame(() => {
        contenedor.setAttribute('data-visible', '');
      });

      window.clearTimeout(temporizadorOcultar);
      temporizadorOcultar = window.setTimeout(ocultar, duracionMs);
    };

    const programarSiguiente = () => {
      window.clearTimeout(temporizadorSiguiente);
      temporizadorSiguiente = window.setTimeout(() => {
        if (cerradoSesion || pausado) return;
        mostrarAviso(avisos[indice]);
        indice = (indice + 1) % avisos.length;
        programarSiguiente();
      }, intervaloMs);
    };

    cerrar?.addEventListener('click', () => {
      cerradoSesion = true;
      ocultar();
      window.clearTimeout(temporizadorSiguiente);
    });

    if (pausarHover && panel) {
      panel.addEventListener('mouseenter', () => {
        pausado = true;
        window.clearTimeout(temporizadorOcultar);
        window.clearTimeout(temporizadorSiguiente);
      });
      panel.addEventListener('mouseleave', () => {
        if (cerradoSesion) return;
        pausado = false;
        programarSiguiente();
      });
    }

    window.setTimeout(() => {
      if (cerradoSesion) return;
      mostrarAviso(avisos[indice]);
      indice = (indice + 1) % avisos.length;
      programarSiguiente();
    }, retrasoMs);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quiz-tallas"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const seccion = document.querySelector('[data-quiz-tallas]');
    if (!seccion) return;

    const totalPreguntas = parseInt(seccion.getAttribute('data-total-preguntas') || '0', 10);
    if (!totalPreguntas) return;

    const vistaIntro = seccion.querySelector('[data-quiz-tallas-vista="intro"]');
    const vistasPregunta = Array.from(seccion.querySelectorAll('[data-quiz-tallas-vista="pregunta"]'));
    const vistaResultado = seccion.querySelector('[data-quiz-tallas-vista="resultado"]');
    const progreso = seccion.querySelector('[data-quiz-tallas-progreso]');
    const progresoAccesible = seccion.querySelector('[data-quiz-tallas-progreso-accesible]');
    const pasoActualEl = seccion.querySelector('[data-quiz-tallas-paso-actual]');
    const resultadosJson = seccion.querySelector('[data-quiz-tallas-resultados]');

    const resultadoTitulo = seccion.querySelector('[data-quiz-tallas-resultado-titulo]');
    const resultadoTalla = seccion.querySelector('[data-quiz-tallas-resultado-talla]');
    const resultadoDescripcion = seccion.querySelector('[data-quiz-tallas-resultado-descripcion]');
    const enlacePrimario = seccion.querySelector('[data-quiz-tallas-resultado-enlace-primario]');
    const enlaceSecundario = seccion.querySelector('[data-quiz-tallas-resultado-enlace-secundario]');

    let indiceActual = -1;
    let resultados = [];

    try {
      resultados = JSON.parse(resultadosJson ? resultadosJson.textContent : '[]');
    } catch (error) {
      resultados = [];
    }

    const ocultarTodas = function () {
      if (vistaIntro) vistaIntro.hidden = true;
      vistasPregunta.forEach(function (vista) {
        vista.hidden = true;
      });
      if (vistaResultado) vistaResultado.hidden = true;
    };

    const actualizarProgreso = function () {
      const paso = indiceActual < 0 ? 0 : indiceActual + 1;
      const porcentaje = totalPreguntas ? (paso / totalPreguntas) * 100 : 0;

      if (progreso) progreso.style.width = porcentaje + '%';
      if (pasoActualEl) pasoActualEl.textContent = String(paso);
      if (progresoAccesible) progresoAccesible.setAttribute('aria-valuenow', String(paso));
    };

    const mostrarIntro = function () {
      indiceActual = -1;
      ocultarTodas();
      if (vistaIntro) vistaIntro.hidden = false;
      actualizarProgreso();
    };

    const mostrarPregunta = function (indice) {
      indiceActual = indice;
      ocultarTodas();
      const vista = vistasPregunta[indice];
      if (vista) {
        vista.hidden = false;
        const error = vista.querySelector('[data-quiz-tallas-error]');
        if (error) error.hidden = true;
      }
      actualizarProgreso();
    };

    const obtenerSeleccion = function (vista) {
      const inputs = Array.from(vista.querySelectorAll('[data-quiz-tallas-opcion]:checked'));
      return inputs;
    };

    const validarPaso = function (vista) {
      const seleccion = obtenerSeleccion(vista);
      const error = vista.querySelector('[data-quiz-tallas-error]');
      const valido = seleccion.length > 0;

      if (error) error.hidden = valido;
      return valido;
    };

    const calcularPuntuacion = function () {
      let total = 0;
      const claves = {};

      vistasPregunta.forEach(function (vista) {
        obtenerSeleccion(vista).forEach(function (input) {
          total += parseInt(input.getAttribute('data-puntos') || '0', 10);
          const clave = input.getAttribute('data-resultado-clave');
          if (clave) claves[clave] = (claves[clave] || 0) + 1;
        });
      });

      return { total: total, claves: claves };
    };

    const encontrarResultado = function (puntuacion) {
      if (!resultados.length) return null;

      const porClave = resultados.find(function (item) {
        return item.clave && puntuacion.claves[item.clave];
      });
      if (porClave) return porClave;

      return resultados.find(function (item) {
        return puntuacion.total >= item.puntosMin && puntuacion.total <= item.puntosMax;
      }) || resultados[resultados.length - 1];
    };

    const mostrarResultado = function () {
      const puntuacion = calcularPuntuacion();
      const resultado = encontrarResultado(puntuacion);

      ocultarTodas();
      if (!vistaResultado || !resultado) return;

      if (resultadoTitulo) resultadoTitulo.textContent = resultado.titulo || '';
      if (resultadoTalla) resultadoTalla.textContent = resultado.talla || '';
      if (resultadoDescripcion) resultadoDescripcion.textContent = resultado.descripcion || '';

      if (enlacePrimario) {
        if (resultado.enlacePrimario && resultado.textoEnlacePrimario) {
          enlacePrimario.href = resultado.enlacePrimario;
          enlacePrimario.textContent = resultado.textoEnlacePrimario;
          enlacePrimario.hidden = false;
        } else {
          enlacePrimario.hidden = true;
        }
      }

      if (enlaceSecundario) {
        if (resultado.enlaceSecundario && resultado.textoEnlaceSecundario) {
          enlaceSecundario.href = resultado.enlaceSecundario;
          enlaceSecundario.textContent = resultado.textoEnlaceSecundario;
          enlaceSecundario.hidden = false;
        } else {
          enlaceSecundario.hidden = true;
        }
      }

      vistaResultado.hidden = false;
      if (progreso) progreso.style.width = '100%';
      if (pasoActualEl) pasoActualEl.textContent = String(totalPreguntas);
      if (progresoAccesible) progresoAccesible.setAttribute('aria-valuenow', String(totalPreguntas));
    };

    const reiniciar = function () {
      seccion.querySelectorAll('[data-quiz-tallas-opcion]').forEach(function (input) {
        input.checked = false;
      });
      mostrarIntro();
    };

    seccion.querySelector('[data-quiz-tallas-iniciar]')?.addEventListener('click', function () {
      mostrarPregunta(0);
    });

    seccion.querySelector('[data-quiz-tallas-volver-intro]')?.addEventListener('click', function () {
      mostrarIntro();
    });

    seccion.querySelectorAll('[data-quiz-tallas-anterior]').forEach(function (boton) {
      boton.addEventListener('click', function () {
        if (indiceActual > 0) mostrarPregunta(indiceActual - 1);
        else mostrarIntro();
      });
    });

    seccion.querySelectorAll('[data-quiz-tallas-siguiente]').forEach(function (boton) {
      boton.addEventListener('click', function () {
        const vista = vistasPregunta[indiceActual];
        if (!vista || !validarPaso(vista)) return;
        if (indiceActual < vistasPregunta.length - 1) mostrarPregunta(indiceActual + 1);
      });
    });

    seccion.querySelectorAll('[data-quiz-tallas-finalizar]').forEach(function (boton) {
      boton.addEventListener('click', function () {
        const vista = vistasPregunta[indiceActual];
        if (!vista || !validarPaso(vista)) return;
        mostrarResultado();
      });
    });

    seccion.querySelector('[data-quiz-tallas-reiniciar]')?.addEventListener('click', reiniciar);

    seccion.querySelectorAll('.quiz-tallas__opcion-input').forEach(function (input) {
      input.addEventListener('change', function () {
        const vista = input.closest('[data-quiz-tallas-vista="pregunta"]');
        if (!vista) return;

        const esRadio = input.type === 'radio';
        if (esRadio) {
          vista.querySelectorAll('.quiz-tallas__opcion').forEach(function (opcion) {
            opcion.classList.remove('quiz-tallas__opcion--seleccionada');
          });
        }

        if (input.checked) {
          input.closest('.quiz-tallas__opcion')?.classList.add('quiz-tallas__opcion--seleccionada');
        } else {
          input.closest('.quiz-tallas__opcion')?.classList.remove('quiz-tallas__opcion--seleccionada');
        }

        const error = vista.querySelector('[data-quiz-tallas-error]');
        if (error) error.hidden = true;
      });
    });

    mostrarIntro();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["selector-pais"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const drawer = document.querySelector('[data-selector-pais]');
    if (!drawer) return;

    const panel = drawer.querySelector('[data-selector-pais-panel]');
    const formulario = drawer.querySelector('[data-selector-pais-formulario]');
    const countryInput = drawer.querySelector('[data-selector-pais-country-input]');
    const filtro = drawer.querySelector('[data-selector-pais-filtro]');
    const limpiarFiltro = drawer.querySelector('[data-selector-pais-limpiar-filtro]');
    const filtroVivo = drawer.querySelector('[data-selector-pais-filtro-vivo]');
    const sinResultados = drawer.querySelector('[data-selector-pais-sin-resultados]');
    const items = Array.from(drawer.querySelectorAll('[data-selector-pais-item]'));
    const idiomaSelect = drawer.querySelector('[data-selector-pais-idioma]');

    const textoResultados = drawer.dataset.textoResultados || '';
    const textoSinResultados = drawer.dataset.textoSinResultados || '';

    let focoAnterior = null;

    const selectoresFoco =
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    function atraparFoco(contenedor) {
      contenedor.addEventListener('keydown', function manejarTab(evento) {
        if (evento.key !== 'Tab') return;
        const elementos = Array.from(contenedor.querySelectorAll(selectoresFoco)).filter(function (el) {
          return !el.closest('[hidden]') && el.offsetParent !== null;
        });
        if (!elementos.length) return;

        const primero = elementos[0];
        const ultimo = elementos[elementos.length - 1];

        if (evento.shiftKey && document.activeElement === primero) {
          evento.preventDefault();
          ultimo.focus();
        } else if (!evento.shiftKey && document.activeElement === ultimo) {
          evento.preventDefault();
          primero.focus();
        }
      });
    }

    function abrirDrawer() {
      focoAnterior = document.activeElement;
      drawer.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(function () {
        drawer.setAttribute('data-abierto', '');
        if (window.NaiaUI) window.NaiaUI.bloquearScroll(drawer);
        else document.body.style.overflow = 'hidden';
        const foco = drawer.querySelector('[data-selector-pais-cerrar]');
        if (foco) foco.focus();
        atraparFoco(panel);
      });
    }

    function cerrarDrawer() {
      drawer.removeAttribute('data-abierto');
      drawer.setAttribute('aria-hidden', 'true');
      if (window.NaiaUI) window.NaiaUI.desbloquearScroll(drawer);
      else document.body.style.overflow = '';
      window.setTimeout(function () {
        drawer.hidden = true;
      }, 300);
      if (filtro) {
        filtro.value = '';
        filtrarPaises('');
        if (limpiarFiltro) limpiarFiltro.hidden = true;
      }
      if (focoAnterior && typeof focoAnterior.focus === 'function') focoAnterior.focus();
    }

    function enviarFormulario() {
      if (!formulario) return;
      formulario.submit();
    }

    function filtrarPaises(termino) {
      const consulta = termino.trim().toLowerCase();
      let visibles = 0;

      items.forEach(function (item) {
        const nombre = item.getAttribute('data-nombre') || '';
        const alias = item.getAttribute('data-alias') || '';
        const coincide = !consulta || nombre.indexOf(consulta) !== -1 || alias.indexOf(consulta) !== -1;
        item.hidden = !coincide;
        if (coincide) visibles += 1;
      });

      if (sinResultados) sinResultados.hidden = visibles > 0;
      if (filtroVivo) {
        if (!consulta) {
          filtroVivo.textContent = '';
        } else if (visibles === 0) {
          filtroVivo.textContent = textoSinResultados;
        } else {
          filtroVivo.textContent = textoResultados.replace('[[count]]', String(visibles));
        }
      }
    }

    document.addEventListener('cabecera:abrir-selector-pais', abrirDrawer);

    document.querySelectorAll('[data-abrir-selector-pais]').forEach(function (boton) {
      boton.addEventListener('click', abrirDrawer);
    });

    drawer.querySelectorAll('[data-selector-pais-cerrar]').forEach(function (boton) {
      boton.addEventListener('click', cerrarDrawer);
    });

    drawer.querySelectorAll('[data-selector-pais-opcion]').forEach(function (boton) {
      boton.addEventListener('click', function () {
        if (!countryInput) return;
        countryInput.value = boton.getAttribute('data-country-code') || '';
        enviarFormulario();
      });
    });

    if (idiomaSelect) {
      idiomaSelect.addEventListener('change', enviarFormulario);
    }

    if (filtro) {
      filtro.addEventListener('input', function () {
        const valor = filtro.value;
        if (limpiarFiltro) limpiarFiltro.hidden = !valor.length;
        filtrarPaises(valor);
      });
    }

    if (limpiarFiltro && filtro) {
      limpiarFiltro.addEventListener('click', function () {
        filtro.value = '';
        limpiarFiltro.hidden = true;
        filtrarPaises('');
        filtro.focus();
      });
    }

    document.addEventListener('keydown', function (evento) {
      if (evento.key === 'Escape' && drawer.hasAttribute('data-abierto')) {
        cerrarDrawer();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-promo-pdp"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const seccion = document.querySelector('[data-sticky-promo-pdp]');
    if (!seccion) return;

    const boton = seccion.querySelector('[data-sticky-promo-boton]');
    const precioEl = seccion.querySelector('[data-sticky-promo-precio]');
    const precioCompararEl = seccion.querySelector('[data-sticky-promo-precio-comparar]');
    const varianteEl = seccion.querySelector('[data-sticky-promo-variante]');
    const imagenEl = seccion.querySelector('[data-sticky-promo-imagen]');
    const variantes = JSON.parse(
      seccion.querySelector('[data-sticky-promo-variantes]')?.textContent || '[]'
    );

    const posicion = seccion.dataset.posicion || 'superior';
    const respetarMovimiento = seccion.dataset.respetarMovimiento === 'true';
    const textoAgotado = seccion.dataset.textoAgotado || '';
    const botonPrincipal = document.querySelector('[data-producto-principal-boton-anadir]');
    const cabeceraBarra = document.querySelector('[data-cabecera-barra]');
    const stickyMovil = document.querySelector('[data-producto-principal-sticky]');

    if (respetarMovimiento) {
      seccion.setAttribute('data-respetar-movimiento', 'true');
    }

    const formatearPrecio = (centimos) => {
      const ejemplo = precioEl?.textContent?.trim() || '';
      const numero = Number(centimos) / 100;
      const simbolo = ejemplo.replace(/[\d\s.,]/g, '').trim() || '€';
      const conDecimales = /\.\d{2}|,\d{2}/.test(ejemplo);
      const valor = conDecimales ? numero.toFixed(2).replace('.', ',') : Math.round(numero).toString();
      if (ejemplo.indexOf(simbolo) === 0) return `${simbolo}${valor}`;
      return `${valor} ${simbolo}`;
    };

    const actualizarOffsets = () => {
      if (posicion === 'superior' && cabeceraBarra) {
        seccion.style.setProperty('--sticky-promo-offset-top', `${cabeceraBarra.offsetHeight}px`);
      }

      if (posicion === 'inferior') {
        let offset = 0;
        if (stickyMovil && !stickyMovil.hidden && window.getComputedStyle(stickyMovil).display !== 'none') {
          offset += stickyMovil.offsetHeight;
        }
        seccion.style.setProperty('--sticky-promo-offset-bottom', `${offset}px`);
      }
    };

    const mostrarBarra = (visible) => {
      seccion.hidden = false;
      if (visible) {
        seccion.setAttribute('data-visible', '');
      } else {
        seccion.removeAttribute('data-visible');
      }
    };

    const actualizarVariante = (variante) => {
      if (!variante) return;

      if (precioEl) precioEl.textContent = formatearPrecio(variante.price);

      if (precioCompararEl) {
        const enOferta =
          variante.compare_at_price != null && Number(variante.compare_at_price) > Number(variante.price);
        if (enOferta) {
          precioCompararEl.hidden = false;
          precioCompararEl.textContent = formatearPrecio(variante.compare_at_price);
        } else {
          precioCompararEl.hidden = true;
          precioCompararEl.textContent = '';
        }
      }

      if (varianteEl) varianteEl.textContent = variante.title || '';

      if (imagenEl && variante.featured_image?.src) {
        imagenEl.src = variante.featured_image.src;
      }

      if (boton) {
        const disponible = Boolean(variante.available);
        boton.disabled = !disponible;
        boton.textContent = disponible
          ? boton.dataset.textoDisponible || boton.textContent
          : textoAgotado || boton.dataset.textoAgotado || boton.textContent;
      }
    };

    if (boton) {
      boton.dataset.textoDisponible = boton.textContent.trim();
      boton.dataset.textoAgotado = textoAgotado;
      boton.addEventListener('click', () => {
        botonPrincipal?.click();
      });
    }

    if (botonPrincipal) {
      const observador = new IntersectionObserver(
        ([entrada]) => {
          mostrarBarra(!entrada.isIntersecting);
          actualizarOffsets();
        },
        { threshold: 0, rootMargin: '0px 0px -8px 0px' }
      );
      observador.observe(botonPrincipal);
    }

    document.addEventListener('producto:variante-cambiada', (evento) => {
      if (evento.detail?.variante) {
        actualizarVariante(evento.detail.variante);
      }
    });

    actualizarOffsets();
    window.addEventListener('resize', actualizarOffsets, { passive: true });

    if (stickyMovil) {
      const observadorSticky = new MutationObserver(actualizarOffsets);
      observadorSticky.observe(stickyMovil, { attributes: true, attributeFilter: ['hidden'] });
    }

    const varianteInicial = (() => {
      const params = new URLSearchParams(window.location.search);
      const varianteId = Number(params.get('variant'));
      if (varianteId) {
        const encontrada = variantes.find((item) => Number(item.id) === varianteId);
        if (encontrada) return encontrada;
      }
      return variantes.find((item) => item.available) || variantes[0];
    })();

    actualizarVariante(varianteInicial);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tarjeta-regalo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const seccion = document.querySelector('[data-tarjeta-regalo]');
    if (!seccion) return;

    const botonCopiar = seccion.querySelector('[data-tarjeta-regalo-copiar]');
    const mensajeCopiado = seccion.querySelector('[data-tarjeta-regalo-copiado]');

    if (botonCopiar) {
      botonCopiar.addEventListener('click', async function () {
        const codigo = botonCopiar.getAttribute('data-codigo') || '';
        if (!codigo) return;

        try {
          if (navigator.clipboard && navigator.clipboard.writeText) {
            await navigator.clipboard.writeText(codigo);
          } else {
            const campo = document.createElement('textarea');
            campo.value = codigo;
            campo.setAttribute('readonly', '');
            campo.style.position = 'absolute';
            campo.style.left = '-9999px';
            document.body.appendChild(campo);
            campo.select();
            document.execCommand('copy');
            document.body.removeChild(campo);
          }

          if (mensajeCopiado) {
            mensajeCopiado.hidden = false;
            window.setTimeout(function () {
              mensajeCopiado.hidden = true;
            }, 3000);
          }
        } catch (error) {
          console.error('No se pudo copiar el código de la tarjeta regalo', error);
        }
      });
    }

    const contenedorQr = seccion.querySelector('[data-tarjeta-regalo-qr]');
    if (!contenedorQr || typeof window.__tarjetaRegaloInitQr !== 'function') return;

    window.__tarjetaRegaloInitQr(contenedorQr);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonios-inicio"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const seccion = document.querySelector('[data-testimonios-inicio]');
    if (!seccion) return;

    const pista = seccion.querySelector('[data-testimonios-inicio-pista]');
    if (!pista) return;

    const btnAnterior = seccion.querySelector('[data-testimonios-inicio-anterior]');
    const btnSiguiente = seccion.querySelector('[data-testimonios-inicio-siguiente]');
    const indicadoresContenedor = seccion.querySelector('[data-testimonios-inicio-indicadores]');
    const tarjetas = [...pista.children];
    const autoplay = seccion.dataset.autoplay === 'true';
    const intervaloMs = Math.max(3000, Number(seccion.dataset.intervalo || 6) * 1000);
    const pausarHover = seccion.dataset.pausarHover === 'true';
    const respetarMovimiento = seccion.dataset.respetarMovimiento === 'true';
    const movimientoReducido = respetarMovimiento && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (respetarMovimiento) {
      seccion.setAttribute('data-respetar-movimiento', 'true');
    }

    let temporizadorAutoplay = null;
    let pausado = false;

    const distanciaScroll = () => {
      const primera = tarjetas[0];
      if (!primera) return pista.clientWidth;
      const estilos = window.getComputedStyle(pista);
      const gap = parseFloat(estilos.columnGap || estilos.gap || '0') || 0;
      return primera.offsetWidth + gap;
    };

    const indiceActivo = () => {
      const distancia = distanciaScroll();
      if (!distancia) return 0;
      return Math.round(pista.scrollLeft / distancia);
    };

    const actualizarControles = () => {
      const indice = indiceActivo();
      const maxIndice = Math.max(0, tarjetas.length - 1);

      if (btnAnterior) btnAnterior.disabled = pista.scrollLeft <= 4;
      if (btnSiguiente) {
        btnSiguiente.disabled = pista.scrollLeft + pista.clientWidth >= pista.scrollWidth - 4;
      }

      if (indicadoresContenedor) {
        indicadoresContenedor.querySelectorAll('[data-testimonios-inicio-indicador]').forEach((boton, i) => {
          const activo = i === indice;
          boton.classList.toggle('testimonios-inicio__indicador--activo', activo);
          boton.setAttribute('aria-selected', activo ? 'true' : 'false');
        });
      }
    };

    const desplazar = (direccion) => {
      pista.scrollBy({ left: direccion * distanciaScroll(), behavior: movimientoReducido ? 'auto' : 'smooth' });
    };

    const irAIndice = (indice) => {
      pista.scrollTo({ left: indice * distanciaScroll(), behavior: movimientoReducido ? 'auto' : 'smooth' });
    };

    const detenerAutoplay = () => {
      window.clearInterval(temporizadorAutoplay);
      temporizadorAutoplay = null;
    };

    const iniciarAutoplay = () => {
      detenerAutoplay();
      if (!autoplay || movimientoReducido || tarjetas.length <= 1 || pausado) return;

      temporizadorAutoplay = window.setInterval(() => {
        const indice = indiceActivo();
        const siguiente = indice >= tarjetas.length - 1 ? 0 : indice + 1;
        irAIndice(siguiente);
      }, intervaloMs);
    };

    if (indicadoresContenedor && tarjetas.length > 1) {
      tarjetas.forEach((_, i) => {
        const boton = document.createElement('button');
        boton.type = 'button';
        boton.className = 'testimonios-inicio__indicador';
        boton.setAttribute('data-testimonios-inicio-indicador', '');
        boton.setAttribute('role', 'tab');
        boton.setAttribute('aria-label', `Testimonio ${i + 1}`);
        boton.addEventListener('click', () => irAIndice(i));
        indicadoresContenedor.appendChild(boton);
      });
    }

    btnAnterior?.addEventListener('click', () => desplazar(-1));
    btnSiguiente?.addEventListener('click', () => desplazar(1));

    pista.addEventListener('scroll', actualizarControles, { passive: true });
    window.addEventListener('resize', actualizarControles, { passive: true });

    if (pausarHover) {
      seccion.addEventListener('mouseenter', () => {
        pausado = true;
        detenerAutoplay();
      });
      seccion.addEventListener('mouseleave', () => {
        pausado = false;
        iniciarAutoplay();
      });
      seccion.addEventListener('focusin', detenerAutoplay);
      seccion.addEventListener('focusout', iniciarAutoplay);
    }

    pista.addEventListener('keydown', (evento) => {
      if (evento.key === 'ArrowLeft') {
        evento.preventDefault();
        desplazar(-1);
      }
      if (evento.key === 'ArrowRight') {
        evento.preventDefault();
        desplazar(1);
      }
    });

    actualizarControles();
    iniciarAutoplay();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tiles-categorias"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const seccion = document.querySelector('[data-tiles-categorias]');
    if (!seccion) return;

    const pista = seccion.querySelector('[data-tiles-categorias-pista]');
    const btnAnterior = seccion.querySelector('[data-tiles-categorias-anterior]');
    const btnSiguiente = seccion.querySelector('[data-tiles-categorias-siguiente]');

    if (!pista) return;

    const desplazar = function (direccion) {
      const ancho = pista.clientWidth;
      if (!ancho) return;
      pista.scrollBy({ left: direccion * ancho * 0.85, behavior: 'smooth' });
    };

    if (btnAnterior) {
      btnAnterior.addEventListener('click', function () {
        desplazar(-1);
      });
    }

    if (btnSiguiente) {
      btnSiguiente.addEventListener('click', function () {
        desplazar(1);
      });
    }

    pista.addEventListener('keydown', function (evento) {
      if (evento.key === 'ArrowLeft') {
        evento.preventDefault();
        desplazar(-1);
      }

      if (evento.key === 'ArrowRight') {
        evento.preventDefault();
        desplazar(1);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["toast-carrito"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const toast = document.querySelector('[data-toast-carrito]');
    if (!toast) return;

    const panel = toast.querySelector('[data-toast-carrito-panel]');
    const media = toast.querySelector('[data-toast-carrito-media]');
    const imagen = toast.querySelector('[data-toast-carrito-imagen]');
    const mensaje = toast.querySelector('[data-toast-carrito-mensaje]');
    const verCarrito = toast.querySelector('[data-toast-carrito-ver-carrito]');
    const cerrar = toast.querySelector('[data-toast-carrito-cerrar]');

    const duracionMs = Number(toast.dataset.duracion || 4000);
    const textoGenerico = toast.dataset.textoGenerico || '';
    const textoConProducto = toast.dataset.textoConProducto || '';
    const abrirDrawerAlVer = toast.dataset.abrirDrawerAlVer === 'true';
    const mostrarImagen = toast.dataset.mostrarImagen === 'true';

    let temporizador = null;
    let ultimoEnlace = '';

    function ocultarToast() {
      toast.removeAttribute('data-visible');
      window.clearTimeout(temporizador);
      temporizador = window.setTimeout(() => {
        toast.hidden = true;
      }, 280);
    }

    function mostrarToast(detalle) {
      if (!detalle || typeof detalle.itemCount !== 'number') return;

      const producto = detalle.producto || {};
      const titulo = producto.titulo || '';
      const imagenUrl = producto.imagen || '';
      ultimoEnlace = producto.url || '';

      if (titulo && textoConProducto) {
        mensaje.textContent = textoConProducto.replace('[[producto]]', titulo);
      } else {
        mensaje.textContent = textoGenerico.replace('[[count]]', String(detalle.itemCount));
      }

      if (mostrarImagen && imagenUrl) {
        media.hidden = false;
        imagen.src = imagenUrl;
        imagen.alt = titulo;
      } else {
        media.hidden = true;
        imagen.removeAttribute('src');
        imagen.alt = '';
      }

      if (verCarrito) verCarrito.hidden = false;

      toast.hidden = false;
      requestAnimationFrame(() => {
        toast.setAttribute('data-visible', '');
      });

      window.clearTimeout(temporizador);
      temporizador = window.setTimeout(ocultarToast, Math.max(1500, duracionMs));
    }

    document.addEventListener('cart:updated', (evento) => {
      if (!evento.detail?.mostrarToast) return;
      mostrarToast(evento.detail);
    });

    cerrar?.addEventListener('click', ocultarToast);

    verCarrito?.addEventListener('click', () => {
      ocultarToast();
      if (abrirDrawerAlVer) {
        document.dispatchEvent(new CustomEvent('cabecera:abrir-carrito'));
        return;
      }
      if (ultimoEnlace) {
        window.location.href = ultimoEnlace;
      }
    });

    document.addEventListener('keydown', (evento) => {
      if (evento.key === 'Escape' && toast.hasAttribute('data-visible')) {
        ocultarToast();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["volver-arriba"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const boton = document.querySelector('[data-volver-arriba]');
    if (!boton) return;

    if (boton.dataset.mostrarTexto === 'true') {
      boton.classList.add('volver-arriba--con-texto');
    }

    const umbral = Number(boton.dataset.umbral) || 400;
    const respetarMovimiento = boton.dataset.respetarMovimiento === 'true';
    const sinAnimacion =
      respetarMovimiento && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    let visible = false;

    const actualizarVisibilidad = () => {
      const debeMostrar = window.scrollY > umbral;
      if (debeMostrar === visible) return;
      visible = debeMostrar;
      if (visible) {
        boton.hidden = false;
        boton.dataset.visible = 'true';
      } else {
        delete boton.dataset.visible;
        window.setTimeout(() => {
          if (!visible) boton.hidden = true;
        }, 220);
      }
    };

    const volverArriba = () => {
      window.scrollTo({
        top: 0,
        behavior: sinAnimacion ? 'auto' : 'smooth'
      });
      boton.focus({ preventScroll: true });
    };

    boton.addEventListener('click', volverArriba);

    window.addEventListener(
      'scroll',
      () => {
        window.requestAnimationFrame(actualizarVisibilidad);
      },
      { passive: true }
    );

    actualizarVisibilidad();
  })();

  } catch(e) { console.error(e); }
})();
})();
